import image1 from "../../images/products/frame1.png";
// Biochemistry
import magnaGrey from "../AllDatas/greyImages/Turbochem Magna.webp";
import magna1 from "../AllDatas/ProductImages/Biochemistry/MAGNA/Turbochem Magna.webp";
import magna2 from "../AllDatas/ProductImages/Biochemistry/MAGNA/product2-3.webp";
import magna3 from "../AllDatas/ProductImages/Biochemistry/MAGNA/product3-1.webp";
import magna4 from "../AllDatas/ProductImages/Biochemistry/MAGNA/product4-1.webp";
// import neogrey from "../AllDatas/ProductImages/Biochemistry/greyImages/product1.webp";
import neo1 from "../AllDatas/ProductImages/Biochemistry/NEO/product1-3.webp";

import neo2 from "../AllDatas/ProductImages/Biochemistry/NEO/product2.webp";
import neo3 from "../AllDatas/ProductImages/Biochemistry/NEO/product3.webp";
import neo4 from "../AllDatas/ProductImages/Biochemistry/NEO/product4.webp";
//
import plusGrey from "../AllDatas/greyImages/plus1.png";
import plus1 from "../AllDatas/ProductImages/Biochemistry/PLUS/plus1 bg.webp";
import plus2 from "../AllDatas/ProductImages/Biochemistry/PLUS/product2-2.webp";
//turbochemprime
import primGrey from "../AllDatas/greyImages/Turbochem Prime.webp";
import prim1 from "../AllDatas/ProductImages/Biochemistry/PRIME/Turbochem Prime.webp";
import prim2 from "../AllDatas/ProductImages/Biochemistry/PRIME/product2-1.webp";
//turbochem optima

import optimagrey from "../AllDatas/greyImages/Turbochem optima.png";
import optima from "../AllDatas/ProductImages/Biochemistry/OPTIMA/Turbochem optima.webp";
//
// import chemistryCollibratorGrey from "../AllDatas/ProductImages/Biochemistry/chemistryCollibrator/Chemistry Calibrator and Chemistry Controls.jpg";
// import chemistryCollibrator from "../AllDatas/ProductImages/Biochemistry/chemistryCollibrator/Chemistry Calibrator and Chemistry Controls.webp";
//
import ichemPrimeGrey from "../AllDatas/greyImages/reagentGrey.png";
import ichemPrime from "../AllDatas/ProductImages/Biochemistry/ichemPrime/reagent.webp";
//
import identiImmunoGrey from "../AllDatas/ProductImages/Biochemistry/identiImmuno/identi Immuno Turbidimetry Reagents.webp";
import identiImmuno from "../AllDatas/ProductImages/Biochemistry/identiImmuno/identi Immuno Turbidimetry Reagents.webp";
//
import identiReagentsGrey from "../AllDatas/ProductImages/Biochemistry/identiReagents/identi.webp";
import identiReagents from "../AllDatas/ProductImages/Biochemistry/identiReagents/identi.webp";
//

import ichemMagnaGrey from "../AllDatas/greyImages/Ichem Magna.webp";
import ichemMagna1 from "../AllDatas/ProductImages/Biochemistry/ichemManga/Ichem Magna.webp";
// Clinical Microbiology
import ast1 from "../AllDatas/ProductImages/Clinical Microbiology/AST plates/product1.webp";
import astGrey from "../AllDatas/ProductImages/Clinical Microbiology/AST plates/product1.webp";
import Nephelometer1 from "../AllDatas/ProductImages/Clinical Microbiology/Nephelometer/product1.webp";
import Automated1 from "../AllDatas/ProductImages/Clinical Microbiology/Automated Inoculation/product1.webp";
import manual1 from "../AllDatas/ProductImages/Clinical Microbiology/Manual Viewbox/product1.webp";
import Digital1 from "../AllDatas/ProductImages/Clinical Microbiology/Digital MIC/product1.webp";
import Fluorometric1 from "../AllDatas/ProductImages/Clinical Microbiology/Fluorometric Plate/product1.webp";
import System1 from "../AllDatas/ProductImages/Clinical Microbiology/System for AST/product1.webp";
//covid
import ANTIBODY1 from "../AllDatas/ProductImages/Covid/ANTIBODY TESTING/product1.jpg";
import Affinity1 from "../AllDatas/ProductImages/Covid/Affinity RNA/product1.jpg";
import REACTIVE1 from "../AllDatas/ProductImages/Covid/C-REACTIVE/product1.jpg";
import FERRITI1 from "../AllDatas/ProductImages/Covid/FERRITIN/product1.jpg";
import LACTAT1 from "../AllDatas/ProductImages/Covid/LACTATE/product1.jpg";
import PROCALCITONIN1 from "../AllDatas/ProductImages/Covid/PROCALCITONIN/product1.jpg";
import identi1 from "../AllDatas/ProductImages/Covid/identi VTM/product1.jpg";
// Electrolyte Analyzer
import JokohExDGrey from "../AllDatas/greyImages/Jokoh Ex-D.webp";
import JokohExDsGrey from "../AllDatas/greyImages/Jokoh Ex-Ds.webp";
import JokohExDs from "../AllDatas/ProductImages/Electrolyte Analyzer/Jokoh Ex-Ds/Jokoh Ex-Ds.webp";
import Jokoh1 from "../AllDatas/ProductImages/Electrolyte Analyzer/JokohEx-D/Jokoh Ex-D.webp";
import Jokoh2 from "../AllDatas/ProductImages/Electrolyte Analyzer/JokohEx-D/product2.webp";
import Jokoh3 from "../AllDatas/ProductImages/Electrolyte Analyzer/JokohEx-D/product3.webp";
// Hematology

import DYNACOUNT3DPlus from "../AllDatas/ProductImages/Hematology/3D PLUS/Dynacount 3D Plus.webp";
import DYNACOUNT3DPlusGrey from "../AllDatas/ProductImages/Hematology/3D PLUS/Dynacount 3D Plus.jpg";
//
import DYNACOUNT5DElitegrey from "../AllDatas/greyImages/Dynacount 5D Elite.webp";
import DYNACOUNT5DElite from "../AllDatas/ProductImages/Hematology/DYNACOUNT5D/Dynacount 5D Elite.webp";
import DYNACOUNT5DElitefront from "../AllDatas/ProductImages/Hematology/DYNACOUNT5D/Dynacount5dElitefront.webp";
import DYNACOUNT5DEliteright from "../AllDatas/ProductImages/Hematology/DYNACOUNT5D/Dynacount5dEliteright.webp";
//
import DYNACOUNT5DPROgrey from "../AllDatas/greyImages/Dynacount 5D PRO.png";
import DYNACOUNT5DPRO from "../AllDatas/ProductImages/Hematology/DYNACOUNT5D/Dynacount 5D PRO.png";
import DYNACOUNT5DFront from "../AllDatas/ProductImages/Hematology/DYNACOUNT5D/dynacount5dproFrontView.webp";
import DYNACOUNT5DRight from "../AllDatas/ProductImages/Hematology/DYNACOUNT5D/dynacount5dproright.webp";
import DYNACOUNT5DFrontView from "../AllDatas/ProductImages/Hematology/DYNACOUNT5D/dynacount5dproFrontViewN.webp";
//
import VisionGrey from "../AllDatas/greyImages/vision-pro.jpg";
import Vision1 from "../AllDatas/ProductImages/Hematology/VisionPro/vison.webp";
import Vision2 from "../AllDatas/ProductImages/Hematology/VisionPro/vison.webp";
//
import DYNACOUNT3D1 from "../AllDatas/ProductImages/Hematology/DYNACOUNT 3D/Dynacount 3D Plus-2.webp";
import DYNACOUNT3DGrey from "../AllDatas/greyImages/Dynacount 3D.webp";
//
import DYNACOUNT5Dgrey from "../AllDatas/greyImages/Dynacount 5D.webp";
import DYNACOUNT5D1 from "../AllDatas/ProductImages/Hematology/DYNACOUNT5D/Dynacount 5D.webp";

//
import SedrateProGrey from "../AllDatas/greyImages/Sedrate Pro.jpg";
import SedratePro1 from "../AllDatas/ProductImages/Hematology/SedratePro/product1-1.webp";
import SedratePro2 from "../AllDatas/ProductImages/Hematology/SedratePro/product1-3.webp";
import SedratePro3 from "../AllDatas/ProductImages/Hematology/SedratePro/product1-4.webp";
// Immunology;
import EuroblotoneGrey from "../AllDatas/greyImages/Euroblotone.webp";
import Euroblotone from "../AllDatas/ProductImages/Immunology/Euroblotone/product1.webp";
//
import EuroimmunGrey from "../AllDatas/ProductImages/Immunology/Euroimmun/Euroimmun Analyzer I-2P.webp";
import Euroimmun from "../AllDatas/ProductImages/Immunology/Euroimmun/product1-9.webp";
//
import EuroStarGrey from "../AllDatas/greyImages/Eurostar III Plus.webp";
import EuroStar from "../AllDatas/ProductImages/Immunology/EuroStar/product1-2.webp";
//
import Iflash1200Grey from "../AllDatas/greyImages/Iflash 1200.webp";
import Iflash12001 from "../AllDatas/ProductImages/Immunology/Iflash1200/product1-3.webp";
import Iflash12002 from "../AllDatas/ProductImages/Immunology/Iflash1200/product1-4.webp";
import Iflash12003 from "../AllDatas/ProductImages/Immunology/Iflash1200/product1-5.webp";
import Iflash12004 from "../AllDatas/ProductImages/Immunology/Iflash1200/product1-6.webp";
import Iflash12005 from "../AllDatas/ProductImages/Immunology/Iflash1200/product1-7.webp";
//
import Iflash1800Grey from "../AllDatas/greyImages/Iflash 1800.webp";
import Iflash18001 from "../AllDatas/ProductImages/Immunology/Iflash1800/iflash 1800.webp";
import Iflash18002 from "../AllDatas/ProductImages/Immunology/Iflash1800/iflash 1800-1.webp";
import Iflash18003 from "../AllDatas/ProductImages/Immunology/Iflash1800/iflash 1800-2.webp";
import Iflash18004 from "../AllDatas/ProductImages/Immunology/Iflash1800/iflash 1800-3.webp";
import Iflash18005 from "../AllDatas/ProductImages/Immunology/Iflash1800/iflash 1800-4.webp";
//
import Iflash3000Grey from "../AllDatas/greyImages/Iflash 3000.webp";
import Iflash30001 from "../AllDatas/ProductImages/Immunology/Iflash3000/iflash 3000.webp";
import Iflash30002 from "../AllDatas/ProductImages/Immunology/Iflash3000/iflash 3000-1.webp";
import Iflash30003 from "../AllDatas/ProductImages/Immunology/Iflash3000/iflash 3000-2.webp";
import Iflash30004 from "../AllDatas/ProductImages/Immunology/Iflash3000/iflash 3000-3.webp";
//
import IfSprinterGrey from "../AllDatas/greyImages/If Sprinter.webp";
import IfSprinter from "../AllDatas/ProductImages/Immunology/IfSprinter/if.webp";
//
import KryptorGrey from "../AllDatas/greyImages/Kryptor Compact Plus.webp";
import Kryptor1 from "../AllDatas/ProductImages/Immunology/Kryptor/if-1.webp";
import Kryptor2 from "../AllDatas/ProductImages/Immunology/Kryptor/if-2.webp";
import Kryptor3 from "../AllDatas/ProductImages/Immunology/Kryptor/if-3.webp";
//
import PlexMAT4Grey from "../AllDatas/greyImages/PlexMAT4.webp";
import PlexMAT4 from "../AllDatas/ProductImages/Immunology/Plexmat4/Plexmat 4.webp";
//
import PlexMAT8Grey from "../AllDatas/greyImages/PlexMAT8.webp";
import PlexMAT8 from "../AllDatas/ProductImages/Immunology/Plexmat8/PlexMAT8.webp";
//
import brahmsGrey from "../AllDatas/ProductImages/Immunology/brahms/B·R·A·H·M·S.webp";
import brahms from "../AllDatas/ProductImages/Immunology/brahms/B·R·A·H·M·S.webp";
//
import euroimmunAnalyzerI from "../AllDatas/ProductImages/Immunology/euroimmunAnalyzer I/product1-1.webp";
import euroimmunAnalyzerIGrey from "../AllDatas/greyImages/Euroimmun Analyzer I.webp";
//
import euroPatternGrey from "../AllDatas/greyImages/Europattern Microscope.webp";
import euroPattern from "../AllDatas/ProductImages/Immunology/euroPattern/product1-8.webp";
//
import fluoroMatGrey from "../AllDatas/greyImages/Fluoromat 50.webp";
import fluoroMat from "../AllDatas/ProductImages/Immunology/fluoroMat/flouromat50.webp";
//
import afiasgrey1 from "../AllDatas/greyImages/AFIAS 1.png";
import afiaswhite1 from "../AllDatas/ProductImages/Immunology/afias/afias1/Afias 1 lft.webp";
import afiaswhite2 from "../AllDatas/ProductImages/Immunology/afias/afias1/Afias 1 rt.webp";
import afiaswhite3 from "../AllDatas/ProductImages/Immunology/afias/afias1/Afias 1.webp";
//
import afias3grey1 from "../AllDatas/greyImages/AFIAS 3-1.png";
import afias3white1 from "../AllDatas/ProductImages/Immunology/afias/afias3/AFIAS 3.webp";
import afias3white2 from "../AllDatas/ProductImages/Immunology/afias/afias3/AFIAS 3-1.webp";
import afias3white3 from "../AllDatas/ProductImages/Immunology/afias/afias3/AFIAS 3-2.webp";
//
import afias6grey1 from "../AllDatas/greyImages/AFIAS 6-1.png";
import afias6white1 from "../AllDatas/ProductImages/Immunology/afias/afias6/AFIAS 6.webp";
import afias6white2 from "../AllDatas/ProductImages/Immunology/afias/afias6/AFIAS 6-1.webp";
import afias6white3 from "../AllDatas/ProductImages/Immunology/afias/afias6/AFIAS 6-2.webp";
//
import afias10grey1 from "../AllDatas/greyImages/AFIAS 10.png";
import afias10white1 from "../AllDatas/ProductImages/Immunology/afias/afias10/AFIAS 10.webp";
import afias10white2 from "../AllDatas/ProductImages/Immunology/afias/afias10/AFIAS 10-1.webp";
import afias10white3 from "../AllDatas/ProductImages/Immunology/afias/afias10/AFIAS 10-2.webp";

// import sprinter from "../AllDatas/greyImages/";
import sprinterGrey from "../AllDatas/ProductImages/Immunology/sprinter/Sprinter XL.webp";
import sprinter from "../AllDatas/ProductImages/Immunology/sprinter/Sprinter XL.webp";
//
// Molecular Diagnostics
import labscan3DGrey from "../AllDatas/ProductImages/Molecular Diagnostics/Labscan 3D/Labscan 3D.jpg";
import labscan3D from "../AllDatas/ProductImages/Molecular Diagnostics/Labscan 3D/Labscan 3D.webp";
//
import labscan100Grey from "../AllDatas/ProductImages/Molecular Diagnostics/Labscan 100/Labscan 100.jpg";
import labscan100 from "../AllDatas/ProductImages/Molecular Diagnostics/Labscan 100/Labscan 100.webp";

// Point of Care
import ichromaIIGrey from "../AllDatas/greyImages/Ichroma™ II.webp";
import ichromaII from "../AllDatas/ProductImages/Point of Care/ichroma™ II/product1.webp";
//
import ichromaIIIGrey from "../AllDatas/greyImages/Ichroma™ III.webp";
import ichromaIII from "../AllDatas/ProductImages/Point of Care/ichroma™ III/product1.webp";

// Pre-Analytical Automation
import PreAnalyticalGrey from "../AllDatas/ProductImages/Pre-Analytical Automation/Sortpro Sample Sorter.jpg";
import PreAnalytical from "../AllDatas/ProductImages/Pre-Analytical Automation/product1.webp";

const products = [
  {
    category: "Biochemistry",
    categoryURL: 'biochemistry-analyzer',
    subsection: ["Fully Automatic", "semi Automatic", "Reagents"],
    about: [
      {
        all: "The Biochemistry category includes products and information related to the chemical processes and substances that occur within living organisms. This category encompasses diagnostic tools, reagents, and equipment used for biochemical analyses, such as enzyme assays, metabolite detection, and protein characterization. These products are essential for understanding the molecular mechanisms of diseases and developing effective treatments.",
      },
      { "fully-automatic": " content about fullyautomatic" },
      { "semi-automatic": " content about semiautomatic" },
      { reagents: " content about reagents" },
    ],
    items: [
      {
        category: "Biochemistry",
        categoryURL: 'biochemistry-analyzer',
        section: "fully-automatic",
        allover: "This is for fully automatic",
        id: "1",
        slug: 'turbochem-magna',
        coverImg: magnaGrey,
        image: [
          { src: magna1, alt: "Sedrate Pro ESR analyzer - front view" },
          { src: magna2, alt: "Sedrate Pro ESR analyzer - side view" },
          { src: magna3, alt: "Sedrate Pro ESR analyzer - close-up controls" },
          { src: magna4, alt: "Sedrate Pro ESR analyzer - close-up controls" },
        ],
        title: "TURBOCHEM MAGNA",
        shortdescription:
          "The Turbochem Magna is a fully automated biochemistry analyzer tailored for medium to large laboratories. With its advanced technology, it ensures high throughput and precision, making it ideal for comprehensive biochemical testing.",
        description:
          "The Turbochem Magna is a high-performance, fully automated biochemistry analyzer designed for medium to large laboratories. It offers advanced technology for precise and efficient diagnostic testing.",
        workPrinciple: (
          <div>
            {/* Working Principle Table */}
            <table className="min-w-full table-auto">
              <tbody className="flex flex-col gap-4">
                <tr>
                  <td className="  text-black">
                    <strong className="text-xs tablet:text-sm font-semibold largeLaptop:text-lg ">
                      <span className="text-sm">How it Works:</span>
                    </strong>{" "}
                    <span className="text-sm">The analyzer employs photometric technology to measure the
                      intensity of light absorbed by samples, providing accurate
                      biochemical measurements.</span>
                  </td>
                </tr>
                <tr>
                  <td className="  text-black">
                    <strong className="text-xs tablet:text-sm font-semibold largeLaptop:text-lg ">
                      <span className="text-sm"> For Whom:</span>
                    </strong>{" "}
                    <span className="text-sm"> Designed for large hospitals and diagnostic centers
                      requiring extensive test menus.</span>
                  </td>
                </tr>
                <tr>
                  <td className="  text-black">
                    <strong className="text-xs tablet:text-sm font-semibold largeLaptop:text-lg ">
                      <span className="text-sm"> Use Cases:</span>
                    </strong>{" "}
                    <span className="text-sm"> Performs a variety of tests including liver function, kidney
                      function, lipid profiles, and more.</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div >
        ),

        advantages: (
          <div>
            <ul className="space-y-6 font-poppins">
              <li className="flex gap-3">
                <p className=" largeLaptop:text-lg text-xs tablet:text-sm text-black  text-wrap">
                  {" "}
                  <span className="text-[#10b981]">◆</span> High precision and
                  reliability
                </p>
              </li>
              <li className="flex gap-3">
                <p className=" largeLaptop:text-lg text-xs tablet:text-sm text-black  text-wrap">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Extensive test menu
                  for diverse diagnostics
                </p>
              </li>
              <li className="flex gap-3">
                <p className=" largeLaptop:text-lg text-xs tablet:text-sm text-black  text-wrap">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Capable of handling
                  high sample volumes efficiently
                </p>
              </li>
            </ul>
          </div>
        ),
        benefits: (
          <div>
            <ul className="space-y-6 font-poppins">
              <li className="flex gap-3">
                <p className=" largeLaptop:text-lg text-xs tablet:text-sm text-black  text-wrap">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Reduces turnaround
                  time for test results
                </p>
              </li>
              <li className="flex gap-3">
                <p className=" largeLaptop:text-lg text-xs tablet:text-sm text-black  text-wrap">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Enhances diagnostic
                  efficiency and patient care
                </p>
              </li>
              <li className="flex gap-3">
                <p className=" largeLaptop:text-lg text-xs tablet:text-sm text-black  text-wrap">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Supports a wide
                  range of biochemical assays
                </p>
              </li>
            </ul>
          </div>
        ),
        testMenu: [""],
        mainAndCare: (
          <div>
            <ul className="space-y-6">
              <li className="flex gap-3">
                <p className=" largeLaptop:text-lg text-xs tablet:text-sm text-black  text-wrap">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Regular calibration
                  and quality control checks
                </p>
              </li>
              <li className="flex gap-3">
                <p className=" largeLaptop:text-lg text-xs tablet:text-sm text-black  text-wrap">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Routine cleaning of
                  cuvettes and probes to ensure accurate readings
                </p>
              </li>
              <li className="flex gap-3">
                <p className=" largeLaptop:text-lg text-xs tablet:text-sm text-black  text-wrap">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Scheduled
                  maintenance to prolong the lifespan of the analyzer
                </p>
              </li>
            </ul>
          </div>
        ),
        workServices: "Available technical support and service packages.",
        productBrochure: "path/to/turbochem-magna-brochure.pdf",
        detailedSpecification:
          "Detailed technical specifications available upon request.",
        offerOrDiscounts:
          "Check with the distributor for current offers and discounts.",
      },
      {
        allover: "This is for fully automatic",
        id: "2",
        slug: 'turbochem-prime',
        section: "fully-automatic",
        coverImg: primGrey,

        image: [
          { src: prim1, alt: "Sedrate Pro ESR analyzer - front view" },
          { src: prim2, alt: "Sedrate Pro ESR analyzer - side view" },
        ],
        title: "TURBOCHEM PRIME",
        shortdescription:
          "The Turbochem Prime is a fully automatic biochemistry analyzer, perfect for small to medium-sized laboratories. It offers a balance of efficiency, ease of use, and cost-effectiveness.",
        description:
          "The Turbochem Prime is a fully automatic biochemistry analyzer ideal for small to medium-sized laboratories, providing a blend of efficiency, reliability, and ease of use.",
        workPrinciple: (
          <div>
            {/* Working Principle Table */}
            <table className="min-w-full table-auto">
              <tbody className="flex flex-col gap-4">
                <tr>
                  <td className="  text-black">
                    <strong className="text-xs tablet:text-sm font-semibold largeLaptop:text-lg ">
                      How it Works:
                    </strong>{" "}
                    <span className="text-sm">The analyzer employs photometric technology to measure the
                      intensity of light absorbed by samples, providing accurate
                      biochemical measurements.</span>
                  </td>
                </tr>
                <tr>
                  <td className="  text-black">
                    <strong className="text-xs tablet:text-sm font-semibold largeLaptop:text-lg ">
                      For Whom:
                    </strong>{" "}
                    <span className="text-sm">Designed for large hospitals and diagnostic centers
                      requiring extensive test menus.</span>
                  </td>
                </tr>
                <tr>
                  <td className="  text-black">
                    <strong className="text-xs tablet:text-sm font-semibold largeLaptop:text-lg ">
                      Use Cases:
                    </strong>{" "}
                    <span className="text-sm">Performs a variety of tests including liver function, kidney
                      function, lipid profiles, and more.</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        ),

        advantages: (
          <div>
            <ul className="space-y-6 font-poppins">
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> User-friendly
                  interface with intuitive controls
                </p>
              </li>
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Compact design that
                  saves space
                </p>
              </li>
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Reliable performance
                  with minimal operational complexity
                </p>
              </li>
            </ul>
          </div>
        ),
        benefits: (
          <div>
            <ul className="space-y-6 font-poppins">
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Simplifies
                  laboratory workflows
                </p>
              </li>
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Enhances accuracy
                  and speed of diagnostics
                </p>
              </li>
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Cost-effective
                  solution for comprehensive biochemistry testing
                </p>
              </li>
            </ul>
          </div>
        ),
        testMenu: [""],
        mainAndCare: (
          <div>
            <ul className="space-y-6 font-poppins">
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Periodic software
                  updates to maintain functionality
                </p>
              </li>
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Regular cleaning and
                  maintenance of analytical components
                </p>
              </li>
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Proper storage of
                  reagents to ensure test accuracy
                </p>
              </li>
            </ul>
          </div>
        ),
        workServices: "Comprehensive service options available.",
        productBrochure: "path/to/turbochem-prime-brochure.pdf",
        detailedSpecification:
          "In-depth specifications can be provided on request.",
        offerOrDiscounts: "Contact sales for the latest promotions.",
      },
      {
        allover: "This is for fully automatic",
        id: "8",
        slug: 'turbochem-optima',
        section: "fully-automatic",
        coverImg: optimagrey,
        image: [
          { src: optima, alt: "Turbochem Optima fully automatic biochemistry analyzer with display panel" },
        ],

        title: "TURBOCHEM OPTIMA",
        shortdescription:
          "The Turbochem Optima is a high-performance, fully automated biochemistry analyzer designed for medium to large laboratories. It offers advanced technology for precise and efficient diagnostic testing.",
        description:
          "The Turbochem Optima is a fully automated biochemistry analyzer tailored for large laboratories. With its advanced technology, it ensures high throughput and precision, making it ideal for comprehensive biochemical testing. ",
        workPrinciple: (
          <div>
            {/* Working Principle Table */}
            <table className="min-w-full table-auto">
              <tbody className="flex flex-col gap-4">
                <tr>
                  <td className="  text-black">
                    <strong className="text-xs tablet:text-sm font-semibold largeLaptop:text-lg ">
                      <span className="text-sm">How it Works:</span>
                    </strong>{" "}
                    <span className="text-sm">The analyzer employs a grating system to measure the intensity of light absorbed by samples, providing accurate biochemical measurements.</span>
                  </td>
                </tr>
                <tr>
                  <td className="  text-black">
                    <strong className="text-xs tablet:text-sm font-semibold largeLaptop:text-lg ">
                      <span className="text-sm">For Whom:</span>
                    </strong>{" "}
                    <span className="text-sm">Designed for large hospitals and diagnostic centers requiring extensive test menus.</span>
                  </td>
                </tr>
                <tr>
                  <td className="  text-black">
                    <strong className="text-xs tablet:text-sm font-semibold largeLaptop:text-lg ">
                      <span className="text-sm">Use Cases:</span>
                    </strong>{" "}
                    <span className="text-sm">Performs a variety of tests, including liver function, kidney function, lipid profiles, and more.</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        ),

        advantages: (
          <div>
            <ul className="space-y-6 font-poppins">
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> High precision and reliability
                </p>
              </li>
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Wide range of biochemistry and immunoturbidimetry parameters
                </p>
              </li>
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Capable of handling high sample volumes efficiently.
                </p>
              </li>
            </ul>
          </div>
        ),
        benefits: (
          <div>
            <ul className="space-y-6 font-poppins">
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Reduces turnaround time for test results
                </p>
              </li>
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Enhances diagnostic efficiency and patient care
                </p>
              </li>
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Supports a wide range of biochemical assays
                </p>
              </li>
            </ul>
          </div>
        ),
        testMenu: [""],
        mainAndCare: (
          <div>
            <ul className="space-y-6 font-poppins">
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Regular calibration and quality control checks
                </p>
              </li>
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Routine cleaning of cuvettes and probes to ensure accurate readings
                </p>
              </li>
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Scheduled maintenance to prolong the lifespan of the analyzer
                </p>
              </li>
            </ul>
          </div>
        ),
        workServices: "Comprehensive service options available.",
        productBrochure: "path/to/turbochem-prime-brochure.pdf",
        detailedSpecification:
          "In-depth specifications can be provided on request.",
        offerOrDiscounts: "Contact sales for the latest promotions.",
      },
      // neo
      // {
      //   allover: "This is for fully automatic",
      //   id: "3",
      //   image: [plus1, plus2],
      //   title: "Turbochem Neo",
      //   section: "fullyautomatic",
      //   shortdescription: "TURBOCHEM NEO FULLY AUTOMATIC BIOCHEMISTRY ANALYZER",
      //   description:
      //     "Ideal for performing basic metabolic panels, liver function tests, and more with reliable outcomes.",
      //   workPrinciple:
      //     "Utilizes precise measurement techniques for various biochemical tests.",
      //   advantages: "Reliable performance with minimal manual intervention.",
      //   benefits: "Enhances testing accuracy and efficiency.",
      //   testMenu:[''],mainAndCare: "Routine maintenance and calibration required.",
      //   workServices: "Support and service packages are available.",
      //   productBrochure: "path/to/turbochem-neo-brochure.pdf",
      //   detailedSpecification: "Specifications detailed in the product manual.",
      //   offerOrDiscounts: "Check for current discounts and offers.",
      // },
      {
        allover: "This is for Semi automatic",
        id: "4",
        slug: 'turbostat-plus',
        coverImg: plusGrey,
        image: [

          { src: plus1, alt: "Turbostat Plus semi automatic biochemistry analyzer machine front view" },
        ],


        title: "TURBOSTAT PLUS",
        section: "semi-automatic",
        shortdescription:
          "The Turbostat Plus is a semi-automated biochemistry analyzer designed for rapid and reliable biochemical testing. It ensures high accuracy and efficiency, making it suitable for diverse laboratory environments.",
        description:
          "The Turbostat Plus is a semi-automated biochemistry analyzer designed for rapid and precise biochemical testing, suitable for small to mid-sized laboratories.",
        workPrinciple: (
          <div>
            {/* Working Principle Table */}
            <table className="min-w-full table-auto">
              <tbody className="flex flex-col gap-4">
                <tr>
                  <td className="  text-black">
                    <strong className="text-xs tablet:text-sm font-semibold largeLaptop:text-lg ">
                      <span className="text-sm"> How it Works:</span>
                    </strong>{" "}
                    <span className="text-sm">Employs photometric detection to analyze biochemical
                      reactions and provide precise measurements.</span>
                  </td>
                </tr>
                <tr>
                  <td className="  text-black">
                    <strong className="text-xs tablet:text-sm font-semibold largeLaptop:text-lg ">
                      <span className="text-sm">For Whom:</span>
                    </strong>{" "}
                    <span className="text-sm">Perfect for small to mid-sized laboratories needing quick
                      turnaround times.</span>
                  </td>
                </tr>
                <tr>
                  <td className="  text-black">
                    <strong className="text-xs tablet:text-sm font-semibold largeLaptop:text-lg ">
                      <span className="text-sm">Use Cases:</span>
                    </strong>{" "}
                    <span className="text-sm">Commonly used for routine chemistry tests, specific protein
                      assays, and urgent biochemical assessments.</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        ),

        advantages: (
          <div>
            <ul className="space-y-6 font-poppins">
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Fast processing time
                  for quick results
                </p>
              </li>
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> High reliability
                  with consistent performance
                </p>
              </li>
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Versatile
                  applications across various tests
                </p>
              </li>
            </ul>
          </div>
        ),
        benefits: (
          <div>
            <ul className="space-y-6 font-poppins">
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Improves laboratory
                  productivity
                </p>
              </li>
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Provides quick and
                  accurate diagnostics
                </p>
              </li>
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Adaptable to a wide
                  range of biochemical testing needs
                </p>
              </li>
            </ul>
          </div>
        ),
        testMenu: [""],
        mainAndCare: (
          <div>
            <p className="mb-4 text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
              {" "}
              Routine maintenance of sensors and optical systems
            </p>
            <ul className="space-y-6 font-poppins ml-4">
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Ensuring proper
                  storage and handling of reagents
                </p>
              </li>
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Regular performance
                  checks to ensure ongoing accuracy
                </p>
              </li>
            </ul>
          </div>
        ),
        workServices: "Service options available upon request.",
        productBrochure: "path/to/turbostat-plus-brochure.pdf",
        detailedSpecification:
          "Detailed specs provided in the product documentation.",
        offerOrDiscounts: "Inquire about current offers from your distributor.",
      },
      {
        allover: "Reagents",
        id: "5",
        slug: 'i-chem-prime',
        coverImg: ichemPrimeGrey,
        image: [

          { src: ichemPrime, alt: "I-Chem Prime biochemistry reagent bottle used for clinical chemistry tests" },
        ],
        section: "reagents",
        title: "i-chem Prime",
        shortdescription:
          "The iChem Prime System Pack is a comprehensive solution developed for use with the TurboChem Prime analyzer. These high-quality reagents ensure precision in clinical chemistry testing, providing consistent and reliable results. Designed to meet the rigorous demands of modern diagnostic laboratories, the iChem Prime System Pack stands as a benchmark for accuracy and efficiency",
        description:
          "The iChem Prime System Pack is a sophisticated solution designed for use with the TurboChem Prime analyzer. These high-quality reagents deliver precision in clinical chemistry testing, ensuring reliable and consistent results. Engineered to meet the demanding requirements of modern diagnostic laboratories, the iChem Prime System Pack stands as a hallmark of accuracy and efficiency.",
        // workPrinciple: (
        //   <div>
        //     <table className="min-w-full table-auto">
        //       <tbody className="flex flex-col gap-4">
        //         <tr>
        //           <td className="  text-black">
        //             <strong className="text-xs tablet:text-sm font-semibold largeLaptop:text-lg ">
        //               {" "}
        //               Working Principle: How It Works? <br />
        //             </strong>
        //             The iChem Prime operates on photometric and colorimetric
        //             principles to accurately quantify analytes for precise
        //             health diagnostics. This advanced technology ensures
        //             reliable and consistent clinical chemistry results.
        //           </td>
        //         </tr>
        //         <tr>
        //           <td className="  text-black">
        //             <strong className="text-xs tablet:text-sm font-semibold largeLaptop:text-lg ">
        //               {" "}
        //               For Whom It Is Useful? <br />
        //             </strong>
        //             Ideal for clinical laboratories, diagnostic centers, and
        //             healthcare institutions requiring high-throughput and
        //             dependable biochemistry testing.
        //           </td>
        //         </tr>
        //         <tr>
        //           <td className="  text-black">
        //             <strong className="text-xs tablet:text-sm font-semibold largeLaptop:text-lg ">
        //               {" "}
        //               Use Cases:
        //             </strong>
        //             <ul className="list-disc pl-5 ">
        //               <li>
        //                 Monitoring routine biochemistry profiles like glucose,
        //                 lipids, and enzymes.
        //               </li>
        //               <li>
        //                 Managing chronic diseases such as diabetes,
        //                 cardiovascular conditions, and liver disorders.
        //               </li>
        //               <li>
        //                 Supporting urgent and critical care diagnostics for
        //                 timely patient management.
        //               </li>
        //             </ul>
        //           </td>
        //         </tr>
        //       </tbody>
        //     </table>
        //   </div>
        // ),

        advantages: (
          <div>
            <ul className="space-y-6 font-poppins">
              <li className="flex gap-3">
                <p className="text-sm largeLaptop:text-lg font-medium text-gray-800">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Guaranteed Number of
                  Tests: Ensures zero wastage by providing a fixed number of
                  tests per reagent pack.
                </p>
              </li>
              <li className="flex gap-3">
                <p className="text-sm largeLaptop:text-lg font-medium text-gray-800">
                  {" "}
                  <span className="text-[#10b981]">◆</span> On-board and
                  Calibration Stability: Maintains consistent performance during
                  use and storage.
                </p>
              </li>
            </ul>
          </div>
        ),

        benefits: (
          <div>
            <ul className="space-y-6 font-poppins">
              <li className="flex gap-3">
                <p className="text-sm largeLaptop:text-lg font-medium text-gray-800">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Easy Inventory
                  Management: Simplifies reagent tracking and replenishment.
                </p>
              </li>
              <li className="flex gap-3">
                <p className="text-sm largeLaptop:text-lg font-medium text-gray-800">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Comprehensive Test
                  Menu: Offers a wide range of biochemistry assays, including
                  Urea Kinetic, Total Protein, and Bilirubin Direct tests.
                </p>
              </li>
            </ul>
          </div>
        ),

        testMenu: [""],
        mainAndCare: (
          <div>
            <ul className="space-y-6 font-poppins">
              <li className="flex gap-3">
                <p className="text-sm largeLaptop:text-2xl font-medium text-gray-800">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Store reagents under
                  recommended conditions to maintain stability and performance.
                </p>
              </li>
              <li className="flex gap-3">
                <p className="text-sm largeLaptop:text-2xl font-medium text-gray-800">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Regularly calibrate
                  the TurboChem Prime system to ensure optimal accuracy.
                </p>
              </li>
              <li className="flex gap-3">
                <p className="text-sm largeLaptop:text-2xl font-medium text-gray-800">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Follow the
                  manufacturer’s guidelines for proper reagent handling and
                  disposal.
                </p>
              </li>
            </ul>
          </div>
        ),

        workServices: "Technical support for reagent use available.",
        productBrochure: "path/to/ichem-prime-brochure.pdf",
        detailedSpecification: "Specifications available on request.",
        offerOrDiscounts: "Check for current promotions and discounts.",
      },
      {
        allover: "Reagents",
        id: "6",
        slug: 'i-chem-magna',
        section: "reagents",
        coverImg: ichemPrimeGrey,
        image: [

          { src: ichemMagna1, alt: "I-Chem Magna biochemistry reagent bottle for laboratory chemistry analysis" },
        ],
        shortdescription:
          "The iChem Magna is a high-performance biochemical testing solution, delivering precise and reliable results for high-volume clinical laboratories.",
        title: "i-chem Magna",
        alt: "I-Chem Magna biochemistry reagent bottle for laboratory chemistry analysis",
        description:
          "The iChem Magna is an advanced biochemical testing solution designed for a wide range of diagnostic applications. With its advanced formulation, iChem Magna ensures precise and reliable results, making it a trusted choice for high-volume clinical laboratories.",
        // workPrinciple: (
        //   <div>
        //     <table className="min-w-full table-auto">
        //       <tbody className="flex flex-col gap-4">
        //         <tr>
        //           <td className="  text-black">
        //             <strong className="text-xs tablet:text-sm font-semibold largeLaptop:text-lg ">
        //               {" "}
        //               How It Works? <br />
        //             </strong>
        //             iChem Magna operates on enzymatic and photometric reactions
        //             to measure biochemical parameters with high efficiency and
        //             accuracy.
        //           </td>
        //         </tr>
        //         <tr>
        //           <td className="  text-black">
        //             <strong className="text-xs tablet:text-sm font-semibold largeLaptop:text-lg ">
        //               {" "}
        //               For Whom It Is Useful? <br />
        //             </strong>
        //             Designed for laboratories requiring high-throughput
        //             solutions for routine and specialized biochemistry tests.
        //           </td>
        //         </tr>
        //         <tr>
        //           <td className="  text-black">
        //             <strong className="text-xs tablet:text-sm font-semibold largeLaptop:text-lg ">
        //               {" "}
        //               Use Cases:
        //             </strong>
        //             <ul className="list-disc pl-5 ">
        //               <li>
        //                 Routine health check-ups to assess organ function.
        //               </li>
        //               <li>Diagnosing and monitoring chronic diseases.</li>
        //               <li>
        //                 Research applications in biochemistry and clinical
        //                 studies.
        //               </li>
        //             </ul>
        //           </td>
        //         </tr>
        //       </tbody>
        //     </table>
        //   </div>
        // ),

        advantages: (
          <div>
            <ul className="space-y-6 font-poppins">
              <li className="flex gap-3">
                <p className="text-sm largeLaptop:text-2xl font-medium text-gray-800">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Enhanced accuracy
                  and reliability in biochemical testing.
                </p>
              </li>
              <li className="flex gap-3">
                <p className="text-sm largeLaptop:text-2xl font-medium text-gray-800">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Increased on-board
                  stability and linearity across a wide range of concentrations.
                </p>
              </li>
            </ul>
          </div>
        ),

        benefits: (
          <div>
            <ul className="space-y-6 font-poppins">
              <li className="flex gap-3">
                <p className="text-sm largeLaptop:text-2xl font-medium text-gray-800">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Guaranteed number of
                  tests per reagent pack ensures zero wastage.
                </p>
              </li>
              <li className="flex gap-3">
                <p className="text-sm largeLaptop:text-2xl font-medium text-gray-800">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Delivers precise and
                  consistent results for accurate diagnostics.
                </p>
              </li>
            </ul>
          </div>
        ),

        testMenu: [""],
        mainAndCare: (
          <div>
            <ul className="space-y-6 font-poppins">
              <li className="flex gap-3">
                <p className="text-sm largeLaptop:text-2xl font-medium text-gray-800">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Store at specified
                  temperatures to maintain reagent efficacy.
                </p>
              </li>
              <li className="flex gap-3">
                <p className="text-sm largeLaptop:text-2xl font-medium text-gray-800">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Regularly inspect
                  for proper storage conditions.
                </p>
              </li>
              <li className="flex gap-3">
                <p className="text-sm largeLaptop:text-2xl font-medium text-gray-800">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Ensure proper
                  calibration of equipment for consistent performance.
                </p>
              </li>
            </ul>
          </div>
        ),
        workServices: "Customer support available for reagent-related queries.",
        productBrochure: "path/to/ichem-magna-brochure.pdf",
        detailedSpecification: "Available upon request.",
        offerOrDiscounts: "Inquire about available discounts.",
      },
      {
        allover: "Reagents",
        id: "7",
        slug: 'identi-immuno-turbidimetry',
        section: "reagents",
        coverImg: ichemPrimeGrey,
        image: [

          { src: ichemPrime, alt: "Identi Immuno Turbidimetry reagent kit for protein analysis testing" },
        ],
        shortdescription:
          "identi Immuno Turbidimetry Reagents provide precise and sensitive results for detecting critical biomarkers in immunoassay testing.",
        title: "identi Immuno Turbidimetry Reagents",
        description:
          "identi Immuno Turbidimetry Reagents are premium solutions for immunoassay testing using turbidimetric methods. These reagents are designed to deliver precise and sensitive results, enabling the detection of critical biomarkers for effective diagnosis and treatment planning.",
        workPrinciple: (
          <div>
            <table className="min-w-full table-auto">
              <tbody className="flex flex-col gap-4">
                <tr>
                  <td className="  text-black">
                    <strong className="text-xs tablet:text-sm font-semibold largeLaptop:text-lg ">
                      {" "}
                      How It Works? <br />
                    </strong>
                    <span className="text-sm">identi Immuno Turbidimetry Reagents operate on turbidimetry,
                      using antigen-antibody complexes to quantify proteins and
                      biomarkers accurately.</span>
                  </td>
                </tr>
                <tr>
                  <td className="  text-black">
                    <strong className="text-xs tablet:text-sm font-semibold largeLaptop:text-lg ">
                      {" "}
                      For Whom It Is Useful? <br />
                    </strong>
                    <span className="text-sm">Perfect for diagnostic laboratories conducting immunoassays
                      for conditions like inflammation, cardiovascular risks, and
                      autoimmune diseases.</span>
                  </td>
                </tr>
                <tr>
                  <td className="  text-black">
                    <strong className="text-xs tablet:text-sm font-semibold largeLaptop:text-lg ">
                      {" "}
                      Use Cases:
                    </strong>
                    <ul className="list-disc pl-5 ">
                      <li>
                        <span className="text-sm">Measuring proteins such as CRP, ferritin, and rheumatoid
                          factors.</span>
                      </li>
                      <li>
                        <span className="text-sm">Monitoring inflammatory and autoimmune conditions.</span>
                      </li>
                      <li>
                        <span className="text-sm">Supporting clinical research studies in immunology.</span>
                      </li>
                    </ul>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        ),

        advantages: (
          <div>
            <ul className="space-y-6 font-poppins">
              <li className="flex gap-3">
                <p className="text-sm largeLaptop:text-2xl font-medium text-gray-800">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Provides
                  high-quality turbidimetric measurements for reliable results.
                </p>
              </li>
              <li className="flex gap-3">
                <p className="text-sm largeLaptop:text-2xl font-medium text-gray-800">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Optimized for
                  automation, enhancing laboratory efficiency.
                </p>
              </li>
            </ul>
          </div>
        ),

        benefits: (
          <div>
            <ul className="space-y-6 font-poppins">
              <li className="flex gap-3">
                <p className="text-sm largeLaptop:text-2xl font-medium text-gray-800">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Offers improved
                  sensitivity and linearity for precise quantification across a
                  range of concentrations.
                </p>
              </li>
              <li className="flex gap-3">
                <p className="text-sm largeLaptop:text-2xl font-medium text-gray-800">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Includes
                  comprehensive test kits catering to diverse diagnostic needs.
                </p>
              </li>
            </ul>
          </div>
        ),

        testMenu: [""],
        mainAndCare: (
          <div>
            <ul className="space-y-6 font-poppins">
              <li className="flex gap-3">
                <p className="text-sm largeLaptop:text-2xl font-medium text-gray-800">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Follow storage and
                  handling instructions for optimal performance.
                </p>
              </li>
              <li className="flex gap-3">
                <p className="text-sm largeLaptop:text-2xl font-medium text-gray-800">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Perform routine
                  equipment maintenance to ensure precise measurements.
                </p>
              </li>
              <li className="flex gap-3">
                <p className="text-sm largeLaptop:text-2xl font-medium text-gray-800">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Dispose of reagents
                  according to regulatory guidelines.
                </p>
              </li>
            </ul>
          </div>
        ),

        workServices: "Technical assistance available.",
        productBrochure: "path/to/identi-immuno-turbidimetry-brochure.pdf",
        detailedSpecification: "Detailed specifications available on request.",
        offerOrDiscounts: "Contact distributor for current offers.",
      },
      {
        allover: "Reagents",
        id: "8",
        slug: 'identi',
        section: "reagents",
        coverImg: ichemPrimeGrey,
        image: [

          { src: ichemPrime, alt: "Identi diagnostic reagent bottles arranged for immunoassay testing" },
        ],
        title: "identi",
        shortdescription:
          "The Identi Reagents Kit offers reliable and easy-to-use solutions for accurate diagnostic testing in clinical laboratories.",
        description:
          "The Identi Reagents Kit is a versatile solution for clinical laboratories, offering a comprehensive range of reagents to facilitate accurate diagnostic testing. Its reliability and ease of use make it an indispensable tool for healthcare professionals.",
        // workPrinciple: (
        //   <div>
        //     <table className="min-w-full table-auto">
        //       <tbody className="flex flex-col gap-4">
        //         <tr>
        //           <td className="  text-black">
        //             <strong className="text-xs tablet:text-sm font-semibold largeLaptop:text-lg ">
        //               {" "}
        //               How It Works? <br />
        //             </strong>
        //             Identi Reagents Kit operates on enzymatic, photometric, and
        //             colorimetric methods to precisely quantify various analytes.
        //           </td>
        //         </tr>
        //         <tr>
        //           <td className="  text-black">
        //             <strong className="text-xs tablet:text-sm font-semibold largeLaptop:text-lg ">
        //               {" "}
        //               For Whom It Is Useful? <br />
        //             </strong>
        //             Designed for use in clinical labs performing routine and
        //             specialized tests.
        //           </td>
        //         </tr>
        //         <tr>
        //           <td className="  text-black">
        //             <strong className="text-xs tablet:text-sm font-semibold largeLaptop:text-lg ">
        //               {" "}
        //               Use Cases:
        //             </strong>
        //             <ul className="list-disc pl-5 ">
        //               <li>Conducting metabolic and organ function panels.</li>
        //               <li>Supporting chronic disease management.</li>
        //               <li>
        //                 Enhancing diagnostic precision in critical care
        //                 settings.
        //               </li>
        //             </ul>
        //           </td>
        //         </tr>
        //       </tbody>
        //     </table>
        //   </div>
        // ),

        advantages: (
          <div>
            <ul className="space-y-6 font-poppins">
              <li className="flex gap-3">
                <p className="text-sm largeLaptop:text-2xl font-medium text-gray-800">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Ready-to-use liquid
                  stable reagents simplify laboratory workflows.
                </p>
              </li>
              <li className="flex gap-3">
                <p className="text-sm largeLaptop:text-2xl font-medium text-gray-800">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Available in varied
                  pack sizes to cater to specific customer needs.
                </p>
              </li>
            </ul>
          </div>
        ),

        benefits: (
          <div>
            <ul className="space-y-6 font-poppins">
              <li className="flex gap-3">
                <p className="text-sm largeLaptop:text-2xl font-medium text-gray-800">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Manufactured to
                  international standards, ensuring reliable and accurate
                  results.
                </p>
              </li>
              <li className="flex gap-3">
                <p className="text-sm largeLaptop:text-2xl font-medium text-gray-800">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Includes
                  comprehensive test kits for diverse diagnostic requirements.
                </p>
              </li>
            </ul>
          </div>
        ),

        testMenu: [""],
        // mainAndCare: (
        //   <div>
        //     <ul className="space-y-6 font-poppins">
        //       <li className="flex gap-3">
        //         <p className="text-sm largeLaptop:text-2xl font-medium text-gray-800">
        //           {" "}
        //           <span className="text-[#10b981]">◆</span> Ensure proper
        //           storage conditions for reagent stability.
        //         </p>
        //       </li>
        //       <li className="flex gap-3">
        //         <p className="text-sm largeLaptop:text-2xl font-medium text-gray-800">
        //           {" "}
        //           <span className="text-[#10b981]">◆</span> Regular calibration
        //           of analyzers is essential for optimal results.
        //         </p>
        //       </li>
        //       <li className="flex gap-3">
        //         <p className="text-sm largeLaptop:text-2xl font-medium text-gray-800">
        //           {" "}
        //           <span className="text-[#10b981]">◆</span> Adhere to best
        //           practices for reagent preparation and disposal.
        //         </p>
        //       </li>
        //     </ul>
        //   </div>
        // ),

        workServices: "Support available for reagent use.",
        productBrochure: "path/to/identi-reagents-brochure.pdf",
        detailedSpecification: "Specifications can be provided upon request.",
        offerOrDiscounts: "Check with your distributor for promotions.",
      },
      // {
      //   allover: "Reagents",
      //   id: "9",
      //   section: "reagents",
      //   shortdescription:
      //     "The Chemistry Calibrator and Controls ensure accuracy and reliability in diagnostic testing by calibrating and validating clinical chemistry analyzers.",
      //   coverImg: chemistryCollibratorGrey,
      //   image: [chemistryCollibrator],
      //   title: "Chemistry Calibrator and Chemistry Controls",
      //   description:
      //     "The Chemistry Calibrator and Chemistry Controls are essential tools for ensuring accuracy and reliability in diagnostic testing. These solutions are designed to calibrate and validate clinical chemistry analyzers, providing confidence in test results.",
      //   workPrinciple: (
      //     <div>
      //       <table className="min-w-full table-auto">
      //         <tbody className="flex flex-col gap-4">
      //           <tr>
      //             <td className="  text-black">
      //               <strong className="text-xs tablet:text-sm font-semibold largeLaptop:text-lg ">
      //                 {" "}
      //                 How It Works? <br />
      //               </strong>
      //               Chemistry Calibrator and Chemistry Controls ensure precise
      //               diagnostics by providing reference points and verifying
      //               system performance against expected values.
      //             </td>
      //           </tr>
      //           <tr>
      //             <td className="  text-black">
      //               <strong className="text-xs tablet:text-sm font-semibold largeLaptop:text-lg ">
      //                 {" "}
      //                 For Whom It Is Useful? <br />
      //               </strong>
      //               Essential for diagnostic labs seeking high accuracy in
      //               clinical chemistry testing.
      //             </td>
      //           </tr>
      //           <tr>
      //             <td className="  text-black">
      //               <strong className="text-xs tablet:text-sm font-semibold largeLaptop:text-lg ">
      //                 {" "}
      //                 Use Cases:
      //               </strong>
      //               <ul className="list-disc pl-5 ">
      //                 <li>
      //                   Calibrating analyzers for routine biochemistry tests.
      //                 </li>
      //                 <li>Validating test accuracy and reliability.</li>
      //                 <li>Meeting regulatory compliance standards.</li>
      //               </ul>
      //             </td>
      //           </tr>
      //         </tbody>
      //       </table>
      //     </div>
      //   ),

      //   advantages: (
      //     <div>
      //       <ul className="space-y-6 font-poppins">
      //         <li className="flex gap-3">
      //           <p className="text-sm largeLaptop:text-2xl font-medium text-gray-800">
      //             {" "}
      //             <span className="text-[#10b981]">◆</span> Utilizes lyophilized
      //             human serum for enhanced stability.
      //           </p>
      //         </li>
      //         <li className="flex gap-3">
      //           <p className="text-sm largeLaptop:text-2xl font-medium text-gray-800">
      //             {" "}
      //             <span className="text-[#10b981]">◆</span> Provides extended
      //             shelf life when stored at 2°C – 8°C.
      //           </p>
      //         </li>
      //       </ul>
      //     </div>
      //   ),

      //   benefits: (
      //     <div>
      //       <ul className="space-y-6 font-poppins">
      //         <li className="flex gap-3">
      //           <p className="text-sm largeLaptop:text-2xl font-medium text-gray-800">
      //             {" "}
      //             <span className="text-[#10b981]">◆</span> Ensures consistent
      //             and accurate calibration and control for clinical chemistry
      //             tests.
      //           </p>
      //         </li>
      //         <li className="flex gap-3">
      //           <p className="text-sm largeLaptop:text-2xl font-medium text-gray-800">
      //             {" "}
      //             <span className="text-[#10b981]">◆</span> Offers flexible
      //             storage options, with reconstituted stability of up to 7 days
      //             at 2°C – 8°C or 4 weeks at -20°C.
      //           </p>
      //         </li>
      //       </ul>
      //     </div>
      //   ),

      //   testMenu: [""],
      //   mainAndCare: (
      //     <div>
      //       <ul className="space-y-6 font-poppins">
      //         <li className="flex gap-3">
      //           <p className="text-sm largeLaptop:text-2xl font-medium text-gray-800">
      //             {" "}
      //             <span className="text-[#10b981]">◆</span> Store under
      //             recommended conditions to maintain stability.
      //           </p>
      //         </li>
      //         <li className="flex gap-3">
      //           <p className="text-sm largeLaptop:text-2xl font-medium text-gray-800">
      //             {" "}
      //             <span className="text-[#10b981]">◆</span> Follow protocols for
      //             calibration and control preparation.
      //           </p>
      //         </li>
      //         <li className="flex gap-3">
      //           <p className="text-sm largeLaptop:text-2xl font-medium text-gray-800">
      //             {" "}
      //             <span className="text-[#10b981]">◆</span> Regularly review
      //             analyzer performance to detect inconsistencies.
      //           </p>
      //         </li>
      //       </ul>
      //     </div>
      //   ),

      //   workServices:
      //     "Technical support available for calibration and control.",
      //   productBrochure: "path/to/chemistry-calibrator-brochure.pdf",
      //   detailedSpecification: "Detailed information available upon request.",
      //   offerOrDiscounts: "Inquire about available discounts.",
      // },
    ],
  },
  // {
  //   category: "Clinical Microbiology",
  //   subsection: ["All", "Reagents"],
  //   items: [
  //     {
  //       topic: "CLINICAL MICROBIOLOGY LABORATORY EQUIPMENTS",
  //       id: "1",
  //       image: [ast1],
  //       section: "reagents",
  //       title: "Sensititre™ Standard Ast Plates",
  //       shortdescription: "Sensititre™ Standard Ast Plates",
  //       description:
  //         "Used for antimicrobial susceptibility testing, providing reliable and accurate results for various microbial strains.",
  //       workPrinciple:
  //         "Plates with a predefined concentration of antibiotics to test the effectiveness against microbial strains.",
  //       advantages: "Provides standardized and reproducible results.",
  //       benefits:
  //         "Helps in selecting appropriate antimicrobial agents for treatment.",
  //       testMenu:[''],mainAndCare:
  //         "Store in a cool, dry place; follow handling instructions to prevent contamination.",
  //       workServices:
  //         "Technical support available for product use and interpretation.",
  //       productBrochure: "path/to/sensititre-standard-ast-plates-brochure.pdf",
  //       detailedSpecification:
  //         "Detailed specifications can be provided on request.",
  //       offerOrDiscounts: "Inquire about current offers and discounts.",
  //     },
  //     {
  //       topic: "CLINICAL MICROBIOLOGY LABORATORY EQUIPMENTS",
  //       id: "2",
  //       image: [Nephelometer1],
  //       title: "Sensititre™ Nephelometer",
  //       shortdescription: "Thermo Scientific™ Sensititre™ Nephelometer",
  //       description:
  //         "Measures the turbidity of microbial growth, aiding in the determination of antimicrobial susceptibility.",
  //       workPrinciple:
  //         "Uses nephelometry to measure turbidity changes indicating microbial growth.",
  //       advantages:
  //         "Provides rapid and precise measurements of microbial growth.",
  //       benefits:
  //         "Enhances the accuracy of antimicrobial susceptibility tests.",
  //       testMenu:[''],mainAndCare:
  //         "Regular calibration required; keep the unit clean and free from dust.",
  //       workServices: "Service and calibration support available.",
  //       productBrochure: "path/to/sensititre-nephelometer-brochure.pdf",
  //       detailedSpecification: "Specifications available upon request.",
  //       offerOrDiscounts: "Check for available discounts and promotions.",
  //     },
  //     {
  //       topic: "CLINICAL MICROBIOLOGY LABORATORY EQUIPMENTS",
  //       id: "3",
  //       image: [Automated1],
  //       title: "Sensititre™ Aim™ Automated Inoculation Delivery System",
  //       shortdescription:
  //         "Sensititre™ Aim™ Automated Inoculation Delivery System",
  //       description:
  //         "Automates the inoculation process for antimicrobial susceptibility testing, enhancing accuracy and efficiency.",
  //       workPrinciple:
  //         "Automated system for precise and consistent inoculation of test plates.",
  //       advantages: "Reduces manual errors and increases testing throughput.",
  //       benefits:
  //         "Improves the efficiency and accuracy of susceptibility testing.",
  //       testMenu:[''],mainAndCare:
  //         "Perform regular maintenance and follow operational guidelines.",
  //       workServices: "Technical support and maintenance services available.",
  //       productBrochure:
  //         "path/to/sensititre-aim-automated-inoculation-brochure.pdf",
  //       detailedSpecification: "Detailed specs can be provided upon request.",
  //       offerOrDiscounts: "Inquire about current offers.",
  //     },
  //     {
  //       topic: "CLINICAL MICROBIOLOGY LABORATORY EQUIPMENTS",
  //       id: "4",
  //       image: [manual1],
  //       title: "Sensititre™ Manual Viewbox",
  //       shortdescription: "Thermo Scientific Sensititre™ Manual Viewbox",
  //       description:
  //         "A manual device for visual reading of antimicrobial susceptibility test results, providing clear and precise interpretations.",
  //       workPrinciple:
  //         "Uses transmitted light to view and interpret test results manually.",
  //       advantages:
  //         "Allows for clear visualization of results and manual interpretation.",
  //       benefits: "Essential for labs requiring manual review of test results.",
  //       testMenu:[''],mainAndCare: "Keep the viewbox clean and calibrated regularly.",
  //       workServices: "Support for calibration and usage available.",
  //       productBrochure: "path/to/sensititre-manual-viewbox-brochure.pdf",
  //       detailedSpecification: "Specifications available on request.",
  //       offerOrDiscounts: "Contact for current promotions.",
  //     },
  //     {
  //       topic: "CLINICAL MICROBIOLOGY LABORATORY EQUIPMENTS",
  //       id: "5",
  //       image: [Digital1],
  //       title: "Sensititre™ Vizion™ Digital Mic Viewing System",
  //       shortdescription: "Sensititre™ Vizion™ Digital Mic Viewing System",
  //       description:
  //         "Digital system for viewing and interpreting minimum inhibitory concentrations (MICs) in antimicrobial susceptibility testing.",
  //       workPrinciple:
  //         "Digital imaging system for precise measurement and interpretation of MICs.",
  //       advantages: "Provides accurate and consistent digital readings.",
  //       benefits:
  //         "Enhances the reliability and efficiency of MIC interpretation.",
  //       testMenu:[''],mainAndCare: "Ensure regular maintenance and software updates.",
  //       workServices:
  //         "Technical support available for system operation and troubleshooting.",
  //       productBrochure: "path/to/sensititre-vizion-digital-mic-brochure.pdf",
  //       detailedSpecification:
  //         "Detailed technical specifications can be provided upon request.",
  //       offerOrDiscounts: "Check for current discounts and offers.",
  //     },
  //     {
  //       topic: "CLINICAL MICROBIOLOGY LABORATORY EQUIPMENTS",
  //       id: "6",
  //       image: [Fluorometric1],
  //       title:
  //         "Sensititre™ Optiread™ Automated Fluorometric Plate Reading System",
  //       shortdescription:
  //         "Sensititre™ Optiread™ Automated Fluorometric Plate Reading System",
  //       description:
  //         "Automated system for reading fluorometric plates, providing quick and accurate results for antimicrobial susceptibility tests.",
  //       workPrinciple:
  //         "Uses fluorometric technology to read and analyze test plates.",
  //       advantages:
  //         "Fast and accurate readings with minimal manual intervention.",
  //       benefits: "Improves testing efficiency and accuracy.",
  //       testMenu:[''],mainAndCare: "Regular calibration and maintenance required.",
  //       workServices: "Support for system use and maintenance available.",
  //       productBrochure: "path/to/sensititre-optiread-brochure.pdf",
  //       detailedSpecification: "Specifications available upon request.",
  //       offerOrDiscounts: "Inquire about current promotions.",
  //     },
  //     {
  //       topic: "CLINICAL MICROBIOLOGY LABORATORY EQUIPMENTS",
  //       id: "7",
  //       image: [System1],
  //       title: "Sensititre™ Aris Hiq™ System For Ast",
  //       shortdescription: "Sensititre™ Aris Hiq™ System For Ast",
  //       description:
  //         "Automated system for antimicrobial susceptibility testing, offering high throughput and reliable results.",
  //       workPrinciple:
  //         "Fully automated system for performing and analyzing antimicrobial susceptibility tests.",
  //       advantages: "High throughput with consistent and reliable results.",
  //       benefits: "Reduces manual workload and improves testing accuracy.",
  //       testMenu:[''],mainAndCare: "Follow maintenance schedule and operational guidelines.",
  //       workServices: "Comprehensive support and service options available.",
  //       productBrochure: "path/to/sensititre-aris-hiq-brochure.pdf",
  //       detailedSpecification: "Detailed specs can be provided upon request.",
  //       offerOrDiscounts: "Check with the distributor for current offers.",
  //     },
  //   ],
  // },
  // covid
  // {
  //   category: "COVID-19",
  //   subsection: [],
  //   items: [
  //     {
  //       id: "1",
  //       image: [ANTIBODY1],
  //       title: "Identi VTM",
  //       shortdescription: "Identi VTM",
  //       description:
  //         "Viral Transport Medium (VTM) for the collection, transport, and preservation of clinical specimens containing viruses, including SARS-CoV-2.",
  //       workPrinciple:
  //         "Preserves viral integrity during specimen transport and handling.",
  //       advantages: "Ensures stability of viral samples until analysis.",
  //       benefits:
  //         "Improves the accuracy of viral testing by preserving samples properly.",
  //       testMenu:[''],mainAndCare:
  //         "Store at recommended temperatures; handle according to provided guidelines.",
  //       workServices:
  //         "Technical support available for product usage and storage.",
  //       productBrochure: "path/to/identi-vtm-brochure.pdf",
  //       detailedSpecification:
  //         "Detailed specifications available upon request.",
  //       offerOrDiscounts:
  //         "Check with distributor for current offers and discounts.",
  //     },
  //     {
  //       id: "2",
  //       image: [Affinity1],
  //       title: "Identi Affinity RNA Extraction",
  //       shortdescription: "Identi Affinity RNA Extraction",
  //       description:
  //         "High-efficiency RNA extraction kit designed for reliable and rapid isolation of viral RNA from various clinical samples.",
  //       workPrinciple:
  //         "Uses advanced chemistry to efficiently isolate RNA from clinical samples.",
  //       advantages:
  //         "Provides high yield and purity of RNA for accurate testing.",
  //       benefits:
  //         "Ensures reliable results in downstream applications like PCR.",
  //       testMenu:[''],mainAndCare:
  //         "Follow kit instructions carefully; store reagents as recommended.",
  //       workServices: "Support available for kit usage and troubleshooting.",
  //       productBrochure: "path/to/identi-affinity-rna-extraction-brochure.pdf",
  //       detailedSpecification: "Specifications can be provided on request.",
  //       offerOrDiscounts: "Inquire about current promotions and discounts.",
  //     },
  //     {
  //       id: "3",
  //       image: [REACTIVE1],
  //       title: "Antibody Testing",
  //       shortdescription: "Antibody Testing",
  //       description:
  //         "Comprehensive antibody testing solutions for detecting the presence of antibodies against SARS-CoV-2 in patient samples.",
  //       workPrinciple:
  //         "Detects antibodies produced in response to SARS-CoV-2 infection.",
  //       advantages: "Helps identify past infections and immune response.",
  //       benefits:
  //         "Aids in epidemiological studies and individual immune status assessment.",
  //       testMenu:[''],mainAndCare:
  //         "Ensure proper sample handling and test according to the protocol.",
  //       workServices:
  //         "Technical support available for interpreting results and test procedures.",
  //       productBrochure: "path/to/antibody-testing-brochure.pdf",
  //       detailedSpecification:
  //         "Detailed technical specifications available upon request.",
  //       offerOrDiscounts: "Check for any current offers or discounts.",
  //     },
  //     {
  //       id: "4",
  //       image: [FERRITI1],
  //       title: "Procalcitonin",
  //       shortdescription: "Procalcitonin",
  //       description:
  //         "Biomarker assay for the detection of procalcitonin levels, aiding in the diagnosis of bacterial infections and sepsis.",
  //       workPrinciple:
  //         "Measures procalcitonin levels, which rise in response to bacterial infections.",
  //       advantages:
  //         "Helps differentiate bacterial infections from other causes of inflammation.",
  //       benefits:
  //         "Provides valuable diagnostic information in acute care settings.",
  //       testMenu:[''],mainAndCare:
  //         "Store and handle according to the manufacturer's guidelines.",
  //       workServices:
  //         "Support available for assay setup and result interpretation.",
  //       productBrochure: "path/to/procalcitonin-brochure.pdf",
  //       detailedSpecification: "Specifications available upon request.",
  //       offerOrDiscounts: "Inquire about current discounts.",
  //     },
  //     {
  //       id: "5",
  //       image: [LACTAT1],
  //       title: "Ferritin",
  //       shortdescription: "Ferritin",
  //       description:
  //         "Assay for measuring ferritin levels, useful in the diagnosis and monitoring of iron deficiency and related conditions.",
  //       workPrinciple:
  //         "Measures ferritin, a marker of iron stores in the body.",
  //       advantages:
  //         "Helps diagnose iron deficiency and monitor treatment efficacy.",
  //       benefits:
  //         "Provides insight into iron metabolism and related health conditions.",
  //       testMenu:[''],mainAndCare: "Follow storage instructions to ensure assay performance.",
  //       workServices:
  //         "Technical support for assay usage and results interpretation.",
  //       productBrochure: "path/to/ferritin-brochure.pdf",
  //       detailedSpecification:
  //         "Detailed specifications available upon request.",
  //       offerOrDiscounts: "Check for current offers and discounts.",
  //     },
  //     {
  //       id: "6",
  //       image: [PROCALCITONIN1],
  //       title: "Lactate Dehydrogenase (LDH-L)",
  //       shortdescription: "Lactate Dehydrogenase (LDH-L)",
  //       description:
  //         "Enzyme assay for lactate dehydrogenase, a marker of tissue damage and inflammation, including in COVID-19 patients.",
  //       workPrinciple:
  //         "Measures LDH enzyme levels, which increase with tissue damage.",
  //       advantages: "Provides information on tissue injury and inflammation.",
  //       benefits:
  //         "Useful in diagnosing and monitoring conditions associated with tissue damage.",
  //       testMenu:[''],mainAndCare:
  //         "Store reagents according to guidelines; follow assay instructions carefully.",
  //       workServices:
  //         "Support available for assay use and result interpretation.",
  //       productBrochure: "path/to/ldh-l-brochure.pdf",
  //       detailedSpecification: "Specifications can be provided on request.",
  //       offerOrDiscounts: "Inquire about current discounts.",
  //     },
  //     {
  //       id: "7",
  //       image: [identi1],
  //       title: "C-Reactive Protein (CRP)",
  //       shortdescription: "C-Reactive Protein (CRP)",
  //       description:
  //         "CRP assay for the detection of inflammation and infection, useful in managing COVID-19 and other inflammatory conditions.",
  //       workPrinciple:
  //         "Detects CRP levels, an indicator of systemic inflammation.",
  //       advantages: "Helps assess inflammation and infection levels.",
  //       benefits:
  //         "Useful in monitoring disease progression and response to treatment.",
  //       testMenu:[''],mainAndCare: "Handle samples and reagents according to the protocol.",
  //       workServices:
  //         "Technical support available for assay usage and result interpretation.",
  //       productBrochure: "path/to/crp-brochure.pdf",
  //       detailedSpecification:
  //         "Detailed specifications available upon request.",
  //       offerOrDiscounts: "Check for current promotions and discounts.",
  //     },
  //   ],
  // },
  // "Electrolyte Analyzer"
  {
    category: "Electrolyte Analyzer",
    categoryURL: 'electrolyte-analyzer',
    subsection: ["With Auto loader", "Without Auto loader"],

    items: [
      {
        topic: "Electrolyte Analyzer",
        id: "1",
        slug: 'jokoh-ex-d',
        section: "with-auto-loader",
        coverImg: JokohExDGrey,
        image: [
          { src: Jokoh1, alt: "JOKOH EX-D electrolyte analyzer with auto loader for lab ion testing" },
          { src: Jokoh2, alt: "Compact esr analyzer showing sample loading and display interface" },
          { src: Jokoh3, alt: "Advanced esr analyzer unit with touchscreen and testing module" },
        ],
        title: "Jokoh Ex-D",
        shortdescription:
          "The Jokoh EX-D Electrolyte Analyzer is engineered to deliver rapid and precise measurements of vital electrolytes, including sodium (Na+), potassium (K+), and chloride (Cl-). The analyzer’s compact design makes it an excellent choice for laboratories with space constraints, while its advanced technology ensures consistent accuracy and low operational costs.",
        description:
          "The Jokoh EX-D Electrolyte Analyzer is a high-performance, batch analyzer designed for quick and accurate measurement of critical electrolytes such as sodium, potassium, and chloride. Ideal for clinical laboratories and healthcare facilities, this analyzer is renowned for its precision, efficiency, and ease of use, ensuring reliable diagnostic results.",
        workPrinciple: (
          <div>
            <ul className="space-y-6 font-poppins">
              <li className="flex-col gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="font-semibold tablet:text-sm largeLaptop:text-2xl  text-xs">
                    How it Works
                  </span>
                </p>
                <p className=" largeLaptop:text-2xl text-xs tablet:text-sm text-black ">
                  <span className="text-sm">The Jokoh EX-D uses ion-selective electrode (ISE) technology
                    to measure electrolyte concentrations in biological fluids
                    such as blood, serum, and plasma. This technology relies on
                    electrodes that are sensitive to specific ions, allowing for
                    accurate and direct measurement of electrolyte levels in a
                    short amount of time. The analyzer features automatic
                    calibration and a built-in quality control system to ensure
                    the reliability of every result.</span>
                </p>
              </li>
            </ul>

            {/* For Whom It Is Useful */}
            <table className="min-w-full table-auto">
              <thead>
                <tr>
                  <th className="tablet:px-4 tablet:py-4 px-0 py-1 tablet:text-sm text-xs  text-left text-black font-semibold">
                    For Whom It Is Useful
                  </th>
                </tr>
              </thead>
              <tbody className="flex flex-col gap-4">
                <tr>
                  <td className="  text-black tablet:text-sm text-xs">
                    <span className="text-sm">The Jokoh EX-D Electrolyte Analyzer is perfect for clinical
                      laboratories, hospitals, and diagnostic centers that require
                      fast and precise electrolyte measurements. It is
                      particularly valuable in critical care settings, emergency
                      rooms, and intensive care units where timely and accurate
                      electrolyte analysis is essential for patient management.</span>
                  </td>
                </tr>
              </tbody>
            </table>

            {/* Use Cases */}
            <table className="min-w-full table-auto mt-6">
              <thead>
                <tr>
                  <th className="tablet:px-4 tablet:text-sm tablet:py-2 px-0 py-0  text-left text-black font-semibold">
                    Use Cases
                  </th>
                </tr>
              </thead>
              <tbody className="flex flex-col gap-4">
                <tr>
                  <td className="  text-black">
                    <strong className="text-xs tablet:text-sm font-semibold largeLaptop:text-lg ">
                      {" "}
                      Critical Care:
                    </strong>{" "}
                    <span className="text-sm">Provides rapid electrolyte analysis for patients in
                      intensive care units or emergency departments.</span>
                  </td>
                </tr>
                <tr>
                  <td className="  text-black">
                    <strong className="text-xs tablet:text-sm font-semibold largeLaptop:text-lg ">
                      {" "}
                      Routine Laboratory Testing:
                    </strong>{" "}
                    <span className="text-sm">Ideal for use in clinical laboratories handling a high
                      volume of samples daily.</span>
                  </td>
                </tr>
                <tr>
                  <td className="  text-black">
                    <strong className="text-xs tablet:text-sm font-semibold largeLaptop:text-lg ">
                      {" "}
                      Diagnostic Centers:
                    </strong>{" "}
                    <span className="text-sm">Enables precise electrolyte measurement for diagnostic
                      purposes, supporting medical professionals in delivering
                      accurate diagnoses.</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        ),

        advantages: (
          <div>
            {/* Advantages Table */}
            <table className="min-w-full table-auto">
              <tbody className="flex flex-col gap-4">
                <tr>
                  <td className="  text-black">
                    <strong className="text-xs tablet:text-sm font-semibold largeLaptop:text-lg ">
                      {" "}
                      High Efficiency:
                    </strong>{" "}
                    <span className="text-sm">Quick turnaround time ensures that critical results are
                      delivered without delay, enabling faster decision-making.</span>
                  </td>
                </tr>
                <tr>
                  <td className="  text-black">
                    <strong className="text-xs tablet:text-sm font-semibold largeLaptop:text-lg ">
                      {" "}
                      Ease of Use:
                    </strong>{" "}
                    <span className="text-sm">The intuitive touchscreen interface and automated features
                      reduce the complexity of operations, allowing for minimal
                      operator intervention.</span>
                  </td>
                </tr>
                <tr>
                  <td className="  text-black">
                    <strong className="text-xs tablet:text-sm font-semibold largeLaptop:text-lg ">
                      {" "}
                      Compact Design:
                    </strong>{" "}
                    <span className="text-sm">Its small footprint allows it to be placed in laboratories
                      with limited space, optimizing workflow efficiency.</span>
                  </td>
                </tr>
                <tr>
                  <td className="  text-black">
                    <strong className="text-xs tablet:text-sm font-semibold largeLaptop:text-lg ">
                      {" "}
                      Consistent Accuracy:
                    </strong>{" "}
                    <span className="text-sm">The built-in quality control system guarantees consistent
                      and reliable results, reducing the risk of errors.</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        ),

        benefits: (
          <div>
            {/* Benefits Table */}
            <table className="min-w-full table-auto">
              <tbody className="flex flex-col gap-4">
                <tr>
                  <td className="  text-black">
                    <strong className="text-xs tablet:text-sm font-semibold largeLaptop:text-lg ">
                      {" "}
                      Cost-Effective:
                    </strong>{" "}
                    <span className="text-sm">Low reagent consumption and minimal maintenance requirements
                      lower the overall cost of ownership.</span>
                  </td>
                </tr>
                <tr>
                  <td className="  text-black">
                    <strong className="text-xs tablet:text-sm font-semibold largeLaptop:text-lg ">
                      {" "}
                      Improved Workflow:
                    </strong>{" "}
                    <span className="text-sm">Automatic calibration and fast processing speeds streamline
                      lab operations, allowing for higher productivity.</span>
                  </td>
                </tr>
                <tr>
                  <td className="  text-black">
                    <strong className="text-xs tablet:text-sm font-semibold largeLaptop:text-lg ">
                      {" "}
                      Reliable Results:
                    </strong>{" "}
                    <span className="text-sm">The precision of ion-selective electrode technology ensures
                      that clinicians receive accurate data, enhancing patient</span>
                    care.
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        ),

        testMenu: [""],
        mainAndCare: (
          <div>
            <ul className="space-y-6 font-poppins">
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Routine maintenance
                  of the tubings by the wash solutions.
                </p>
              </li>
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Ensuring proper
                  storage and handling of reagents
                </p>
              </li>
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span>Regular performance
                  checks of the electrodes to ensure ongoing accuracy
                </p>
              </li>
            </ul>
          </div>
        ),
        workServices:
          "Technical support and service options available for system maintenance and troubleshooting.",
        productBrochure: "path/to/jokoh-ex-d-brochure.pdf",
        detailedSpecification:
          "Detailed specifications can be provided upon request.",
        offerOrDiscounts:
          "Check with the distributor for current offers and discounts.",
      },
      {
        topic: "Electrolyte Analyzer",
        id: "2",
        slug: 'jokoh-ex-ds',
        section: "without-auto-loader",
        coverImg: JokohExDsGrey,
        image: [

          { src: JokohExDs, alt: "JOKOH EX-DS electrolyte analyzer without auto loader for ion testing" },
        ],

        title: "Jokoh Ex-Ds",
        shortdescription:
          "The EX-Ds Electrolyte Analyzer offers reliable and efficient high-throughput testing, providing precise results and seamless integration for both routine and specialized diagnostic tests, optimizing laboratory workflows.",
        description:
          "The EX-Ds electrolyte analyzer is a reliable and efficient solution for high-throughput laboratories. Its precision and seamless integration make it ideal for routine and specialized diagnostic tests, ensuring accurate results and optimized workflows.",
        workPrinciple: (
          <div>
            <ul className="space-y-6 font-poppins">
              <li className="flex-col gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="font-semibold tablet:text-sm largeLaptop:text-2xl  text-xs">
                    How it Works
                  </span>
                </p>
                <p className=" largeLaptop:text-2xl text-xs tablet:text-sm text-black ">
                  <span className="text-sm">The Jokoh EX-DS uses ion-selective electrode (ISE) technology
                    to measure electrolyte concentrations in biological fluids
                    such as blood, serum, and plasma. This technology relies on
                    electrodes that are sensitive to specific ions, allowing for
                    accurate and direct measurement of electrolyte levels in a
                    short amount of time. The analyzer features automatic
                    calibration and a built-in quality control system to ensure
                    the reliability of every result.</span>
                </p>
              </li>
            </ul>

            {/* For Whom It Is Useful */}
            <table className="min-w-full table-auto">
              <thead>
                <tr>
                  <th className="tablet:px-4 tablet:py-4 px-0 py-1 tablet:text-sm text-xs  text-left text-black font-semibold">
                    For Whom It Is Useful
                  </th>
                </tr>
              </thead>
              <tbody className="flex flex-col gap-4">
                <tr>
                  <td className="  text-black tablet:text-sm text-xs">
                    <span className="text-sm">The Jokoh EX-DS Electrolyte Analyzer is perfect for clinical
                      laboratories, hospitals, and diagnostic centers that require
                      fast and precise electrolyte measurements. It is
                      particularly valuable in critical care settings, emergency
                      rooms, and intensive care units where timely and accurate
                      electrolyte analysis is essential for patient management.</span>
                  </td>
                </tr>
              </tbody>
            </table>

            {/* Use Cases */}
            <table className="min-w-full table-auto mt-6">
              <thead>
                <tr>
                  <th className="tablet:px-4 tablet:text-sm tablet:py-2 px-0 py-0  text-left text-black font-semibold">
                    Use Cases
                  </th>
                </tr>
              </thead>
              <tbody className="flex flex-col gap-4">
                <tr>
                  <td className="  text-black">
                    <strong className="text-xs tablet:text-sm font-semibold largeLaptop:text-lg ">
                      {" "}
                      Critical Care:
                    </strong>{" "}
                    <span className="text-sm">Provides rapid electrolyte analysis for patients in
                      intensive care units or emergency departments.</span>
                  </td>
                </tr>
                <tr>
                  <td className="  text-black">
                    <strong className="text-xs tablet:text-sm font-semibold largeLaptop:text-lg ">
                      {" "}
                      Routine Laboratory Testing:
                    </strong>{" "}
                    <span className="text-sm">Ideal for use in clinical laboratories handling a high
                      volume of samples daily.</span>
                  </td>
                </tr>
                <tr>
                  <td className="  text-black">
                    <strong className="text-xs tablet:text-sm font-semibold largeLaptop:text-lg ">
                      {" "}
                      Diagnostic Centers:
                    </strong>{" "}
                    <span className="text-sm">Enables precise electrolyte measurement for diagnostic
                      purposes, supporting medical professionals in delivering
                      accurate diagnoses.</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        ),

        advantages: (
          <div>
            {/* Advantages Table */}
            <table className="min-w-full table-auto">
              <tbody className="flex flex-col gap-4">
                <tr>
                  <td className="  text-black">
                    <strong className="text-xs tablet:text-sm font-semibold largeLaptop:text-lg ">
                      {" "}
                      High Efficiency:
                    </strong>{" "}
                    <span className="text-sm">Quick turnaround time ensures that critical results are
                      delivered without delay, enabling faster decision-making.</span>
                  </td>
                </tr>
                <tr>
                  <td className="  text-black">
                    <strong className="text-xs tablet:text-sm font-semibold largeLaptop:text-lg ">
                      {" "}
                      Ease of Use:
                    </strong>{" "}
                    <span className="text-sm">The intuitive touchscreen interface and automated features
                      reduce the complexity of operations, allowing for minimal
                      operator intervention.</span>
                  </td>
                </tr>
                <tr>
                  <td className="  text-black">
                    <strong className="text-xs tablet:text-sm font-semibold largeLaptop:text-lg ">
                      {" "}
                      Compact Design:
                    </strong>{" "}
                    <span className="text-sm">Its small footprint allows it to be placed in laboratories
                      with limited space, optimizing workflow efficiency.</span>
                  </td>
                </tr>
                <tr>
                  <td className="  text-black">
                    <strong className="text-xs tablet:text-sm font-semibold largeLaptop:text-lg ">
                      {" "}
                      Consistent Accuracy:
                    </strong>{" "}
                    <span className="text-sm">The built-in quality control system guarantees consistent
                      and reliable results, reducing the risk of errors.</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div >
        ),

        benefits: (
          <div>
            {/* Benefits Table */}
            <table className="min-w-full table-auto">
              <tbody className="flex flex-col gap-4">
                <tr>
                  <td className="  text-black">
                    <strong className="text-xs tablet:text-sm font-semibold largeLaptop:text-lg ">
                      {" "}
                      Cost-Effective:
                    </strong>{" "}
                    <span className="text-sm">Low reagent consumption and minimal maintenance requirements
                      lower the overall cost of ownership.</span>
                  </td>
                </tr>
                <tr>
                  <td className="  text-black">
                    <strong className="text-xs tablet:text-sm font-semibold largeLaptop:text-lg ">
                      {" "}
                      Improved Workflow:
                    </strong>{" "}
                    <span className="text-sm">Automatic calibration and fast processing speeds streamline
                      lab operations, allowing for higher productivity.</span>
                  </td>
                </tr>
                <tr>
                  <td className="  text-black">
                    <strong className="text-xs tablet:text-sm font-semibold largeLaptop:text-lg ">
                      {" "}
                      Reliable Results:
                    </strong>{" "}
                    <span className="text-sm">The precision of ion-selective electrode technology ensures
                      that clinicians receive accurate data, enhancing patient</span>
                    care.
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        ),

        testMenu: [""],
        mainAndCare: (
          <div>
            <ul className="space-y-6 font-poppins">
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Routine maintenance
                  of the tubings by the wash solutions.
                </p>
              </li>
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Ensuring proper
                  storage and handling of reagents
                </p>
              </li>
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span>Regular performance
                  checks of the electrodes to ensure ongoing accuracy
                </p>
              </li>
            </ul>
          </div>
        ),
        workServices:
          "Technical support and service options available for system maintenance and troubleshooting.",
        productBrochure: "path/to/jokoh-ex-d-brochure.pdf",
        detailedSpecification:
          "Detailed specifications can be provided upon request.",
        offerOrDiscounts:
          "Check with the distributor for current offers and discounts.",
      },
    ],
  },
  // Hematology
  {
    category: "Hematology",
    categoryURL: 'hematology-analyzer',
    subsection: [
      "3 Part",
      "5 Part",
      "ESR Analyzer",
      // "Reagents",
    ],
    items: [
      // {
      //   allover: "5 Part Differential Hematology Analyzer",
      //   id: "3",
      //   coverImg: DYNACOUNT5Dgrey,
      //   image: [DYNACOUNT5D1],
      //   title: "DYNACOUNT 5D",
      //   section: "5parthematology",

      //   shortdescription:
      //     "The Dynacount 5D Hematology Analyzer or CBC machine utilizes state-of-the-art 5-part differential technology to provide detailed and accurate blood cell analysis. It is designed to meet the rigorous demands of modern laboratories, ensuring reliable results with minimal manual intervention.",
      //   description:
      //     "The Dynacount 5D Hematology Analyzer or CBC machine is a sophisticated diagnostic tool designed for precise and comprehensive hematological analysis. It features advanced 5-part differential technology for accurate blood cell counting and differentiation, making it ideal for high-throughput laboratories. With its user-friendly interface and reliable performance, this analyzer ensures efficient and accurate results.",
      //   workPrinciple: (
      //     <div>
      //       {/* Working Principle Table */}
      //       <table className="min-w-full table-auto">
      //         <tbody className="flex flex-col gap-4">
      //           <tr>
      //             <td className="  text-black">
      //               <strong className="text-xs tablet:text-sm font-semibold largeLaptop:text-lg ">
      //                 {" "}
      //                 <span className="font-semibold tablet:text-sm largeLaptop:text-2xl  text-xs">
      //                   Flow Cytometry (Laser Scattering)
      //                 </span>
      //                 :
      //               </strong>{" "}
      //               <br />A laser-based flow cytometry system is used to
      //               classify white blood cells into five subtypes (neutrophils,
      //               lymphocytes, monocytes, eosinophils, and basophils) based on
      //               cell size, granularity, and complexity.
      //             </td>
      //           </tr>
      //         </tbody>
      //       </table>
      //     </div>
      //   ),

      //   advantages: (
      //     <div>
      //       {/* Advantages List */}
      //       <ul className="space-y-6 font-poppins">
      //         <li className="flex gap-3">
      //           <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
      //             {" "}
      //             <span className="text-[#10b981]">◆</span> High precision with
      //             5-part differential technology
      //           </p>
      //         </li>
      //         <li className="flex gap-3">
      //           <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
      //             {" "}
      //             <span className="text-[#10b981]">◆</span> Fast processing for
      //             high throughput
      //           </p>
      //         </li>
      //         <li className="flex gap-3">
      //           <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
      //             {" "}
      //             <span className="text-[#10b981]">◆</span> User-friendly
      //             interface for easy operation
      //           </p>
      //         </li>
      //       </ul>
      //     </div>
      //   ),

      //   benefits: (
      //     <div>
      //       {/* Benefits List */}
      //       <ul className="space-y-6 font-poppins">
      //         <li className="flex gap-3">
      //           <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
      //             {" "}
      //             <span className="text-[#10b981]">◆</span> Enhanced accuracy
      //             and reliability in blood cell analysis
      //           </p>
      //         </li>
      //         <li className="flex gap-3">
      //           <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
      //             {" "}
      //             <span className="text-[#10b981]">◆</span> Increased efficiency
      //             in laboratory workflows
      //           </p>
      //         </li>
      //         <li className="flex gap-3">
      //           <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
      //             {" "}
      //             <span className="text-[#10b981]">◆</span> Reduced need for
      //             manual intervention, minimizing errors
      //           </p>
      //         </li>
      //       </ul>
      //     </div>
      //   ),

      //   testMenu: [""],
      //   mainAndCare: (
      //     <div>
      //       {/* Maintenance and Care List */}
      //       <ul className="space-y-6 font-poppins">
      //         <li className="flex gap-3">
      //           <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
      //             {" "}
      //             <span className="text-[#10b981]">◆</span> Regular Calibration:
      //             Ensure periodic calibration to maintain accuracy.
      //           </p>
      //         </li>
      //         <li className="flex gap-3">
      //           <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
      //             {" "}
      //             <span className="text-[#10b981]">◆</span> Routine Cleaning:
      //             Regularly clean sample probes and internal components to
      //             ensure optimal performance.
      //           </p>
      //         </li>
      //         <li className="flex gap-3">
      //           <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
      //             {" "}
      //             <span className="text-[#10b981]">◆</span> Software Updates:
      //             Keep the software updated to benefit from the latest features
      //             and improvements.
      //           </p>
      //         </li>
      //         <li className="flex gap-3">
      //           <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
      //             {" "}
      //             <span className="text-[#10b981]">◆</span> Preventive
      //             Maintenance: Schedule regular maintenance checks by certified
      //             technicians to ensure long-term reliability.
      //           </p>
      //         </li>
      //       </ul>
      //     </div>
      //   ),

      //   workServices:
      //     "Available technical support for installation, maintenance, and troubleshooting.",
      //   productBrochure: "path/to/dynacount-5d-brochure.pdf",
      //   detailedSpecification:
      //     "Detailed technical specifications available on request.",
      //   offerOrDiscounts:
      //     "Check for current offers and discounts with the distributor.",
      // },
      // {
      //   allover: "3 Part Differential Hematology Analyzer",
      //   id: "1",

      //   section: "3parthematology",
      //   coverImg: DYNACOUNT3DGrey,
      //   image: [DYNACOUNT3D1],
      //   title: "DYNACOUNT 3D",
      //   shortdescription:
      //     "The Dynacount 3D Hematology Analyzer utilizes state-of-the-art 3D imaging technology to provide detailed and accurate blood cell analysis. It is designed to meet the rigorous demands of modern laboratories, ensuring reliable results with ease.",
      //   description:
      //     "The Dynacount 3D Hematology Analyzer is a cutting-edge device designed for precise and reliable hematological analysis. Leveraging advanced 3D imaging technology, it ensures accurate blood cell counting and differentiation. Ideal for laboratories and healthcare facilities, this analyzer enhances efficiency and offers user-friendly operation.",
      //   workPrinciple: (
      //     <div>
      //       {/* Working Principle Table */}
      //       <table className="min-w-full table-auto">
      //         <tbody className="flex flex-col gap-4">
      //           <tr>
      //             <td className="  text-black">
      //               <strong className="text-xs tablet:text-sm font-semibold largeLaptop:text-lg ">
      //                 {" "}
      //                 <span className="font-semibold tablet:text-sm largeLaptop:text-2xl  text-xs">
      //                   How it Works
      //                 </span>
      //                 :
      //               </strong>{" "}
      //               Employs 3D imaging to capture detailed blood cell images,
      //               facilitating accurate counting and differentiation.
      //               Processes samples quickly for timely results.
      //             </td>
      //           </tr>
      //           <tr>
      //             <td className="  text-black">
      //               <strong className="text-xs tablet:text-sm font-semibold largeLaptop:text-lg ">
      //                 {" "}
      //                 For Whom:
      //               </strong>{" "}
      //               Ideal for clinical laboratories, hospitals, and diagnostic
      //               centers.
      //             </td>
      //           </tr>
      //           <tr>
      //             <td className="  text-black">
      //               <strong className="text-xs tablet:text-sm font-semibold largeLaptop:text-lg ">
      //                 {" "}
      //                 Use Cases:
      //               </strong>{" "}
      //               Suitable for routine blood tests, diagnosing hematological
      //               disorders, and monitoring patient health.
      //             </td>
      //           </tr>
      //         </tbody>
      //       </table>
      //     </div>
      //   ),

      //   advantages: (
      //     <div>
      //       {/* Advantages List */}
      //       <ul className="space-y-6 font-poppins list-disc list-inside">
      //         <li className="flex gap-3">
      //           <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
      //             {" "}
      //             <span className="text-[#10b981]">◆</span> High precision with
      //             advanced 3D technology
      //           </p>
      //         </li>
      //         <li className="flex gap-3">
      //           <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
      //             {" "}
      //             <span className="text-[#10b981]">◆</span> Fast processing for
      //             high throughput
      //           </p>
      //         </li>
      //         <li className="flex gap-3">
      //           <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
      //             {" "}
      //             <span className="text-[#10b981]">◆</span> Easy-to-use
      //             interface for streamlined operation
      //           </p>
      //         </li>
      //       </ul>
      //     </div>
      //   ),

      //   benefits: (
      //     <div>
      //       {/* Benefits List */}
      //       <ul className="space-y-6 font-poppins">
      //         <li className="flex gap-3">
      //           <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
      //             {" "}
      //             <span className="text-[#10b981]">◆</span> Enhanced accuracy
      //             and reliability in blood analysis
      //           </p>
      //         </li>
      //         <li className="flex gap-3">
      //           <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
      //             {" "}
      //             <span className="text-[#10b981]">◆</span> Increased efficiency
      //             and workflow optimization
      //           </p>
      //         </li>
      //         <li className="flex gap-3">
      //           <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
      //             {" "}
      //             <span className="text-[#10b981]">◆</span> Reduced need for
      //             manual intervention, minimizing errors
      //           </p>
      //         </li>
      //       </ul>
      //     </div>
      //   ),

      //   testMenu: [""],
      //   mainAndCare: (
      //     <div>
      //       {/* Maintenance and Care List */}
      //       <ul className="space-y-6 font-poppins">
      //         <li className="flex gap-3">
      //           <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
      //             {" "}
      //             <span className="text-[#10b981]">◆</span> Regular Calibration:
      //             Periodic calibration to maintain accuracy.
      //           </p>
      //         </li>
      //         <li className="flex gap-3">
      //           <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
      //             {" "}
      //             <span className="text-[#10b981]">◆</span> Routine Cleaning:
      //             Regular cleaning of sample probes and internal components.
      //           </p>
      //         </li>
      //         <li className="flex gap-3">
      //           <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
      //             {" "}
      //             <span className="text-[#10b981]">◆</span> Software Updates:
      //             Keep software updated for the latest features.
      //           </p>
      //         </li>
      //         <li className="flex gap-3">
      //           <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
      //             {" "}
      //             <span className="text-[#10b981]">◆</span> Preventive
      //             Maintenance: Schedule regular checks by certified technicians
      //             for long-term reliability.
      //           </p>
      //         </li>
      //       </ul>
      //     </div>
      //   ),

      //   workServices:
      //     "Technical support and service options available for system maintenance and troubleshooting.",
      //   productBrochure: "path/to/dynacount-3d-brochure.pdf",
      //   detailedSpecification: "Specifications available upon request.",
      //   offerOrDiscounts:
      //     "Check with distributor for current offers and discounts.",
      // },
      {
        allover: "3 Part Differential Hematology Analyzer",
        id: "2",
        slug: 'dynacount-3d-plus',
        coverImg: DYNACOUNT3DPlusGrey,
        image: [

          { src: DYNACOUNT3DPlus, alt: "DYNACOUNT 3D Plus cbc analyzer with dual sample chambers and touchscreen" },
        ],
        title: "DYNACOUNT 3D Plus",
        section: "3-part",
        shortdescription:
          "The Dynacount 3D Plus Hematology Analyzer leverages sophisticated 3D imaging to provide detailed and accurate blood cell analysis. This device is engineered to meet the demands of modern laboratories, offering reliable results with minimal manual intervention.",
        description: `The Dynacount 3D Plus Hematology Analyzer
     
            is an advanced technology to deliver precise and comprehensive blood
            cell analysis. Designed to meet the evolving needs of modern
            laboratories, the system ensures reliable results with minimal
            manual intervention.`,

        workPrinciple: (
          <div>
            {/* Working Principle Table */}
            <table className="min-w-full table-auto">
              <tbody className="flex flex-col gap-4">
                <tr>
                  <td className="  text-black">
                    <strong className="text-xs tablet:text-sm font-semibold largeLaptop:text-lg ">
                      {" "}
                      <span className="font-semibold tablet:text-sm largeLaptop:text-2xl  text-xs">
                        Electrical Impedance for RBC,WBC& PLT
                      </span>
                      :
                    </strong>{" "}
                    <br />
                    <span className="text-sm">The analyzer uses the electrical impedance method to count
                      and determine the size of red blood cells (RBCs), white
                      blood cells (WBCs), and platelets (PLTs). As cells pass
                      through an aperture changes in impedance are measured to
                      quantify and differentiate them based on volume.</span>
                  </td>
                </tr>
                <tr>
                  <td className="  text-black">
                    <strong className="text-xs tablet:text-sm font-semibold largeLaptop:text-lg ">
                      {" "}
                      Colorimetry for Hemoglobin Measurement
                    </strong>{" "}
                    <br />
                    <span className="text-sm"> For hemoglobin (HGB) estimation, the analyzer employs the
                      colorimetric method. Blood is mixed with a reagent that
                      lyses the red blood cells and converts hemoglobin into a
                      stable colored compound, which is then measured
                      photometrically.</span>{" "}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        ),

        advantages: (
          <div>
            {/* Advantages List */}
            <ul className="space-y-6 font-poppins">
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> High precision due
                  to advanced 3D imaging
                </p>
              </li>
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Fast sample
                  processing enhances laboratory efficiency
                </p>
              </li>
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> User-friendly
                  operation reduces training time
                </p>
              </li>
            </ul>
          </div>
        ),

        benefits: (
          <div>
            {/* Benefits List */}
            <ul className="space-y-6 font-poppins">
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Provides accurate
                  and reliable hematological analysis
                </p>
              </li>
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Increases efficiency
                  in laboratory workflows
                </p>
              </li>
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Minimizes manual
                  intervention, reducing the risk of errors
                </p>
              </li>
            </ul>
          </div>
        ),

        testMenu: [""],
        mainAndCare: (
          <div>
            {/* Maintenance and Care List */}
            <ul className="space-y-6 font-poppins">
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Regular Calibration:
                  Ensure periodic calibration to maintain accuracy.
                </p>
              </li>
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Routine Cleaning:
                  Clean sample probes and internal components regularly.
                </p>
              </li>
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Software Updates:
                  Keep software updated for enhanced features and performance.
                </p>
              </li>
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Preventive
                  Maintenance: Schedule regular maintenance checks by certified
                  technicians to ensure optimal performance.
                </p>
              </li>
            </ul>
          </div>
        ),

        workServices:
          "Comprehensive technical support available for installation and troubleshooting.",
        productBrochure: "path/to/dynacount-3d-plus-brochure.pdf",
        detailedSpecification:
          "Detailed specifications can be provided upon request.",
        offerOrDiscounts: "Inquire about current promotions and discounts.",
      },

      {
        allover: "VISION Pro",
        id: "4",
        slug: 'vision-pro',
        coverImg: VisionGrey,
        image: [

          { src: Vision1, alt: "Vision ESR analyzer for automated erythrocyte sedimentation rate testing" },
        ],
        title: "VISION Pro",
        section: "esr-analyzer",

        shortdescription:
          "The Vision Pro ESR Analyzer by YHLO is designed to streamline the process of measuring erythrocyte sedimentation rate using the Westergren method. This fully automated ESR analyzer ensures precise and rapid results, enhancing laboratory productivity and accuracy.",
        description:
          "The Vision Pro ESR Analyzer is a fully automated solution designed to deliver quick and accurate erythrocyte sedimentation rate (ESR) results. It features advanced technology, providing test results in just 20 minutes with a minimum 1.5ml sample volume. Ideal for laboratories seeking efficiency and reliability, it operates using primary EDTA tubes and requires no disposables.",
        workPrinciple: (
          <div>
            {/* Working Principle Table */}
            <table className="min-w-full table-auto">
              <tbody className="flex flex-col gap-4">
                <tr>
                  <td className="  text-black">
                    <strong className="text-xs tablet:text-sm font-semibold largeLaptop:text-lg ">
                      {" "}
                      <span className="font-semibold tablet:text-sm largeLaptop:text-2xl  text-xs">
                        How it Works
                      </span>
                      :
                    </strong>{" "}
                    <span className="text-sm">The analyzer uses infrared scanning technology to measure
                      ESR, generating a 3-phase sedimentation curve. It processes
                      samples directly from primary EDTA tubes, providing results
                      within 20 minutes.</span>
                  </td>
                </tr>
                <tr>
                  <td className="  text-black">
                    <strong className="text-xs tablet:text-sm font-semibold largeLaptop:text-lg ">
                      {" "}
                      For Whom:
                    </strong>{" "}
                    <span className="text-sm">Ideal for clinical laboratories, hospitals, and diagnostic
                      centers that require fast and accurate ESR testing.</span>
                  </td>
                </tr>
                <tr>
                  <td className="  text-black">
                    <strong className="text-xs tablet:text-sm font-semibold largeLaptop:text-lg ">
                      {" "}
                      Use Cases:
                    </strong>{" "}
                    <span className="text-sm">Used for routine ESR tests to diagnose and monitor
                      inflammatory conditions and other medical conditions.</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        ),

        advantages: (
          <div>
            {/* Advantages List */}
            <ul className="space-y-6 font-poppins">
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Rapid test results,
                  improving laboratory efficiency
                </p>
              </li>
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Eliminates the need
                  for disposable materials, reducing costs
                </p>
              </li>
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Easy operation with
                  primary EDTA tubes and minimal sample volume
                </p>
              </li>
            </ul>
          </div>
        ),

        benefits: (
          <div>
            {/* Benefits List */}
            <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap mb-4">
              {" "}
              <span className="text-sm">Saves time and reduces manual handling with direct sample loading.</span>
            </p>
            <ul className="space-y-6 font-poppins ml-4">
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Offers real-time
                  sedimentation curve monitoring for precise interpretation.
                </p>
              </li>
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Compact design fits
                  into laboratories with limited space.
                </p>
              </li>
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Ensures robust data
                  management through bidirectional LIS connectivity.
                </p>
              </li>
            </ul>
          </div>
        ),

        testMenu: [""],
        mainAndCare: (
          <div>
            {/* Maintenance and Care List */}
            <p className=" text-xs mb-4 largeLaptop:text-2xl tablet:text-sm text-black font-normal text-wrap ">
              {" "}
              <span className="text-sm">Clean the touchscreen interface regularly with a soft cloth.</span>
            </p>
            <ul className="space-y-6 font-poppins ml-4">
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Use the built-in QC
                  options to ensure consistent performance.
                </p>
              </li>
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Store the analyzer
                  in a dry, dust-free environment.
                </p>
              </li>
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Follow the
                  manufacturer’s guidelines for routine calibration and upkeep.
                </p>
              </li>
            </ul>
          </div>
        ),

        workServices:
          "Available technical support for installation, maintenance, and troubleshooting.",
        productBrochure: "path/to/dynacount-5d-brochure.pdf",
        detailedSpecification:
          "Detailed technical specifications available on request.",
        offerOrDiscounts:
          "Check for current offers and discounts with the distributor.",
      },
      {
        allover: "SEDRATE PRO",
        id: "5",
        slug: 'sedrate-pro',
        coverImg: SedrateProGrey,
        image: [
          { src: SedratePro1, alt: "Sedrate Pro ESR analyzer - front view" },
          { src: SedratePro2, alt: "Sedrate Pro ESR analyzer - side view" },
          { src: SedratePro3, alt: "Sedrate Pro ESR analyzer - close-up controls" },
        ],
        title: "SEDRATE PRO",
        section: "esr-analyzer",

        shortdescription:
          "An advanced ESR analyzer for accurate and rapid erythrocyte sedimentation rate (ESR) testing.",
        description:
          "The Sedrate pro ESR Analyzer is a fully automated solution designed to deliver quick and accurate erythrocyte sedimentation rate (ESR) results. It features advanced technology, providing test results in just 20 minutes with a minimum 1.5ml sample volume. Ideal for laboratories seeking efficiency and reliability, it operates using primary EDTA tubes and requires no disposables.",

        workPrinciple: (
          <div>
            <table className="min-w-full table-auto">
              <tbody className="flex flex-col gap-4">
                <tr>
                  <td className="  text-black">
                    <strong className="text-xs tablet:text-sm font-semibold largeLaptop:text-lg ">
                      Working Principle: How It Works? <br />
                    </strong>
                    <span className="text-sm">The SedRate Pro directly measures ESR by analyzing the
                      sedimentation of red blood cells in EDTA tubes. The device
                      tracks this process in real-time and delivers precise
                      results in 20 minutes. With options for random or cycle
                      operation, it ensures flexibility for diverse diagnostic
                      needs.</span>
                  </td>
                </tr>
                <tr>
                  <td className="  text-black">
                    <strong className="text-xs tablet:text-sm font-semibold largeLaptop:text-lg ">
                      For Whom It Is Useful? <br />
                    </strong>
                    <span className="text-sm">Ideal for laboratories, clinics, and hospitals conducting
                      ESR tests.</span>
                  </td>
                </tr>
                <tr>
                  <td className="  text-black">
                    <strong className="text-xs tablet:text-sm font-semibold largeLaptop:text-lg ">
                      Use Cases:
                    </strong>
                    <ul className="list-disc pl-5 ">
                      <li>
                        <span className="text-sm">Diagnosis of conditions like arthritis, infections, and
                          autoimmune disorders.</span>
                      </li>
                      <li>
                        <span className="text-sm">Tracking treatment progress through ESR measurements.</span>
                      </li>
                    </ul>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        ),

        advantages: (
          <div>
            <ul className="space-y-6 font-poppins">
              <li className="flex gap-3">
                <p className="text-sm largeLaptop:text-2xl font-medium text-gray-800">
                  <span className="text-[#10b981]">◆</span> Quick Results:
                  Provides results within 20 minutes.
                </p>
              </li>
              <li className="flex gap-3">
                <p className="text-sm largeLaptop:text-2xl font-medium text-gray-800">
                  <span className="text-[#10b981]">◆</span> Accuracy: Adheres to
                  the gold-standard Westergren method.
                </p>
              </li>
              <li className="flex gap-3">
                <p className="text-sm largeLaptop:text-2xl font-medium text-gray-800">
                  <span className="text-[#10b981]">◆</span> User-Friendly:
                  Intuitive LCD touchscreen for easy operation.
                </p>
              </li>
              <li className="flex gap-3">
                <p className="text-sm largeLaptop:text-2xl font-medium text-gray-800">
                  <span className="text-[#10b981]">◆</span> Versatility:
                  Available in 8, 16, or 32 sample positions for varied lab
                  requirements.
                </p>
              </li>
              <li className="flex gap-3">
                <p className="text-sm largeLaptop:text-2xl font-medium text-gray-800">
                  <span className="text-[#10b981]">◆</span> Integrated Features:
                  Built-in barcode reader, thermal printer, and LIS
                  compatibility.
                </p>
              </li>
            </ul>
          </div>
        ),

        benefits: (
          <div>
            <ul className="space-y-6 font-poppins">
              <li className="flex gap-3">
                <p className="text-sm largeLaptop:text-2xl font-medium text-gray-800">
                  <span className="text-[#10b981]">◆</span> Saves time and
                  reduces manual handling with direct sample loading.
                </p>
              </li>
              <li className="flex gap-3">
                <p className="text-sm largeLaptop:text-2xl font-medium text-gray-800">
                  <span className="text-[#10b981]">◆</span> Offers real-time
                  sedimentation curve monitoring for precise interpretation.
                </p>
              </li>
              <li className="flex gap-3">
                <p className="text-sm largeLaptop:text-2xl font-medium text-gray-800">
                  <span className="text-[#10b981]">◆</span> Compact design fits
                  into laboratories with limited space.
                </p>
              </li>
              <li className="flex gap-3">
                <p className="text-sm largeLaptop:text-2xl font-medium text-gray-800">
                  <span className="text-[#10b981]">◆</span> Ensures robust data
                  management through bidirectional LIS connectivity.
                </p>
              </li>
            </ul>
          </div>
        ),

        testMenu: [""],
        mainAndCare: (
          <div>
            <ul className="space-y-6 font-poppins">
              <li className="flex gap-3">
                <p className="text-sm largeLaptop:text-2xl font-medium text-gray-800">
                  <span className="text-[#10b981]">◆</span> Clean the
                  touchscreen interface regularly with a soft cloth.
                </p>
              </li>
              <li className="flex gap-3">
                <p className="text-sm largeLaptop:text-2xl font-medium text-gray-800">
                  <span className="text-[#10b981]">◆</span> Use the built-in QC
                  options to ensure consistent performance.
                </p>
              </li>
              <li className="flex gap-3">
                <p className="text-sm largeLaptop:text-2xl font-medium text-gray-800">
                  <span className="text-[#10b981]">◆</span> Store the analyzer
                  in a dry, dust-free environment.
                </p>
              </li>
              <li className="flex gap-3">
                <p className="text-sm largeLaptop:text-2xl font-medium text-gray-800">
                  <span className="text-[#10b981]">◆</span> Follow the
                  manufacturer’s guidelines for routine calibration and upkeep.
                </p>
              </li>
            </ul>
          </div>
        ),

        workServices:
          "Technical support and training are available for seamless integration into laboratory workflows. Service plans include annual maintenance and on-demand repair services.",
        productBrochure: "https://example.com/sedrate-pro-brochure",
        detailedSpecification:
          "Dimensions: 45 x 30 x 35 cm \nWeight: 12 kg \nSample Capacity: 20 tubes \nMethod: Westergren \nThroughput: 60 samples/hour",
        offerOrDiscounts:
          "Special discounts available for bulk purchases and long-term service contracts.",
      },
      {
        allover: "5 Part Hematology Analyzer",
        id: "6",
        slug: 'dynacount-5d-pro',
        coverImg: DYNACOUNT5DPROgrey,
        image: [
          { src: DYNACOUNT5DPRO, alt: "Dynacount 5D Pro hematology analyzer with 5-part differential capability" },
          { src: DYNACOUNT5DFront, alt: "Dynacount 5D Pro hematology analyzer with 5-part differential capability" },
          { src: DYNACOUNT5DRight, alt: "Dynacount 5D Pro hematology analyzer with 5-part differential capability" },
          { src: DYNACOUNT5DFrontView, alt: "Dynacount 5D Pro hematology analyzer with 5-part differential capability" },
        ],
        title: "Dynacount 5D PRO",
        section: "5-part",
        shortdescription:
          "Dynacount 5D PRO is a differential hematology analyzer and is an advanced diagnostic system that automates the sample loading process, allowing for continuous analysis of multiple blood samples without manual intervention. It provides a comprehensive breakdown of red blood cells (RBCs), white blood cells (WBCs), including five WBC subtypes, and platelets.",
        description: `The Dynacount 5D PRO is an advanced 5-part differential hematology analyzer designed for high-throughput laboratories. It delivers accurate and consistent results with minimal manual input. 
        `,
        description1: `Reliable & Repeatable Results: Precision-engineered for consistent cell differentiation and reproducible outcomes in every run.`,
        descriptionnext: `Ideal for busy clinical settings, the Dynacount 5DPRO optimizes efficiency without compromising diagnostic accuracy. `,
        workPrinciple: (
          <div>
            {/* Working Principle Table */}
            <table className="min-w-full table-auto">
              <tbody className="flex flex-col gap-4">
                <tr>
                  <td className="  text-black">

                    <span className="text-sm tablet:text-sm largeLaptop:text-xl">
                      {" "}
                      <li>
                        <strong>Flow Cytometry-Based Analysis:</strong> <span className="text-sm tablet:text-lg leading-7">Uses laser-based flow cytometry to measure physical and chemical characteristics of cells, allowing precise differentiation of white blood cell subtypes.</span>
                      </li>
                      <br />
                      <li>
                        <strong>Laser Scatter:</strong> <span className="text-sm tablet:text-lg leading-7">Cells passed through a laser beam, and their light scatter patterns are analyzed to classify WBCs into five types: neutrophils, lymphocytes, monocytes, eosinophils, and basophils.</span>
                      </li>
                      <br />
                      <span className="text-sm tablet:text-sm largeLaptop:text-xl font-bold">
                        Electrical Impedance for RBC & PLT:
                      </span>
                    </span>{" "}
                    <br />
                    <span className="text-sm tablet:text-lg leading-7">
                      The analyzer uses the electrical impedance method to count and determine the size of red blood cells (RBCs), white blood cells (WBCs), and platelets (PLTs). As cells pass through an aperture, changes in impedance are measured to quantify and differentiate them based on volume.
                    </span>
                  </td>
                </tr>
                <tr>
                  <td className="text-black">
                    <strong className="text-sm tablet:text-sm largeLaptop:text-xl font-bold">
                      {" "}
                      Colorimetry for Hemoglobin Measurement
                    </strong>{" "}
                    <br />
                    <span className="text-sm tablet:text-lg leading-7">
                      For hemoglobin (HGB) estimation, the analyzer employs the colorimetric method. Blood is mixed with a reagent that lyses the red blood cells and converts hemoglobin into a stable-colored compound, which is then measured photometrically. {" "}
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        ),

        advantages: (
          <div>
            {/* Advantages List */}
            <ul className="space-y-6 font-poppins">
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> 8 Research parameters: LIC#%, NRBC#%, NLR, PLRLR, ALY#%
                </p>
              </li>
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> 3D scattergram for enhanced visibility and deeper analysis
                </p>
              </li>
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> 100,000 result storage capacity
                </p>
              </li>
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> 3D view scattergram for better visibility and analysis
                </p>
              </li>
            </ul>
          </div>
        ),

        benefits: (
          <div>
            {/* Benefits List */}
            <ul className="space-y-6 font-poppins">
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span>  Provides accurate and reliable hematological analysis
                </p>
              </li>
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Increases efficiency in laboratory workflows
                </p>
              </li>
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Minimizes manual intervention, reducing the risk of errors
                </p>
              </li>
            </ul>
          </div>
        ),

        testMenu: [""],
        mainAndCare: (
          <div>
            {/* Maintenance and Care List */}
            <ul className="space-y-6 font-poppins">
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> <strong>Regular Calibration:</strong> Ensure periodic calibration to maintain accuracy.
                </p>
              </li>
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> <strong>Routine Cleaning:</strong> Clean sample probes and internal components regularly.
                </p>
              </li>
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> <strong>Software Updates:</strong> Keep software updated for enhanced features and performance.
                </p>
              </li>
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> <strong>Preventive Maintenance:</strong> Schedule regular maintenance checks by certified technicians to ensure optimal performance.
                </p>
              </li>
            </ul>
          </div>
        ),

        workServices:
          "Comprehensive technical support available for installation and troubleshooting.",
        productBrochure: "path/to/dynacount-3d-plus-brochure.pdf",
        detailedSpecification:
          "Detailed specifications can be provided upon request.",
        offerOrDiscounts: "Inquire about current promotions and discounts.",
      },
      {
        allover: "5 Part Hematology Analyzer",
        id: "7",
        slug: 'dynacount-5d-elite',
        section: "5-part",
        coverImg: DYNACOUNT5DElitegrey,
        image: [

          { src: DYNACOUNT5DElitefront, alt: "Dynacount 5D Elite advanced 5-part hematology analyzer for labs" },
          { src: DYNACOUNT5DEliteright, alt: "Dynacount 5D Elite advanced 5-part hematology analyzer for labs" },
          { src: DYNACOUNT5DElite, alt: "Dynacount 5D Elite advanced 5-part hematology analyzer for labs" },
        ],
        title: "Dynacount 5D ELITE",
        shortdescription:
          "Dynacount 5D ELITE is a differential hematology analyzer with an autoloader. It is an advanced diagnostic system that automates the sample loading process, allowing for continuous analysis of multiple blood samples without manual intervention. It provides a comprehensive breakdown of red blood cells (RBCs), white blood cells (WBCs), including five WBC subtypes, and platelets. ",
        description: `The Dynacount 5D ELITE is an advanced 5-part differential hematology analyzer designed for high-throughput laboratories. Equipped with an autoloader and barcode scanner, it delivers accurate and consistent results with minimal manual input.  
        `,
        description1: `High Sample Throughput: Automated sample loading enables continuous processing of large batches, boosting lab productivity. `,
        description2: `Reduced Human Error: Barcode-based identification and auto-sampling minimize manual handling and ensure data integrity. `,
        description3: `Reliable & Repeatable Results: Precision-engineered for consistent cell differentiation and reproducible outcomes in every run. `,
        descriptionnext: `Ideal for busy clinical settings, the Dynacount 5D ELITE optimizes efficiency without compromising diagnostic accuracy. `,
        workPrinciple: (
          <div>
            {/* Working Principle Table */}
            <table className="min-w-full table-auto">
              <tbody className="flex flex-col gap-4">
                <tr>
                  <td className="  text-black">

                    <span className="text-xs tablet:text-sm largeLaptop:text-xl ">
                      {" "}
                      <li>
                        <strong>Flow Cytometry-Based Analysis:</strong> <span className="text-sm leading-7">Uses laser-based flow cytometry to measure physical and chemical characteristics of cells, allowing precise differentiation of white blood cell subtypes.</span>
                      </li>
                      <br />
                      <li>
                        <strong>Laser Scatter:</strong> <span className="text-sm leading-7">cells passed through a laser beam, and their light scatter patterns are analyzed to classify WBCs into five types: neutrophils, lymphocytes, monocytes, eosinophils, and basophils.</span>
                      </li>
                      <br />
                      <span className="font-semibold tablet:text-sm largeLaptop:text-2xl  text-xs">
                        Electrical Impedance for RBC & PLT:
                      </span>
                    </span>{" "}
                    <br />
                    <span className="text-sm">
                      The analyzer uses the electrical impedance method to count and determine the size of red blood cells (RBCs), white blood cells (WBCs), and platelets (PLTs). As cells pass through an aperture, changes in impedance are measured to quantify and differentiate them based on volume.
                    </span>
                  </td>
                </tr>
                <tr>
                  <td className="text-black">
                    <strong className="text-xs tablet:text-sm font-semibold largeLaptop:text-lg ">
                      {" "}
                      Colorimetry for Hemoglobin Measurement
                    </strong>{" "}
                    <br />
                    <span className="text-sm">
                      For hemoglobin (HGB) estimation, the analyzer employs the colorimetric method. Blood is mixed with a reagent that lyses the red blood cells and converts hemoglobin into a stable-colored compound, which is then measured photometrically. {" "}
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        ),

        advantages: (
          <div>
            {/* Advantages List */}
            <ul className="space-y-6 font-poppins">
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> 12.1-inch touchscreen—for user convenience
                </p>
              </li>
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Intuitive system that simplifies your handling
                </p>
              </li>
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> 8 Research parameters LIC#%, NRBC#%, NLR, PLR, ALY#%
                </p>
              </li>
            </ul>
          </div>
        ),

        benefits: (
          <div>
            {/* Benefits List */}
            <ul className="space-y-6 font-poppins">
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span>  Provides accurate and reliable hematological analysis
                </p>
              </li>
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Increases efficiency in laboratory workflows
                </p>
              </li>
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Minimizes manual intervention, reducing the risk of errors
                </p>
              </li>
            </ul>
          </div>
        ),

        testMenu: [""],
        mainAndCare: (
          <div>
            {/* Maintenance and Care List */}
            <ul className="space-y-6 font-poppins">
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> <strong>Regular Calibration:</strong> Ensure periodic calibration to maintain accuracy.
                </p>
              </li>
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> <strong>Routine Cleaning:</strong> Clean sample probes and internal components regularly.
                </p>
              </li>
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> <strong>Software Updates:</strong> Keep software updated for enhanced features and performance.
                </p>
              </li>
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> <strong>Preventive Maintenance:</strong> Schedule regular maintenance checks by certified technicians to ensure optimal performance.
                </p>
              </li>
            </ul>
          </div>
        ),

        workServices:
          "Comprehensive technical support available for installation and troubleshooting.",
        productBrochure: "path/to/dynacount-3d-plus-brochure.pdf",
        detailedSpecification:
          "Detailed specifications can be provided upon request.",
        offerOrDiscounts: "Inquire about current promotions and discounts.",
      },
    ],
  },
  // Immunology
  {
    category: "Immunology",
    categoryURL: 'immunoassay-analyzer',
    subsection: [
      "Elisa",
      "Immunoblot",
      "IFA",
      "CLIA",
      "TRACE",
      "FIA",
      // "Reagents",
    ],

    items: [

      {
        id: "1",
        slug: 'plexmat-4',
        coverImg: PlexMAT4Grey,
        image: [

          { src: PlexMAT4, alt: "PlexMAT-4 Immunoblot Analyzer delivering high-quality western blot processing" },
        ],
        title: "PlexMAT 4",
        section: "immunoblot",
        // tagline:
        // "Compact multiplex Immunoblot processor in the diagnosis of ALLERGY, AUTOIMMUNE & INFECTION",
        description:
          "The PlexMAT 4 is an efficient and Compact multiplex Immunoblot processor designed for small to medium-sized laboratories. This automated western blot processor simplifies the immunoblotting process, offering reliable and consistent results for a variety of diagnostic tests, including ALLERGY, AUTOIMMUNE(ANA and liver profiles) & INFECTIONs. With its intuitive interface and space-saving design, the PlexMAT 4 enhances lab productivity while maintaining high standards of accuracy with the throughput of 4 tests in a single run.",
        shortdescription:
          "The PlexMAT 4 is an advanced western blot processor designed to bring automation and precision to immunoblotting processes in diagnostic laboratories. This compact system is ideal for laboratories handling a moderate volume of western blot tests. The PlexMAT 4 automates each step of the blotting process, from sample preparation to final detection, minimizing manual intervention and reducing the risk of errors. Its versatility makes it suitable for processing various test profiles, including ALLERGY, AUTOIMMUNE(ANA and liver profiles) & INFECTIONs, making it a reliable asset in immunodiagnostics..",
        workPrinciple: (
          <div>
            <table className="min-w-full table-auto">
              <tbody className="flex flex-col gap-4">
                <tr>
                  <td className="  text-black">   
                    <strong className="text-sm tablet:text-sm font-semibold largeLaptop:text-lg">
                      {" "}
                      Working Principle: How It Works? <br />
                    </strong>
                    <span className="text-sm">The PlexMAT 4 operates by automating the western blot
                      procedure, which involves separating proteins via gel
                      electrophoresis and transferring them to a membrane. This
                      membrane is then processed using automated steps, including
                      blocking, antibody incubation, washing, and detection. The
                      automation ensures that all steps are performed consistently
                      across all strips, providing reproducible and accurate
                      results. The system is designed to handle multiple strips
                      simultaneously, improving lab throughput and efficiency.</span>
                  </td>
                </tr>
                <tr>
                  <td className="  text-black">
                    <strong className="text-sm tablet:text-sm font-semibold largeLaptop:text-lg ">
                      {" "}
                      For Whom It Is Useful? <br />
                    </strong>
                    <span className="text-sm">The PlexMAT 4 is particularly beneficial for clinical
                      diagnostic laboratories, research institutions, and
                      specialized testing centers that require reliable western
                      blot processing but may have space or volume constraints. It
                      is ideal for labs conducting ANA test profiles, liver
                      profiles, and other immunoassays, offering a practical
                      solution to automate processes while ensuring high standards
                      of precision.</span>
                  </td>
                </tr>
                <tr>
                  <td className="  text-black">
                    <strong className="text-xs tablet:text-sm font-semibold largeLaptop:text-lg ">
                      {" "}
                      Use Cases:
                    </strong>
                    <ul className="list-disc pl-5 ">
                      <li>
                        <span className="text-sm">ANA Test Profile Processing: Automates the
                          immunoblotting process for antinuclear antibody tests,
                          aiding in the diagnosis of autoimmune diseases.</span>
                      </li>
                      <li>
                        <span className="text-sm">Liver Profile Diagnostics: Facilitates the detection of
                          liver-related biomarkers, enabling accurate diagnostics
                          for liver function and disease.</span>
                      </li>
                      <li>
                        <span className="text-sm">Infectious Disease Diagnostics: Supports the western
                          blot testing for various infectious diseases, providing
                          quick and reliable results.</span>
                      </li>
                      <li>
                        <span className="text-sm">Endocrine Function Testing: Processes hormonal profile
                          diagnostics efficiently, aiding in the detection of
                          endocrine disorders.</span>
                      </li>
                      <li>
                        <span className="text-sm">Oncology Diagnostics: Automates the detection of
                          cancer-related biomarkers, contributing to early
                          diagnosis and monitoring of cancer progression.</span>
                      </li>
                    </ul>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        ),

        advantages: (
          <div>
            <p className="text-sm largeLaptop:text-2xl font-medium text-gray-800 mb-4">
              {" "}
              Efficient Processing: Automates multiple steps in the western blot
              process, reducing manual labor and increasing lab productivity.
            </p>
            <ul className="space-y-6 font-poppins ml-4">
              <li className="flex gap-3">
                <p className="text-sm largeLaptop:text-2xl font-medium text-gray-800">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Compact and
                  Space-Saving: Ideal for labs with limited space, the PlexMAT 4
                  offers full functionality without taking up too much room.
                </p>
              </li>
              <li className="flex gap-3">
                <p className="text-sm largeLaptop:text-2xl font-medium text-gray-800">
                  {" "}
                  <span className="text-[#10b981]">◆</span> High Accuracy:
                  Automation ensures consistent and precise results, improving
                  diagnostic accuracy across a variety of tests.
                </p>
              </li>
              <li className="flex gap-3">
                <p className="text-sm largeLaptop:text-2xl font-medium text-gray-800">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Versatile Testing:
                  Supports a broad range of assays, including autoimmune and
                  liver profiles, making it adaptable to various lab needs.
                </p>
              </li>
              <li className="flex gap-3">
                <p className="text-sm largeLaptop:text-2xl font-medium text-gray-800">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Scalable Solution:
                  Capable of processing up to 4 strips simultaneously, making it
                  suitable for labs with moderate testing volumes.
                </p>
              </li>
            </ul>
            <div className="mt-4">
              <p className="text-sm largeLaptop:text-2xl font-medium text-gray-800 mb-4">
                {" "}
                EUROline Scan - Software
              </p>
              <ul className="space-y-6 font-poppins ml-4">
                <li className="flex gap-3">
                  <p className="text-sm largeLaptop:text-2xl font-medium text-gray-800">
                    {" "}
                    <span className="text-[#10b981]">◆</span> User friendly
                  </p>
                </li>
                <li className="flex gap-3">
                  <p className="text-sm largeLaptop:text-2xl font-medium text-gray-800">
                    {" "}
                    <span className="text-[#10b981]">◆</span>Easy result
                    interpretation
                  </p>
                </li>
                <li className="flex gap-3">
                  <p className="text-sm largeLaptop:text-2xl font-medium text-gray-800">
                    {" "}
                    <span className="text-[#10b981]">◆</span>High Quality
                    standard reporting
                  </p>
                </li>
              </ul>
            </div>
          </div>
        ),

        benefits: (
          <div>
            <p className="text-sm largeLaptop:text-2xl font-medium text-gray-800 mb-4">
              {" "}
              Increased Productivity: The automated workflow allows lab
              technicians to focus on other tasks while the PlexMAT 4 handles
              western blot processing, enhancing overall efficiency.
            </p>
            <ul className="space-y-6 font-poppins ml-4">
              <li className="flex gap-3">
                <p className="text-sm largeLaptop:text-2xl font-medium text-gray-800">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Consistent Results:
                  The automated system ensures uniform processing across all
                  strips, delivering reliable and reproducible results every
                  time.
                </p>
              </li>
              <li className="flex gap-3">
                <p className="text-sm largeLaptop:text-2xl font-medium text-gray-800">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Cost-Effective
                  Operation: By reducing manual intervention and minimizing
                  errors, the PlexMAT 4 helps lower operational costs and
                  improve lab efficiency.
                </p>
              </li>
              <li className="flex gap-3">
                <p className="text-sm largeLaptop:text-2xl font-medium text-gray-800">
                  {" "}
                  <span className="text-[#10b981]">◆</span> User-Friendly
                  Design: The intuitive touchscreen interface simplifies
                  operation, reducing the need for extensive training and making
                  the system accessible to all lab staff.
                </p>
              </li>
              <li className="flex gap-3">
                <p className="text-sm largeLaptop:text-2xl font-medium text-gray-800">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Multi-Test
                  Capability: The ability to handle a variety of test profiles,
                  from ANA to liver diagnostics, makes the PlexMAT 4 a versatile
                  addition to any lab.
                </p>
              </li>
            </ul>
          </div>
        ),

        testMenu: [""],
        mainAndCare: (
          <div>
            <p className="text-sm largeLaptop:text-2xl font-medium text-gray-800 mb-4">
              {" "}
              Routine Calibration: Regular calibration ensures that the PlexMAT
              4 maintains its accuracy and reliability over time.
            </p>
            <ul className="space-y-6 font-poppins ml-4">
              <li className="flex gap-3">
                <p className="text-sm largeLaptop:text-2xl font-medium text-gray-800">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Automated
                  Maintenance Alerts: The system provides automatic
                  notifications for maintenance tasks, ensuring timely upkeep.
                </p>
              </li>
              <li className="flex gap-3">
                <p className="text-sm largeLaptop:text-2xl font-medium text-gray-800">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Easy Access for
                  Servicing: The PlexMAT 4 is designed for easy access to
                  internal components, making maintenance and repairs
                  straightforward and efficient.
                </p>
              </li>
              <li className="flex gap-3">
                <p className="text-sm largeLaptop:text-2xl font-medium text-gray-800">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Minimal Downtime:
                  Built for durability, the PlexMAT 4 ensures continuous
                  operation with minimal maintenance interruptions.
                </p>
              </li>
              <li className="flex gap-3">
                <p className="text-sm largeLaptop:text-2xl font-medium text-gray-800">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Comprehensive
                  Support: Supported by CPC Diagnostics' technical team,
                  ensuring optimal performance and long-term reliability.
                </p>
              </li>
            </ul>
          </div>
        ),
        workServices:
          "Technical support available for installation and troubleshooting.",
        productBrochure: "path/to/PlexMAT-4-brochure.pdf",
        detailedSpecification: "Specifications can be provided upon request.",
        offerOrDiscounts:
          "Check with distributor for current promotions and discounts.",
      },
      {
        id: "2",
        slug: 'plexmat-8',
        coverImg: PlexMAT8Grey,

        image: [

          { src: PlexMAT8, alt: "PlexMAT-8 Immunoblot Analyzer delivering high-quality western blot processing" },
        ],
        title: "PlexMAT 8",
        section: "immunoblot",
        shortdescription:
          "The PlexMAT 8 is a cutting-edge immunoblot processor designed to automate and streamline the western blot process in clinical and diagnostic laboratories. This automated western blot processor offers high precision and efficiency, handling up to 8 strips simultaneously. Its automation capabilities significantly reduce manual handling, ensuring consistency and reproducibility across all samples. The PlexMAT 8 is particularly useful for processing complex diagnostic profiles, such as ANA (antinuclear antibody) tests and liver function profiles, making it a versatile tool in immunodiagnostics.",
        description:
          "The PlexMAT 8 is an advanced immunoblot processor designed for fully automated western blot processing. It provides accurate, reliable, and high-throughput results for a range of diagnostic profiles, including ANA and liver tests. This automated western blot processor is ideal for laboratories seeking precision and efficiency in processing multiple samples simultaneously.",
        workPrinciple: (
          <div>
            <table className="min-w-full table-auto">
              <tbody className="flex flex-col gap-4">
                <tr>
                  <td className="  text-black">
                    <strong className="text-xs tablet:text-sm font-semibold largeLaptop:text-lg ">
                      {" "}
                      Working Principle: How It Works? <br />
                    </strong>
                    <span className="text-sm">The PlexMAT 8 operates by automating the western blot
                      procedure, which involves separating proteins via gel
                      electrophoresis and transferring them to a membrane. This
                      membrane is then processed using automated steps, including
                      blocking, antibody incubation, washing, and detection. The
                      automation ensures that all steps are performed consistently
                      across all strips, providing reproducible and accurate
                      results. The system is designed to handle multiple strips
                      simultaneously, improving lab throughput and efficiency.</span>
                  </td>
                </tr>
                <tr>
                  <td className="  text-black">
                    <strong className="text-xs tablet:text-sm font-semibold largeLaptop:text-lg ">
                      {" "}
                      For Whom It Is Useful? <br />
                    </strong>
                    <span className="text-sm">The PlexMAT 8 is particularly beneficial for clinical
                      diagnostic laboratories, research institutions, and
                      specialized testing centers that require reliable western
                      blot processing but may have space or volume constraints. It
                      is ideal for labs conducting ANA test profiles, liver
                      profiles, and other immunoassays, offering a practical
                      solution to automate processes while ensuring high standards
                      of precision.</span>
                  </td>
                </tr>
                <tr>
                  <td className="  text-black">
                    <strong className="text-xs tablet:text-sm font-semibold largeLaptop:text-lg ">
                      {" "}
                      Use Cases:
                    </strong>
                    <ul className="list-disc pl-5 ">
                      <li>
                        <span className="text-sm">ANA Test Profile Processing: Automates the
                          immunoblotting process for antinuclear antibody tests,
                          aiding in the diagnosis of autoimmune diseases.</span>
                      </li>
                      <li>
                        <span className="text-sm">Liver Profile Diagnostics: Facilitates the detection of
                          liver-related biomarkers, enabling accurate diagnostics
                          for liver function and disease.</span>
                      </li>
                      <li>
                        <span className="text-sm">Infectious Disease Diagnostics: Supports the western
                          blot testing for various infectious diseases, providing
                          quick and reliable results.</span>
                      </li>
                      <li>
                        <span className="text-sm">Endocrine Function Testing: Processes hormonal profile
                          diagnostics efficiently, aiding in the detection of
                          endocrine disorders.</span>
                      </li>
                      <li>
                        <span className="text-sm">Oncology Diagnostics: Automates the detection of
                          cancer-related biomarkers, contributing to early
                          diagnosis and monitoring of cancer progression.</span>
                      </li>
                    </ul>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        ),

        advantages: (
          <div>
            <p className="text-sm largeLaptop:text-2xl font-medium text-gray-800 mb-4">
              {" "}
              Efficient Processing: Automates multiple steps in the western blot
              process, reducing manual labor and increasing lab productivity.
            </p>
            <ul className="space-y-6 font-poppins ml-4">
              <li className="flex gap-3">
                <p className="text-sm largeLaptop:text-2xl font-medium text-gray-800">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Compact and
                  Space-Saving: Ideal for labs with limited space, the PlexMAT 8
                  offers full functionality without taking up too much room.
                </p>
              </li>
              <li className="flex gap-3">
                <p className="text-sm largeLaptop:text-2xl font-medium text-gray-800">
                  {" "}
                  <span className="text-[#10b981]">◆</span> High Accuracy:
                  Automation ensures consistent and precise results, improving
                  diagnostic accuracy across a variety of tests.
                </p>
              </li>
              <li className="flex gap-3">
                <p className="text-sm largeLaptop:text-2xl font-medium text-gray-800">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Versatile Testing:
                  Supports a broad range of assays, including autoimmune and
                  liver profiles, making it adaptable to various lab needs.
                </p>
              </li>
              <li className="flex gap-3">
                <p className="text-sm largeLaptop:text-2xl font-medium text-gray-800">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Scalable Solution:
                  Capable of processing up to 4 strips simultaneously, making it
                  suitable for labs with moderate testing volumes.
                </p>
              </li>
            </ul>
            <div className="mt-4">
              <p className="text-sm largeLaptop:text-2xl font-medium text-gray-800 mb-4">
                {" "}
                EUROline Scan - Software
              </p>
              <ul className="space-y-6 font-poppins ml-4">
                <li className="flex gap-3">
                  <p className="text-sm largeLaptop:text-2xl font-medium text-gray-800">
                    {" "}
                    <span className="text-[#10b981]">◆</span> User friendly
                  </p>
                </li>
                <li className="flex gap-3">
                  <p className="text-sm largeLaptop:text-2xl font-medium text-gray-800">
                    {" "}
                    <span className="text-[#10b981]">◆</span>Easy result
                    interpretation
                  </p>
                </li>
                <li className="flex gap-3">
                  <p className="text-sm largeLaptop:text-2xl font-medium text-gray-800">
                    {" "}
                    <span className="text-[#10b981]">◆</span>High Quality
                    standard reporting
                  </p>
                </li>
              </ul>
            </div>
          </div>
        ),

        benefits: (
          <div>
            <p className="text-sm largeLaptop:text-2xl font-medium text-gray-800 mb-4">
              {" "}
              Increased Productivity: The automated workflow allows lab
              technicians to focus on other tasks while the PlexMAT 8 handles
              western blot processing, enhancing overall efficiency.
            </p>
            <ul className="space-y-6 font-poppins ml-4">
              <li className="flex gap-3">
                <p className="text-sm largeLaptop:text-2xl font-medium text-gray-800">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Consistent Results:
                  The automated system ensures uniform processing across all
                  strips, delivering reliable and reproducible results every
                  time.
                </p>
              </li>
              <li className="flex gap-3">
                <p className="text-sm largeLaptop:text-2xl font-medium text-gray-800">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Cost-Effective
                  Operation: By reducing manual intervention and minimizing
                  errors, the PlexMAT 8 helps lower operational costs and
                  improve lab efficiency.
                </p>
              </li>
              <li className="flex gap-3">
                <p className="text-sm largeLaptop:text-2xl font-medium text-gray-800">
                  {" "}
                  <span className="text-[#10b981]">◆</span> User-Friendly
                  Design: The intuitive touchscreen interface simplifies
                  operation, reducing the need for extensive training and making
                  the system accessible to all lab staff.
                </p>
              </li>
              <li className="flex gap-3">
                <p className="text-sm largeLaptop:text-2xl font-medium text-gray-800">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Multi-Test
                  Capability: The ability to handle a variety of test profiles,
                  from ANA to liver diagnostics, makes the PlexMAT 8 a versatile
                  addition to any lab.
                </p>
              </li>
            </ul>
          </div>
        ),

        testMenu: [""],
        mainAndCare: (
          <div>
            <p className="text-sm largeLaptop:text-2xl font-medium text-gray-800 mb-4">
              {" "}
              Routine Calibration: Regular calibration ensures that the PlexMAT
              8 maintains its accuracy and reliability over time.
            </p>
            <ul className="space-y-6 font-poppins ml-4">
              <li className="flex gap-3">
                <p className="text-sm largeLaptop:text-2xl font-medium text-gray-800">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Automated
                  Maintenance Alerts: The system provides automatic
                  notifications for maintenance tasks, ensuring timely upkeep.
                </p>
              </li>
              <li className="flex gap-3">
                <p className="text-sm largeLaptop:text-2xl font-medium text-gray-800">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Easy Access for
                  Servicing: The PlexMAT 8 is designed for easy access to
                  internal components, making maintenance and repairs
                  straightforward and efficient.
                </p>
              </li>
              <li className="flex gap-3">
                <p className="text-sm largeLaptop:text-2xl font-medium text-gray-800">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Minimal Downtime:
                  Built for durability, the PlexMAT 8 ensures continuous
                  operation with minimal maintenance interruptions.
                </p>
              </li>
              <li className="flex gap-3">
                <p className="text-sm largeLaptop:text-2xl font-medium text-gray-800">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Comprehensive
                  Support: Supported by CPC Diagnostics' technical team,
                  ensuring optimal performance and long-term reliability.
                </p>
              </li>
            </ul>
          </div>
        ),
        workServices: "Comprehensive technical support provided.",
        productBrochure: "path/to/PlexMAT-8-brochure.pdf",
        detailedSpecification: "Detailed specs available on request.",
        offerOrDiscounts: "Inquire about current offers with the distributor.",
      },
      //missing cover pic
      // {
      //   id: "3",
      //   image: [brahms],
      //   coverImg: brahmsGrey,
      //   title: "B·R·A·H·M·S",
      //   section: "immunoblot",
      //   shortdescription:
      //     "The BRAHMS Biomarkers system is an advanced diagnostic solution designed for accurate prenatal screening and critical disease detection. This prenatal screening instrument provides fast and reliable results by identifying key biomarkers in patient samples. Ideal for modern laboratories, the BRAHMS Biomarkers system ensures consistent accuracy, making it an essential tool for early diagnosis and effective patient management.",
      //   description:
      //     "The BRAHMS Biomarkers system is a sophisticated prenatal screening instrument that offers precise detection of biomarkers crucial for early diagnosis in various medical conditions, including prenatal abnormalities and infections. This advanced diagnostic equipment is designed to meet the demands of high-throughput laboratories, ensuring fast, reliable, and accurate results. With its automated workflow and versatile test menu, the BRAHMS Biomarkers system plays a critical role in clinical diagnostics, supporting both prenatal and general disease screening applications.",
      //   workPrinciple: (
      //     <div>
      //       <table className="min-w-full table-auto">
      //         <tbody className="flex flex-col gap-4">
      //           <tr>
      //             <td className="  text-black">
      //               <strong className="text-xs tablet:text-sm font-semibold largeLaptop:text-lg ">
      //                 {" "}
      //                 Working Principle: How It Works? <br/>
      //               </strong>
      //               The BRAHMS Biomarkers system operates by detecting specific
      //               biomarkers in biological samples using advanced immunoassay
      //               technology. Biomarkers are measured through sensitive and
      //               specific assays that detect and quantify proteins, hormones,
      //               and other substances associated with various diseases. The
      //               system automates the sample preparation, incubation, and
      //               detection processes, minimizing manual intervention and
      //               ensuring consistent accuracy. Once biomarkers are detected,
      //               results are generated quickly, aiding in timely clinical
      //               decision-making, particularly in prenatal care.
      //             </td>
      //           </tr>
      //           <tr>
      //             <td className="  text-black">
      //               <strong className="text-xs tablet:text-sm font-semibold largeLaptop:text-lg ">
      //                 {" "}
      //                 For Whom It Is Useful? <br/>
      //               </strong>
      //               The BRAHMS Biomarkers system is ideal for clinical
      //               diagnostic laboratories, hospital labs, and specialized
      //               testing centers that require efficient and accurate
      //               biomarker detection. This system is particularly beneficial
      //               for labs performing prenatal screening, where early
      //               detection of abnormalities is crucial for patient care. It
      //               is also valuable for labs conducting research and
      //               diagnostics in infectious diseases, oncology, and
      //               endocrinology.
      //             </td>
      //           </tr>
      //           <tr>
      //             <td className="  text-black">
      //               <strong className="text-xs tablet:text-sm font-semibold largeLaptop:text-lg ">
      //                 {" "}
      //                 Use Cases:
      //               </strong>
      //               <ul className="list-disc pl-5 ">
      //                 <li>
      //                   Prenatal Screening: Detects biomarkers related to fetal
      //                   development, helping to identify potential genetic
      //                   abnormalities or other prenatal conditions.
      //                 </li>
      //                 <li>
      //                   Infectious Disease Diagnostics: Provides rapid and
      //                   accurate identification of biomarkers associated with
      //                   infectious diseases, supporting timely treatment.
      //                 </li>
      //                 <li>
      //                   Oncology Testing: Detects cancer-related biomarkers,
      //                   aiding in early diagnosis and monitoring of cancer
      //                   progression.
      //                 </li>
      //                 <li>
      //                   Endocrine Function Testing: Measures hormonal
      //                   biomarkers, providing insights into endocrine system
      //                   health and helping diagnose conditions such as thyroid
      //                   disorders.
      //                 </li>
      //                 <li>
      //                   Sepsis Detection: Quickly identifies procalcitonin and
      //                   other biomarkers associated with sepsis, enabling rapid
      //                   intervention in critical care settings.
      //                 </li>
      //               </ul>
      //             </td>
      //           </tr>
      //         </tbody>
      //       </table>
      //     </div>
      //   ),

      //   advantages: (
      //     <div>
      //       <ul className="space-y-6 font-poppins">
      //         <li className="flex gap-3">
      //           <p className="text-sm largeLaptop:text-2xl font-medium text-gray-800">
      //             {" "}
      //             <span className="text-[#10b981]">◆</span> High Sensitivity:
      //             Accurately detects even low levels of biomarkers, ensuring
      //             early diagnosis and better patient outcomes.
      //           </p>
      //         </li>
      //         <li className="flex gap-3">
      //           <p className="text-sm largeLaptop:text-2xl font-medium text-gray-800">
      //             {" "}
      //             <span className="text-[#10b981]">◆</span> Automated
      //             Efficiency: Reduces the need for manual labor, streamlining
      //             lab processes and minimizing the risk of human error.
      //           </p>
      //         </li>
      //         <li className="flex gap-3">
      //           <p className="text-sm largeLaptop:text-2xl font-medium text-gray-800">
      //             {" "}
      //             <span className="text-[#10b981]">◆</span> Versatile
      //             Application: Supports a broad range of diagnostic tests,
      //             making it adaptable to various medical fields, including
      //             prenatal care.
      //           </p>
      //         </li>
      //         <li className="flex gap-3">
      //           <p className="text-sm largeLaptop:text-2xl font-medium text-gray-800">
      //             {" "}
      //             <span className="text-[#10b981]">◆</span> Scalable: Capable of
      //             handling both small and large sample volumes, making it
      //             suitable for labs with varying testing demands.
      //           </p>
      //         </li>
      //         <li className="flex gap-3">
      //           <p className="text-sm largeLaptop:text-2xl font-medium text-gray-800">
      //             {" "}
      //             <span className="text-[#10b981]">◆</span> Cost-Effective:
      //             Automation and high accuracy reduce the need for repeat tests,
      //             lowering overall operational costs.
      //           </p>
      //         </li>
      //       </ul>
      //     </div>
      //   ),

      //   benefits: (
      //     <div>
      //       <ul className="space-y-6 font-poppins">
      //         <li className="flex gap-3">
      //           <p className="text-sm largeLaptop:text-2xl font-medium text-gray-800">
      //             {" "}
      //             <span className="text-[#10b981]">◆</span> Improved Diagnostic
      //             Accuracy: High sensitivity and specificity ensure reliable
      //             results, enhancing the quality of patient care.
      //           </p>
      //         </li>
      //         <li className="flex gap-3">
      //           <p className="text-sm largeLaptop:text-2xl font-medium text-gray-800">
      //             {" "}
      //             <span className="text-[#10b981]">◆</span> Faster Turnaround
      //             Times: Automated processes enable quick results, allowing for
      //             prompt clinical decision-making and treatment.
      //           </p>
      //         </li>
      //         <li className="flex gap-3">
      //           <p className="text-sm largeLaptop:text-2xl font-medium text-gray-800">
      //             {" "}
      //             <span className="text-[#10b981]">◆</span> User-Friendly
      //             Operation: The intuitive interface and automated features make
      //             the system easy to use, reducing training time and operational
      //             complexity.
      //           </p>
      //         </li>
      //         <li className="flex gap-3">
      //           <p className="text-sm largeLaptop:text-2xl font-medium text-gray-800">
      //             {" "}
      //             <span className="text-[#10b981]">◆</span> Increased
      //             Productivity: With automated workflows and fast processing
      //             speeds, labs can handle more samples in less time, boosting
      //             productivity.
      //           </p>
      //         </li>
      //         <li className="flex gap-3">
      //           <p className="text-sm largeLaptop:text-2xl font-medium text-gray-800">
      //             {" "}
      //             <span className="text-[#10b981]">◆</span> Long-Term
      //             Reliability: Built for durability, the BRAHMS Biomarkers
      //             system requires minimal maintenance, ensuring consistent
      //             performance and uptime.
      //           </p>
      //         </li>
      //       </ul>
      //     </div>
      //   ),

      //   testMenu:[''],mainAndCare: (
      //     <div>
      //       <ul className="space-y-6 font-poppins">
      //         <li className="flex gap-3">
      //           <p className="text-sm largeLaptop:text-2xl font-medium text-gray-800">
      //             {" "}
      //             <span className="text-[#10b981]">◆</span> Routine Calibration:
      //             Regular calibration ensures that the system maintains its
      //             accuracy and reliability over time.
      //           </p>
      //         </li>
      //         <li className="flex gap-3">
      //           <p className="text-sm largeLaptop:text-2xl font-medium text-gray-800">
      //             {" "}
      //             <span className="text-[#10b981]">◆</span> Automated
      //             Maintenance Alerts: The system provides alerts for scheduled
      //             maintenance, ensuring timely upkeep without disrupting
      //             workflows.
      //           </p>
      //         </li>
      //         <li className="flex gap-3">
      //           <p className="text-sm largeLaptop:text-2xl font-medium text-gray-800">
      //             {" "}
      //             <span className="text-[#10b981]">◆</span> Easy Access for
      //             Servicing: Designed for easy access to internal components,
      //             making routine maintenance and repairs quick and efficient.
      //           </p>
      //         </li>
      //         <li className="flex gap-3">
      //           <p className="text-sm largeLaptop:text-2xl font-medium text-gray-800">
      //             {" "}
      //             <span className="text-[#10b981]">◆</span> Minimal Downtime:
      //             Engineered for durability and longevity, the BRAHMS Biomarkers
      //             system ensures continuous operation with minimal
      //             interruptions.
      //           </p>
      //         </li>
      //         <li className="flex gap-3">
      //           <p className="text-sm largeLaptop:text-2xl font-medium text-gray-800">
      //             {" "}
      //             <span className="text-[#10b981]">◆</span> Comprehensive
      //             Support: Supported by CPC Diagnostics' dedicated technical
      //             team, ensuring that your system operates at peak performance
      //             throughout its lifespan.
      //           </p>
      //         </li>
      //       </ul>
      //     </div>
      //   ),
      //   workServices: "Comprehensive technical support provided.",
      //   productBrochure: "path/to/PlexMAT-8-brochure.pdf",
      //   detailedSpecification: "Detailed specs available on request.",
      //   offerOrDiscounts: "Inquire about current offers with the distributor.",
      // },
      {
        id: "7",
        slug: 'iflash-3000',
        coverImg: Iflash3000Grey,
        image: [
          { src: Iflash30001, alt: "YHLO iFlash 3000 high-performance chemiluminescence analyzer for laboratories" },
          { src: Iflash30002, alt: "YHLO iFlash 3000 high-performance chemiluminescence analyzer for laboratories - side view" },
          { src: Iflash30003, alt: "YHLO iFlash 3000 high-performance chemiluminescence analyzer for laboratories - close-up controls" },
          { src: Iflash30004, alt: "YHLO iFlash 3000 high-performance chemiluminescence analyzer for laboratories - close-up controls" },
        ],
        title: "iFlash 3000",
        section: "clia",
        shortdescription:
          "The iFlash 3000 is a state-of-the-art fully automated immunoassay analyzer designed to meet the demands of modern diagnostic laboratories. Leveraging chemiluminescence technology, this CLIA analyser delivers precise and timely results for various assays, making it an essential tool for clinical diagnostics. Its robust construction and advanced automation features ensure that labs can manage high volumes of tests without compromising on accuracy or speed.",
        description:
          "The iFlash 3000 is a fully automated immunoassay analyzer designed for high-throughput laboratories seeking precision and efficiency in diagnostic testing. Utilizing advanced chemiluminescence technology, this CLIA analyser offers reliable and rapid results for a wide range of assays, including thyroid function tests. With its robust design, the iFlash 3000 is an ideal choice for labs that require consistent performance and ease of use.",
        workPrinciple: (
          <div>
            {/* Working Principle Table */}
            <table className="min-w-full table-auto">
              <tbody className="flex flex-col gap-4">
                <tr>
                  <td className="  text-black">
                    <strong className="text-wrap tablet:text-sm largelaptop:text-sm">
                      Working Principle:
                    </strong>{" "}
                    <span className="text-sm">The iFlash 3000 operates on the principle of
                      chemiluminescence, where light is emitted as a result of a
                      chemical reaction. In the context of immunoassays, this
                      reaction occurs when a target analyte in the sample binds to
                      specific antibodies coated on magnetic beads. These beads
                      are then separated and washed, and a chemiluminescent
                      substrate is added. The light emitted during this reaction
                      is measured, and the intensity is proportional to the
                      concentration of the analyte, providing highly accurate
                      results. The entire process is automated, from sample
                      loading to result generation, ensuring consistent and
                      reliable performance.</span>
                  </td>
                </tr>
                <tr>
                  <td className="  text-black">
                    <strong className="text-wrap tablet:text-sm largelaptop:text-sm">
                      For Whom It Is Useful:
                    </strong>{" "}
                    <span className="text-sm">The iFlash 3000 is ideal for clinical laboratories, hospital
                      labs, and diagnostic centers that require high-throughput
                      testing capabilities. It is particularly useful for
                      facilities that need to perform a wide range of
                      immunoassays, including thyroid function tests, tumor marker
                      detection, and infectious disease screening. Its automation
                      and efficiency make it a valuable asset for labs that need
                      to manage large volumes of samples with minimal manual
                      intervention.</span>
                  </td>
                </tr>
                <tr>
                  <td className="  text-black">
                    <strong className="text-wrap tablet:text-sm largelaptop:text-sm">
                      Use Cases:
                    </strong>
                    <ul className="list-disc pl-5 ">
                      <li>
                        <span className="text-sm">Thyroid Function Testing: The iFlash 3000 excels in
                          performing thyroid assays, providing accurate and rapid
                          results for TSH, T3, and T4 levels.</span>
                      </li>
                      <li>
                        <span className="text-sm">Tumor Marker Detection: Detects and quantifies various
                          tumor markers, aiding in the diagnosis and monitoring of
                          cancer.</span>
                      </li>
                      <li>
                        <span className="text-sm">Infectious Disease Screening: Efficiently screens for
                          infectious diseases, offering reliable results for HIV,
                          hepatitis, and other pathogens.</span>
                      </li>
                      <li>
                        <span className="text-sm">Hormonal Assays: Performs a wide range of hormonal
                          tests, including reproductive hormones and cortisol
                          levels.</span>
                      </li>
                      <li>
                        <span className="text-sm">Cardiac Marker Testing: Provides precise measurements of
                          cardiac markers, essential for assessing heart health.</span>
                      </li>
                    </ul>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        ),

        advantages: (
          <div>
            {/* Advantages List */}
            <ul className="space-y-6 font-poppins">
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> High Efficiency:
                  Processes large sample volumes quickly, making it suitable for
                  busy labs.
                </p>
              </li>
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Accuracy and
                  Reliability: Ensures consistent results with advanced
                  chemiluminescence technology.
                </p>
              </li>
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Broad Assay Range:
                  Supports a wide variety of diagnostic tests, catering to
                  diverse clinical needs.
                </p>
              </li>
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Ease of Use:
                  Features an intuitive interface and automated processes,
                  reducing the need for specialized training.
                </p>
              </li>
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Scalable: Can be
                  integrated into larger laboratory workflows, making it
                  adaptable to growing testing demands.
                </p>
              </li>
            </ul>
          </div>
        ),

        benefits: (
          <div>
            {/* Benefits List */}
            <ul className="space-y-6 font-poppins">
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Reduced Turnaround
                  Time: Rapid processing speeds lead to quicker results,
                  enhancing patient care.
                </p>
              </li>
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Improved Lab
                  Productivity: Automation reduces manual tasks, allowing lab
                  staff to focus on critical analyses.
                </p>
              </li>
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Cost-Effective:
                  Efficient resource usage and low maintenance requirements
                  result in overall cost savings.
                </p>
              </li>
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Enhanced Patient
                  Outcomes: Accurate and timely results contribute to better
                  diagnosis and treatment plans.
                </p>
              </li>
            </ul>
          </div>
        ),

        testMenu: [""],
        mainAndCare: (
          <div>
            {/* Maintenance and Care List */}
            <ul className="space-y-6 font-poppins">
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Routine Calibration:
                  Regular calibration ensures the analyzer maintains its
                  accuracy and reliability.
                </p>
              </li>
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Automated
                  Maintenance Alerts: The system provides alerts for scheduled
                  maintenance, ensuring timely upkeep.
                </p>
              </li>
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Easy Access for
                  Servicing: Designed for easy access, allowing for quick and
                  hassle-free servicing.
                </p>
              </li>
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Minimal Downtime:
                  Robust design and reliable performance minimize the need for
                  frequent repairs, ensuring continuous operation.
                </p>
              </li>
            </ul>
          </div>
        ),

        workServices:
          "Technical support available for installation and troubleshooting.",
        productBrochure: "path/to/iflash-3000-brochure.pdf",
        detailedSpecification:
          "Detailed specifications available upon request.",
        offerOrDiscounts: "Inquire about current offers and discounts.",
      },
      {
        id: "5",
        slug: 'iflash-1800',
        coverImg: Iflash1800Grey,
        image: [
          { src: Iflash18001, alt: "YHLO iFlash 1800 advanced chemiluminescence immunoassay analyzer" },
          { src: Iflash18002, alt: "YHLO iFlash 1800 advanced chemiluminescence immunoassay analyzer - side view" },
          { src: Iflash18003, alt: "YHLO iFlash 1800 advanced chemiluminescence immunoassay analyzer - close-up controls" },
          { src: Iflash18004, alt: "YHLO iFlash 1800 advanced chemiluminescence immunoassay analyzer - close-up controls" },
        ],
        section: "clia",
        title: "iFlash 1800",
        shortdescription:
          "The iFlash 1800 is a high-performance fully automated immunoassay analyzer that leverages chemiluminescence technology to provide accurate and reliable diagnostic results. This CLIA analyser is designed for laboratories seeking efficiency, precision, and high throughput.",
        description:
          "The iFlash 1800 uses chemiluminescence immunoassay (CLIA) technology to detect and quantify various analytes in biological samples. The process involves a chemiluminescent reaction that emits light proportional to the concentration of the target analyte, which is then measured by the analyzer.",
        workPrinciple: (
          <div>
            {/* Working Principle Table */}
            <table className="min-w-full table-auto">
              <tbody className="flex flex-col gap-4">
                <tr>
                  <td className="  text-black">
                    <strong className="text-wrap tablet:text-sm largelaptop:text-sm">
                      Working Principle:
                    </strong>{" "}
                    <span className="text-sm">The iFlash 1800 uses chemiluminescence immunoassay (CLIA)
                      technology to detect and quantify various analytes in
                      biological samples. The process involves a chemiluminescent
                      reaction that emits light proportional to the concentration
                      of the target analyte, which is then measured by the
                      analyzer.</span>
                  </td>
                </tr>
                <tr>
                  <td className="  text-black">
                    <strong className="text-wrap tablet:text-sm largelaptop:text-sm">
                      <span className="text-sm">How It Works:</span>
                    </strong>
                    <ul className="list-disc pl-5 ">
                      <li>
                        <strong className="text-xs tablet:text-sm font-semibold largeLaptop:text-lg ">
                          {" "}
                          <span className="text-sm">Sample Preparation:</span>
                        </strong>{" "}
                        <span className="text-sm">Samples are loaded into the analyzer.</span>
                      </li>
                      <li>
                        <strong className="text-xs tablet:text-sm font-semibold largeLaptop:text-lg ">
                          {" "}
                          <span className="text-sm"> Reaction:</span>
                        </strong>{" "}
                        <span className="text-sm">The analyzer mixes the samples with specific reagents to
                          trigger a chemiluminescent reaction.</span>
                      </li>
                      <li>
                        <strong className="text-xs tablet:text-sm font-semibold largeLaptop:text-lg ">
                          {" "}
                          <span className="text-sm">Detection:</span>
                        </strong>{" "}
                        <span className="text-sm">Light emitted from the reaction is measured, and the RLU
                          correlates with the concentration of the target analyte.</span>
                      </li>
                      <li>
                        <strong className="text-xs tablet:text-sm font-semibold largeLaptop:text-lg ">
                          {" "}
                          <span className="text-sm">Results:</span>
                        </strong>{" "}
                        <span className="text-sm">Data is processed and displayed on the user interface,
                          and results can be integrated into LIS systems for
                          further analysis.</span>
                      </li>
                    </ul>
                  </td>
                </tr>
                <tr>
                  <td className="  text-black">
                    <strong className="text-wrap tablet:text-sm largelaptop:text-sm">
                      <span className="text-sm">For Whom It Is Useful:</span>
                    </strong>{" "}
                    <span className="text-sm">The iFlash 1800 is ideal for clinical laboratories,
                      hospitals, diagnostic centers, and research institutions
                      requiring high-throughput and precise immunoassay testing.</span>
                  </td>
                </tr>
                <tr>
                  <td className="  text-black">
                    <strong className="text-xs tablet:text-sm font-semibold largeLaptop:text-lg ">
                      {" "}
                      <span className="text-sm">Use Cases:</span>
                    </strong>
                    <ul className="list-disc pl-5 ">
                      <li>
                        <span className="text-sm">Thyroid Function Testing: The iFlash 3000 excels in
                          performing thyroid assays, providing accurate and rapid
                          results for TSH, T3, and T4 levels.</span>
                      </li>
                      <li>
                        <span className="text-sm">Tumor Marker Detection: Detects and quantifies various
                          tumor markers, aiding in the diagnosis and monitoring of
                          cancer.</span>
                      </li>
                      <li>
                        <span className="text-sm">Infectious Disease Screening: Efficiently screens for
                          infectious diseases, offering reliable results for HIV,
                          hepatitis, and other pathogens.</span>
                      </li>
                      <li>
                        <span className="text-sm">Hormonal Assays: Performs a wide range of hormonal
                          tests, including reproductive hormones and cortisol
                          levels.</span>
                      </li>
                      <li>
                        <span className="text-sm">Cardiac Marker Testing: Provides precise measurements of
                          cardiac markers, essential for assessing heart health.</span>
                      </li>
                    </ul>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        ),

        advantages: (
          <div>
            {/* Advantages List */}
            <ul className="space-y-6 font-poppins">
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> High throughput
                  capability ensures efficient processing of large sample
                  volumes.
                </p>
              </li>
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Chemiluminescence
                  technology provides high sensitivity and specificity.
                </p>
              </li>
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> User-friendly
                  interface simplifies operation and reduces training time.
                </p>
              </li>
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Comprehensive test
                  menu supports a wide range of diagnostic applications.
                </p>
              </li>
            </ul>
          </div>
        ),

        benefits: (
          <div>
            {/* Benefits List */}
            <ul className="space-y-6 font-poppins">
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Enhanced laboratory
                  productivity with rapid and reliable test results.
                </p>
              </li>
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Improved diagnostic
                  accuracy and confidence in patient care.
                </p>
              </li>
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Streamlined
                  workflows
                </p>
              </li>
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Reduced operational
                  costs with efficient and automated processes.
                </p>
              </li>
            </ul>
          </div>
        ),

        testMenu: [""],
        mainAndCare: (
          <div>
            {/* Maintenance and Care List */}
            <ul className="space-y-6 font-poppins">
              {/* <li className="flex gap-3">
                <p className="text-sm largeLaptop:text-2xl font-medium text-gray-800">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Routine calibration
                  and quality control checks.
                </p>
              </li> */}
              {/* <li className="flex gap-3">
                <p className="text-sm largeLaptop:text-2xl font-medium text-gray-800">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Cleaning and
                  inspection of reagent and sample handling components.
                </p>
              </li> */}
              <li className="flex gap-3">
                <p className="text-sm largeLaptop:text-2xl font-medium text-gray-800">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Software updates and
                  troubleshooting as needed.
                </p>
              </li>
              <li className="flex gap-3">
                <p className="text-sm largeLaptop:text-2xl font-medium text-gray-800">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Scheduled servicing
                  by authorized technicians to maintain peak performance.
                </p>
              </li>
            </ul>
          </div>
        ),

        workServices:
          "Technical support available for troubleshooting and service.",
        productBrochure: "path/to/iflash-1800-brochure.pdf",
        detailedSpecification: "Specifications can be provided on request.",
        offerOrDiscounts:
          "Inquire about promotions and discounts with distributor.",
      },
      {
        id: "4",
        slug: 'iflash-1200',
        coverImg: Iflash1200Grey,
        image: [
          { src: Iflash12001, alt: "YHLO iFlash 1200 advanced chemiluminescence immunoassay analyzer" },
          { src: Iflash12002, alt: "YHLO iFlash 1200 advanced chemiluminescence immunoassay analyzer - side view" },
          { src: Iflash12003, alt: "YHLO iFlash 1200 advanced chemiluminescence immunoassay analyzer - close-up controls" },
          { src: Iflash12004, alt: "YHLO iFlash 1200 advanced chemiluminescence immunoassay analyzer - close-up controls" },
        ],
        section: "clia",
        title: "iFlash 1200",
        shortdescription:
          "The iFlash 1200 is a state-of-the-art Chemiluminescence Immunoassay (CLIA) analyzer that provides high sensitivity and specificity in immunoassay testing. This fully automated system simplifies complex diagnostic procedures, offering a user-friendly interface and robust performance to meet the demands of modern laboratories.",
        description:
          "The iFlash  1200 is a fully automated immunoassay analyzer designed to deliver high precision and efficiency for clinical diagnostics. Leveraging advanced Chemiluminescence Immunoassay (CLIA) technology, this analyzer ensures accurate.",
        workPrinciple: (
          <div>
            {/* Working Principle Table */}
            <table className="min-w-full table-auto">
              <tbody className="flex flex-col gap-4">
                <tr>
                  <td className="  text-black">
                    <strong className="text-xs tablet:text-sm font-semibold largeLaptop:text-lg ">
                      {" "}
                      How It Works:
                    </strong>{" "}
                    <br />
                    <span className="text-sm">The iFlash 1200 operates on the Chemiluminescence
                      Immunoassay (CLIA) principle. It uses chemiluminescent
                      reactions to detect the presence of specific antigens or
                      antibodies in a sample. When a sample is introduced, it
                      interacts with labeled antibodies, producing a
                      light-emitting reaction. The emitted light is measured by a
                      photomultiplier tube, providing precise quantification of
                      the analyte concentration.</span>
                  </td>
                </tr>
                <tr>
                  <td className="  text-black">
                    <strong className="text-xs tablet:text-sm font-semibold largeLaptop:text-lg ">
                      {" "}
                      For Whom It Is Useful:
                    </strong>{" "}
                    <br />
                    <span className="text-sm">The iFlash 1200 is perfect for clinical laboratories,
                      hospitals, and diagnostic centers requiring high-throughput
                      testing. It is especially beneficial for endocrinologists,
                      immunologists, and healthcare professionals who need
                      accurate and timely immunoassay results for diagnosing and
                      managing patient conditions.</span>
                  </td>
                </tr>
                <tr>
                  <td className="  text-black">
                    <strong className="text-xs tablet:text-sm font-semibold largeLaptop:text-lg ">
                      {" "}
                      Use Cases:
                    </strong>
                    <ul className="list-disc pl-5 ">
                      <li>
                        <span className="text-sm">Thyroid Function Testing: The iFlash 3000 excels in
                          performing thyroid assays, providing accurate and rapid
                          results for TSH, T3, and T4 levels.</span>
                      </li>
                      <li>
                        <span className="text-sm">Tumor Marker Detection: Detects and quantifies various
                          tumor markers, aiding in the diagnosis and monitoring of
                          cancer.</span>
                      </li>
                      <li>
                        <span className="text-sm">Infectious Disease Screening: Efficiently screens for
                          infectious diseases, offering reliable results for HIV,
                          hepatitis, and other pathogens.</span>
                      </li>
                      <li>
                        <span className="text-sm">Hormonal Assays: Performs a wide range of hormonal
                          tests, including reproductive hormones and cortisol
                          levels.</span>
                      </li>
                      <li>
                        <span className="text-sm">Cardiac Marker Testing: Provides precise measurements of
                          cardiac markers, essential for assessing heart health.</span>
                      </li>
                    </ul>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        ),

        advantages: (
          <div>
            {/* Advantages List */}
            <ul className="space-y-6 font-poppins">
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> High throughput and
                  random access analysis
                </p>
              </li>
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Exceptional
                  sensitivity and specificity
                </p>
              </li>
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Intuitive interface
                  with easy-to-use software
                </p>
              </li>
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Comprehensive test
                  menu covering diverse assays
                </p>
              </li>
            </ul>
          </div>
        ),

        benefits: (
          <div>
            {/* Benefits List */}
            <ul className="space-y-6 font-poppins">
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Reduced manual
                  intervention and higher walkaway time
                </p>
              </li>
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Increased laboratory
                  productivity and efficiency
                </p>
              </li>
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Consistent and
                  reliable results
                </p>
              </li>
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Enhanced diagnostic
                  precision and patient care Enhanced Menu panel
                </p>
              </li>
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Convenient pack size
                  and zero wastage on tests
                </p>
              </li>
            </ul>
          </div>
        ),

        testMenu: [""],
        mainAndCare: (
          <div>
            {/* Maintenance and Care List */}
            <ul className="space-y-6 font-poppins">
              <li className="flex gap-3">
                <p className=" largeLaptop:text-2xl text-xs tablet:text-sm text-black  font-normal ">
                  <span className="text-sm">The iFLASH 1200 is designed for ease of maintenance with
                    automated calibration and quality control features. Regular
                    cleaning and periodic calibration checks are recommended to
                    maintain optimal performance. The analyzer’s robust
                    construction and high-quality components ensure long-term
                    reliability and minimal maintenance costs. Adhering to the
                    manufacturer’s maintenance guidelines will ensure the device
                    operates efficiently and effectively over its lifespan.</span>
                </p>
              </li>
            </ul>
          </div>
        ),

        workServices:
          "Available technical support for system setup and maintenance.",
        productBrochure: "path/to/iflash-1200-brochure.pdf",
        detailedSpecification: "Detailed specifications available on request.",
        offerOrDiscounts: "Check for current offers and discounts.",
      },

      {
        id: "8",
        slug: 'kryptor-compact-plus',
        coverImg: KryptorGrey,
        image: [
          { src: KryptorGrey, alt: "Thermo Fisher Scientific BRAHMS KRYPTOR PLUS analyzer offering precise immunoassay results" },
        ],
        section: "trace",
        title: "KRYPTOR compact PLUS",
        shortdescription:
          "The KRYPTOR Compact Plus is a highly sophisticated prenatal screening equipment engineered to provide accurate and reliable biomarker detection for prenatal and infectious disease diagnostics. This procalcitonin test machine is designed to meet the demands of high-throughput laboratories, offering rapid results with minimal manual intervention. The system is compact yet powerful, integrating advanced technologies that ensure consistent performance and ease of use in clinical settings.",
        description:
          "The KRYPTOR Compact Plus is a cutting-edge prenatal screening instrument designed for precision and reliability in detecting biomarkers associated with prenatal and infectious diseases. This highly efficient procalcitonin test machine offers rapid and accurate results, making it an essential tool for modern diagnostic laboratories. With its compact design and advanced technology, the KRYPTOR Compact Plus ensures seamless integration into any lab environment.",
        workPrinciple: (
          <div>
            {/* Working Principle Table */}
            <table className="min-w-full table-auto">
              <tbody className="flex flex-col gap-4">
                <tr>
                  <td className="  text-black">
                    <strong className="text-wrap tablet:text-sm largelaptop:text-sm">
                      Working Principle:
                    </strong>{" "}
                    <span className="text-sm">The KRYPTOR Compact Plus operates using TRACE (Time Resolved
                      Amplified Cryptate Emission) technology, a highly sensitive
                      method for detecting biomarkers in biological samples. This
                      technology utilizes the unique properties of europium
                      cryptate and XL665, which emit fluorescence when bound to
                      specific biomarkers. The intensity of the fluorescence is
                      measured and is directly proportional to the concentration
                      of the target biomarker, such as procalcitonin. The system
                      is fully automated, from sample preparation to result
                      generation, ensuring high accuracy and reproducibility.</span>
                  </td>
                </tr>
                <tr>
                  <td className="  text-black">
                    <strong className="text-wrap tablet:text-sm largelaptop:text-sm">
                      For Whom It Is Useful:
                    </strong>{" "}
                    <span className="text-sm">The KRYPTOR Compact Plus is ideal for clinical laboratories,
                      hospital labs, and specialized diagnostic centers that
                      require reliable and efficient biomarker testing. It is
                      particularly useful for facilities focusing on prenatal
                      screening, where early detection of conditions like Down
                      syndrome is crucial, and for those conducting procalcitonin
                      tests to monitor bacterial infections.</span>
                  </td>
                </tr>
                <tr>
                  <td className="  text-black">
                    <strong className="text-wrap tablet:text-sm largelaptop:text-sm">
                      Use Cases:
                    </strong>
                    <ul className="list-disc pl-5 ">
                      <li>
                        <span className="text-sm">Prenatal Screening: Accurately detects biomarkers
                          associated with chromosomal abnormalities, aiding in
                          early diagnosis and intervention.</span>
                      </li>
                      <li>
                        <span className="text-sm">Infectious Disease Monitoring: Performs reliable
                          procalcitonin tests to assess the severity of bacterial
                          infections and guide antibiotic therapy.</span>
                      </li>
                      <li>
                        <span className="text-sm">Biomarker Research: Supports advanced research by
                          providing accurate detection of a wide range of
                          biomarkers, including those involved in inflammatory and
                          oncological conditions.</span>
                      </li>
                      <li>
                        <span className="text-sm">Endocrine Testing: Efficiently measures hormone levels,
                          including thyroid and reproductive hormones, providing
                          crucial information for patient management.</span>
                      </li>
                      <li>
                        <span className="text-sm">Sepsis Detection: Provides rapid detection of
                          procalcitonin, a key biomarker in identifying sepsis,
                          allowing for timely treatment decisions.</span>
                      </li>
                    </ul>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        ),

        advantages: (
          <div>
            {/* Advantages List */}
            <ul className="space-y-6 font-poppins">
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  <strong>KC Plus,</strong> equipped with{" "}
                  <strong>FMF-certified software</strong> and{" "}
                  <strong>Indian MOMs</strong> for localized and accurate risk
                  calculation. The key features of KC Plus include:
                </p>
              </li>
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span>{" "}
                  <strong>FMF-approved risk assessment software</strong>{" "}
                  (provided at no additional cost)
                </p>
              </li>
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span>{" "}
                  <strong> Reliable performance</strong>
                  with a CV% within 3.5% as per UKNEQAS evaluations
                </p>
              </li>
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span>
                  <strong>
                    {" "}
                    FDA-approved assays for pre-eclampsia screening
                  </strong>{" "}
                  (PlGF and sFlt-1)
                </p>
              </li>
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span>
                  <strong> High throughput</strong> (at least 45 tests per hour
                  for PAPP-A and Free βhCG)
                </p>
              </li>
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span>
                  <strong>Nobel Prize-winning TRACE technology</strong> ensuring
                  precision and reproducibility
                </p>
              </li>
            </ul>
          </div>
        ),

        benefits: (
          <div>
            {/* Benefits List */}
            <ul className="space-y-6 font-poppins">
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> The instrument is
                  designed to perform first-trimester screening biochemical
                  parameters, including PAPP-A and Free βhCG.
                </p>
              </li>
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span>
                  Facilitates the diagnosis and monitoring of pre-eclampsia
                  using both PlGF and sFlt-1 parameters.
                </p>
              </li>
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Comes with FMF
                  (Fetal Medicine Foundation, Switzerland) approved risk
                  assessment software, provided at no additional cost.
                </p>
              </li>
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span>The CV% for PAPP-A
                  and Free βhCG remains within 3.5% in UKNEQAS evaluations,
                  ensuring dependable performance for prenatal screening and
                  pre-eclampsia prognosis.
                </p>
              </li>
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Offers a throughput
                  capacity of at least 60 tests per hour for PAPP-A and Free
                  βhCG.
                </p>
              </li>
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> The results
                  generated are unaffected by biotin interference, maintaining
                  accuracy and consistency.
                </p>
              </li>
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span>
                  Capable of automatically diluting samples that exceed
                  linearity.
                </p>
              </li>
            </ul>
          </div>
        ),

        testMenu: [""],
        mainAndCare: (
          <div>
            {/* Maintenance and Care List */}
            <ul className="space-y-6 font-poppins">
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Routine Calibration:
                  Regular calibration is recommended to maintain the accuracy
                  and reliability of the analyzer.
                </p>
              </li>
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Automated
                  Maintenance Alerts: The system provides automated alerts for
                  maintenance tasks, ensuring timely servicing.
                </p>
              </li>
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> User Manuals and
                  Support: Detailed user manuals and access to technical support
                  ensure that maintenance procedures are followed correctly.
                </p>
              </li>
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Easy Access for
                  Repairs: Designed for easy access to components, allowing for
                  quick and efficient repairs when necessary.
                </p>
              </li>
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Longevity: Built
                  with durable materials and components, ensuring long-term use
                  with minimal downtime.
                </p>
              </li>
            </ul>
          </div>
        ),

        workServices:
          "Technical support available for installation and service.",
        productBrochure: "path/to/kryptor-compact-plus-brochure.pdf",
        detailedSpecification: "Specifications available upon request.",
        offerOrDiscounts:
          "Check with distributor for current promotions and discounts.",
      },
      {
        id: "9",
        slug: 'euroimmun-i-2p',
        coverImg: EuroimmunGrey,
        image: [

          { src: EuroimmunGrey, alt: "ELISA immunoassay analyzer-i machine by Euroimmun with control panel and sample tray" },
        ],
        title: "EUROIMMUN Analyzer I-2P",
        section: "elisa",
        shortdescription:
          "The Euroimmun Analyzer I-2P is a cutting-edge, fully automated ELISA analyzer tailored for laboratories requiring high-efficiency and reliable immunoassay processing. Designed to enhance laboratory performance, this analyzer ensures accurate and reproducible results with minimal hands-on time, allowing lab professionals to focus on critical analysis.",
        description:
          "The Euroimmun Analyzer I-2P is a fully automated immunoassay analyzer designed to streamline your laboratory’s workflow with precision and efficiency. This state-of-the-art ELISA analyzer supports high-throughput processing, delivering reliable results while minimizing manual intervention.",
        workPrinciple: (
          <div>
            <table className="min-w-full table-auto">
              <tbody className="flex flex-col gap-4">
                <tr>
                  <td className="  text-black">
                    <strong className="text-wrap text-sm ">
                      Working Principle:
                    </strong>{" "}
                    <span className="text-sm">The Euroimmun Analyzer I-2P fully automates the
                      Enzyme-Linked Immunosorbent Assay (ELISA) process. It
                      manages sample dilution, incubation, washing, and detection,
                      ensuring accurate and consistent data output. Its advanced
                      software allows customizable protocols for various test kits
                      and methods.</span>
                  </td>
                </tr>
                <tr>
                  <td className="  text-black">
                    <strong className="text-wrap tablet:text-sm largelaptop:text-sm">
                      For Whom It Is Useful:
                    </strong>{" "}
                    <span className="text-sm">Ideal for clinical labs handling high-volume diagnostics,
                      research labs requiring precision, and biotech companies
                      focusing on product testing and quality assurance.</span>
                  </td>
                </tr>
                <tr>
                  <td className="  text-black">
                    <strong className="text-wrap tablet:text-sm largelaptop:text-sm">
                      Use Cases:
                    </strong>
                    <ul className="list-disc pl-5 ">
                      <li>
                        <span className="text-sm">Clinical Diagnostics: Testing for infectious diseases,
                          autoimmune disorders, and allergies.</span>
                      </li>
                      <li>
                        <span className="text-sm">Research Applications: Monitoring and analyzing
                          biomarkers in research studies.</span>
                      </li>
                      <li>
                        <span className="text-sm">Quality Control: Maintaining consistent product quality
                          in pharmaceutical and biotech industries.</span>
                      </li>
                    </ul>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        ),

        advantages: (
          <div>
            <ul className="space-y-6 font-poppins">
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Efficiency:
                  Automates ELISA processing, reducing manual labor and freeing
                  lab personnel for critical tasks.
                </p>
              </li>
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Consistency:
                  Minimizes human error, ensuring accurate and reproducible
                  results.
                </p>
              </li>
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Flexibility:
                  Compatible with a wide range of ELISA kits and customizable
                  protocols.
                </p>
              </li>
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Scalability:
                  Designed to handle high sample volumes for large laboratories.
                </p>
              </li>
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Cost-Effective:
                  Reduces the need for additional equipment and labor, lowering
                  operational expenses.
                </p>
              </li>
            </ul>
          </div>
        ),

        benefits: (
          <div>
            <ul className="space-y-6 font-poppins">
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Increased
                  Efficiency: Streamlines operations and improves productivity.
                </p>
              </li>
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Improved Accuracy:
                  Delivers reliable results through automated precision.
                </p>
              </li>
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Versatility:
                  Suitable for diverse diagnostic and research applications.
                </p>
              </li>
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Cost-Effective:
                  Reduces costs by optimizing resources and minimizing errors.
                </p>
              </li>
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Enhanced
                  Productivity: Accelerates processing for timely results.
                </p>
              </li>
            </ul>
          </div>
        ),

        testMenu: [""],
        mainAndCare: (
          <div>
            <ul className="space-y-6 font-poppins">
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Routine Calibration:
                  Essential for maintaining accuracy and performance.
                </p>
              </li>
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Automated
                  Maintenance Alerts: Timely notifications for scheduled
                  maintenance.
                </p>
              </li>
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> User Support:
                  Comprehensive manuals and dedicated support for
                  troubleshooting.
                </p>
              </li>
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Easy Maintenance:
                  Designed for quick component access and repairs.
                </p>
              </li>
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Durability: Built
                  with high-quality materials for long-lasting performance.
                </p>
              </li>
            </ul>
          </div>
        ),
        workServices:
          "Technical support available for system setup and troubleshooting.",
        productBrochure: "path/to/euroimmun-analyzer-i-2p-brochure.pdf",
        detailedSpecification: "Detailed specs available on request.",
        offerOrDiscounts: "Inquire about current offers with the distributor.",
      },
      {
        id: "10",
        slug: 'euroblotone',
        coverImg: EuroblotoneGrey,
        image: [

          { src: Euroblotone, alt: "Euroblot one clinical analyzer with ergonomic design and digital controls" },
        ],
        title: "EUROBlotOne",
        section: "immunoblot",
        shortdescription:
          "The Euroblot One is an advanced immunoblot processor designed for the fully automated processing of immunoblots. This innovative system brings accuracy and consistency to diagnostic laboratories by automating the complex steps of immunoblot testing. The Euroblot One ensures that your lab can deliver reliable results with minimal manual intervention, freeing up time for technicians to focus on other critical tasks. Its streamlined design and intuitive operation make it an essential tool for any lab conducting immunoblot assays.",
        description:
          "The Euroblot One is an advanced immunoblot processor designed to fully automate the processing of immunoblots. This system ensures high precision and reliability, streamlining laboratory workflows with ease. Ideal for laboratories seeking efficiency, the Euroblot One test machine offers intuitive operation, consistent results, and robust performance.",
        workPrinciple: (
          <div>
            <table className="min-w-full table-auto">
              <tbody className="flex flex-col gap-4">
                <tr>
                  <td className="  text-black">
                    <strong className="text-xs tablet:text-sm font-semibold largeLaptop:text-lg ">
                      {" "}
                      Working Principle:
                    </strong>{" "}
                    <span className="text-sm">The Euroblot One automates the immunoblotting process,
                      detecting specific proteins in a sample. The system handles
                      the entire process, from sample incubation to washing and
                      signal detection. After applying the sample, it automates
                      the incubation and washing steps, ensuring uniformity.
                      Results are detected through chemiluminescent or
                      colorimetric methods, depending on the assay, and analyzed
                      automatically. This automation minimizes human error and
                      ensures consistent results every time.</span>
                  </td>
                </tr>
                <tr>
                  <td className="  text-black">
                    <strong className="text-xs tablet:text-sm font-semibold largeLaptop:text-lg ">
                      {" "}
                      For Whom It Is Useful:
                    </strong>{" "}
                    <span className="text-sm">The Euroblot One is ideal for clinical diagnostic
                      laboratories, research facilities, and specialized testing
                      centers that require automated immunoblot processing. This
                      system is particularly beneficial for labs performing high
                      volumes of immunoblot assays, where accuracy and efficiency
                      are critical for delivering timely results.</span>
                  </td>
                </tr>
                <tr>
                  <td className="  text-black">
                    <strong className="text-xs tablet:text-sm font-semibold largeLaptop:text-lg ">
                      {" "}
                      Use Cases:
                    </strong>
                    <ul className="list-disc pl-5 ">
                      <li>
                        <span className="text-sm">Autoimmune Disease Diagnostics: Automates the detection
                          of autoimmune markers, offering accurate and reliable
                          results.</span>
                      </li>
                      <li>
                        <span className="text-sm">Infectious Disease Testing: Processes immunoblot assays
                          for detecting infectious agents, enabling faster and
                          more accurate diagnosis.</span>
                      </li>
                      <li>
                        <span className="text-sm">Allergy Testing: Facilitates rapid and precise analysis
                          of allergen-specific antibodies.</span>
                      </li>
                      {/* <li>
                        Oncology Diagnostics: Plays a critical role in detecting
                        cancer-related biomarkers, assisting in diagnosis and
                        treatment planning.
                      </li> */}
                      <li>
                        <span className="text-sm">Research Applications: Ideal for research labs studying
                          protein detection and analysis.</span>
                      </li>
                    </ul>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        ),

        advantages: (
          <div>
            <ul className="space-y-6 font-poppins">
              <li className="flex gap-3">
                <p className="text-sm largeLaptop:text-2xl font-medium text-gray-800">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Enhanced Workflow
                  Efficiency: Full automation reduces manual labor and speeds up
                  testing.
                </p>
              </li>
              <li className="flex gap-3">
                <p className="text-sm largeLaptop:text-2xl font-medium text-gray-800">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Precision and
                  Accuracy: Consistent results are ensured through automated
                  processes, minimizing human error.
                </p>
              </li>
              <li className="flex gap-3">
                <p className="text-sm largeLaptop:text-2xl font-medium text-gray-800">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Versatile Assay
                  Compatibility: Supports a broad range of immunoblot assays,
                  adaptable to various diagnostic needs.
                </p>
              </li>
              <li className="flex gap-3">
                <p className="text-sm largeLaptop:text-2xl font-medium text-gray-800">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Space-Saving Design:
                  Compact design fits easily into labs with limited space.
                </p>
              </li>
              <li className="flex gap-3">
                <p className="text-sm largeLaptop:text-2xl font-medium text-gray-800">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Scalability: Handles
                  varying sample volumes, making it suitable for both small and
                  large labs.
                </p>
              </li>
            </ul>
          </div>
        ),

        benefits: (
          <div>
            <ul className="space-y-6 font-poppins">
              <li className="flex gap-3">
                <p className="text-sm largeLaptop:text-2xl font-medium text-gray-800">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Improved
                  Productivity: Automation processes more tests in less time,
                  boosting productivity.
                </p>
              </li>
              <li className="flex gap-3">
                <p className="text-sm largeLaptop:text-2xl font-medium text-gray-800">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Cost-Effective
                  Operation: Reduces manual intervention, cutting labor costs
                  and errors.
                </p>
              </li>
              <li className="flex gap-3">
                <p className="text-sm largeLaptop:text-2xl font-medium text-gray-800">
                  {" "}
                  <span className="text-[#10b981]">◆</span> User-Friendly
                  Interface: Simplified software and interface reduce the need
                  for extensive training.
                </p>
              </li>
              <li className="flex gap-3">
                <p className="text-sm largeLaptop:text-2xl font-medium text-gray-800">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Accurate and
                  Reliable Results: Delivers consistent, high-quality results
                  for confidence in diagnostics.
                </p>
              </li>
              <li className="flex gap-3">
                <p className="text-sm largeLaptop:text-2xl font-medium text-gray-800">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Versatile
                  Applications: Compatible with a wide range of assays, making
                  it ideal for diagnostic and research labs.
                </p>
              </li>
            </ul>
          </div>
        ),

        testMenu: [""],
        mainAndCare: (
          <div>
            <ul className="space-y-6 font-poppins">
              <li className="flex gap-3">
                <p className="text-sm largeLaptop:text-2xl font-medium text-gray-800">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Automated
                  Maintenance Alerts: Provides alerts for routine maintenance,
                  ensuring the system remains in optimal condition.
                </p>
              </li>
              <li className="flex gap-3">
                <p className="text-sm largeLaptop:text-2xl font-medium text-gray-800">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Easy Access for
                  Servicing: Simple access to internal components, making
                  maintenance and servicing efficient.
                </p>
              </li>
              <li className="flex gap-3">
                <p className="text-sm largeLaptop:text-2xl font-medium text-gray-800">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Low Maintenance
                  Requirements: Built with durability, minimizing the need for
                  frequent maintenance.
                </p>
              </li>
              <li className="flex gap-3">
                <p className="text-sm largeLaptop:text-2xl font-medium text-gray-800">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Comprehensive
                  Support: Backed by CPC Diagnostics’ expert support team to
                  maintain peak system efficiency.
                </p>
              </li>
              <li className="flex gap-3">
                <p className="text-sm largeLaptop:text-2xl font-medium text-gray-800">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Longevity: The
                  robust design ensures long-term, reliable performance.
                </p>
              </li>
            </ul>
          </div>
        ),
        workServices:
          "Available technical support for installation and troubleshooting.",
        productBrochure: "path/to/euroblotone-brochure.pdf",
        detailedSpecification: "Specifications available upon request.",
        offerOrDiscounts:
          "Check with distributor for current offers and discounts.",
      },
      {
        id: "11",
        slug: 'if-sprinter',
        image: [

          { src: IfSprinter, alt: "Advanced IF Sprinter analyzer used for accurate diagnostic measurements" },
        ],
        coverImg: IfSprinterGrey,
        title: "IF Sprinter",
        section: "ifa",
        shortdescription:
          "The IF Sprinter is an advanced IFA Processor (ImmunoFluorescence Assay) designed to streamline and automate the immunofluorescence assay process. With high throughput and precision, this fully automated IFA processor enhances lab productivity while delivering consistent and accurate results. Ideal for busy diagnostic labs, the IF Sprinter provides reliable automation for ImmunoFluorescence assays.",
        description:
          "The IF Sprinter is a sophisticated IFA Processor (ImmunoFluorescence Assay) developed to bring efficiency and accuracy to diagnostic laboratories. This fully automated IFA processor eliminates manual handling errors and speeds up the immunofluorescence process, allowing labs to focus on delivering timely results. The IF Sprinter’s automation capabilities are versatile instruments for any lab handling immunological testing.",
        workPrinciple: (
          <div>
            <table className="min-w-full table-auto">
              <tbody className="flex flex-col gap-4">
                <tr>
                  <td className="  text-black">
                    <strong className="text-wrap tablet:text-sm largelaptop:text-sm">
                      Working Principle:
                    </strong>{" "}
                    <span className="text-sm">The IF Sprinter automates the entire ImmunoFluorescence
                      Assay (IFA) process, from sample preparation to result
                      generation. It uses fluorescent-labeled antibodies to detect
                      specific antigens in patient samples. After the
                      antigen-antibody reaction, the processor washes away unbound
                      antibodies and measures the emitted fluorescence, which is
                      proportional to the amount of antigen in the sample. This
                      automation ensures precision, reproducibility, and reduces
                      hands-on time for lab technicians.</span>
                  </td>
                </tr>
                <tr>
                  <td className="  text-black">
                    <strong className="text-wrap tablet:text-sm largelaptop:text-sm">
                      For Whom It Is Useful:
                    </strong>{" "}
                    <span className="text-sm">Ideal for clinical diagnostic labs, research facilities, and
                      hospitals performing high-throughput, automated immunoassay
                      processing, especially those focusing on Immunofluorescence
                      assay.</span>
                  </td>
                </tr>
                <tr>
                  <td className="  text-black">
                    <strong className="text-wrap tablet:text-sm largelaptop:text-sm">
                      Use Cases:
                    </strong>
                    <ul className="list-disc pl-5 ">
                      <li>
                        <span className="text-sm">Autoimmune Disease Diagnostics: Automates detection of
                          Broad spectrum of autoimmune markers for quicker
                          diagnosis.</span>
                      </li>
                      <li>
                        <span className="text-sm">Infectious Disease Screening: Processes IFA tests for
                          pathogens to aid in disease management.</span>
                      </li>
                      <li>
                        <span className="text-sm">Allergy Testing: Facilitates rapid analysis of
                          allergen-specific antibodies in patient samples.</span>
                      </li>
                      <li>
                        <span className="text-sm">Endocrine Testing: Automates detection of
                          hormone-related biomarkers for accurate assessments.</span>
                      </li>
                      <li>
                        <span className="text-sm">Cancer Biomarker Detection: Critical for detecting and
                          monitoring cancer-related biomarkers</span>
                      </li>
                    </ul>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        ),

        advantages: (
          <div>
            <p className=" largeLaptop:text-2xl mb-4 text-xs tablet:text-sm text-black  font-normal ">
              <span className="text-sm">Enhanced Workflow Efficiency: Automates IFA and ELISA processes,
                reducing manual work and speeding diagnostics.</span>
            </p>
            <ul className="space-y-6 font-poppins ml-4">
              <li className="flex gap-3">
                <p className=" largeLaptop:text-2xl text-xs tablet:text-sm text-black  font-normal ">
                  <span className="text-[#10b981]">◆</span> Consistent Accuracy:
                  Reproducible results, ensuring diagnostic reliability across
                  tests.
                </p>
              </li>
              <li className="flex gap-3">
                <p className=" largeLaptop:text-2xl text-xs tablet:text-sm text-black  font-normal ">
                  <span className="text-[#10b981]">◆</span> Flexible
                  Application: Supports a range of assays for autoimmune,
                  infectious diseases, and allergies.
                </p>
              </li>
              <li className="flex gap-3">
                <p className=" largeLaptop:text-2xl text-xs tablet:text-sm text-black  font-normal ">
                  <span className="text-[#10b981]">◆</span> Compact and
                  Space-Saving: Fits in any lab setup without occupying
                  excessive space.
                </p>
              </li>
              <li className="flex gap-3">
                <p className=" largeLaptop:text-2xl text-xs tablet:text-sm text-black  font-normal ">
                  <span className="text-[#10b981]">◆</span> Scalable: Adapts to
                  varying lab volumes, ensuring consistent performance as demand
                  grows.
                </p>
              </li>
            </ul>
          </div>
        ),

        benefits: (
          <div>
            <ul className="space-y-6 font-poppins">
              <li className="flex gap-3">
                <p className=" largeLaptop:text-2xl text-xs tablet:text-sm text-black  font-normal ">
                  <span className="text-[#10b981]">◆</span> Time-Saving
                  Automation: Reduces manual labor, allowing technicians to
                  focus on other tasks.
                </p>
              </li>
              <li className="flex gap-3">
                <p className=" largeLaptop:text-2xl text-xs tablet:text-sm text-black  font-normal ">
                  <span className="text-[#10b981]">◆</span> Improved
                  Productivity: High throughput means more samples processed
                  faster, increasing lab efficiency.
                </p>
              </li>
              <li className="flex gap-3">
                <p className=" largeLaptop:text-2xl text-xs tablet:text-sm text-black  font-normal ">
                  <span className="text-[#10b981]">◆</span> Cost-Effective
                  Operations: Reduces human error and the need for repeat
                  testing, cutting operational costs.
                </p>
              </li>
              <li className="flex gap-3">
                <p className=" largeLaptop:text-2xl text-xs tablet:text-sm text-black  font-normal ">
                  <span className="text-[#10b981]">◆</span> User-Friendly
                  Design: Intuitive controls simplify operation, reducing
                  training time for staff
                </p>
              </li>
              <li className="flex gap-3">
                <p className=" largeLaptop:text-2xl text-xs tablet:text-sm text-black  font-normal ">
                  <span className="text-[#10b981]">◆</span> Versatility:
                  Complete spectrum of autoimmune disorders covered.
                </p>
              </li>
            </ul>
          </div>
        ),

        testMenu: [""],
        mainAndCare: (
          <div>
            <ul className="space-y-6 font-poppins">
              <li className="flex gap-3">
                <p className=" largeLaptop:text-2xl text-xs tablet:text-sm text-black  font-normal ">
                  <span className="text-[#10b981]">◆</span> Routine Calibration:
                  Regular calibration maintains precision and ensures
                  reliability.
                </p>
              </li>
              <li className="flex gap-3">
                <p className=" largeLaptop:text-2xl text-xs tablet:text-sm text-black  font-normal ">
                  <span className="text-[#10b981]">◆</span> Automated
                  Maintenance Alerts: The system notifies you when maintenance
                  tasks are needed, minimizing downtime.
                </p>
              </li>
              <li className="flex gap-3">
                <p className=" largeLaptop:text-2xl text-xs tablet:text-sm text-black  font-normal ">
                  <span className="text-[#10b981]">◆</span> Accessible Design:
                  Easy access to internal components for efficient maintenance
                  and repairs.
                </p>
              </li>
              <li className="flex gap-3">
                <p className=" largeLaptop:text-2xl text-xs tablet:text-sm text-black  font-normal ">
                  <span className="text-[#10b981]">◆</span> Minimal Downtime:
                  Designed for continuous operation with minimal maintenance
                  interruptions.
                </p>
              </li>
              <li className="flex gap-3">
                <p className=" largeLaptop:text-2xl text-xs tablet:text-sm text-black  font-normal ">
                  <span className="text-[#10b981]">◆</span> Comprehensive
                  Support: Supported by CPC Diagnostics’ dedicated technical
                  support team to ensure optimal performance.
                </p>
              </li>
            </ul>
          </div>
        ),
        workServices: "Technical support available for setup and service.",
        productBrochure: "path/to/if-sprinter-brochure.pdf",
        detailedSpecification: "Detailed specifications available on request.",
        offerOrDiscounts:
          "Inquire about promotions and discounts with distributor.",
      },
      {
        id: "12",
        slug: 'eutostar-iii-plus',
        image: [

          { src: EuroStar, alt: "Portable Eurostar iii plus diagnostic analyzer used for biochemical testing" },
        ],
        coverImg: EuroStarGrey,
        section: "ifa",
        title: "EUROStar III Plus",
        shortdescription:
          "The EUROStar III Plus is a state-of-the-art fluorescence microscope developed for laboratories requiring high-quality imaging capabilities. Its advanced LED technology ensures bright and even illumination, crucial for producing clear and detailed fluorescence images. This microscope is designed with user convenience in mind, offering an intuitive interface and robust construction to support a wide range of laboratory applications.",
        description:
          "The EUROStar III Plus is a cutting-edge fluorescence microscope designed to deliver high-resolution imaging for advanced laboratory applications. This LED microscope provides bright, clear images with enhanced fluorescence, making it ideal for detailed analysis and diagnostics.",
        workPrinciple: (
          <div>
            <table className="min-w-full table-auto">
              <tbody className="flex flex-col gap-4">
                <tr>
                  <td className="  text-black">
                    <strong className="text-wrap tablet:text-sm largelaptop:text-sm">
                      Working Principle:
                    </strong>{" "}
                    <span className="text-sm">The EUROStar III Plus operates using advanced LED
                      illumination to excite fluorophores in the sample. When the
                      fluorophores are excited, they emit light at specific
                      wavelengths, which is captured by the high-resolution optics
                      of the microscope. This process enables the detailed
                      visualization of cellular and molecular structures that are
                      tagged with fluorescent markers. The LED light source is
                      energy-efficient and provides consistent illumination for
                      reliable results.</span>
                  </td>
                </tr>
                <tr>
                  <td className="  text-black">
                    <strong className="text-wrap tablet:text-sm largelaptop:text-sm">
                      For Whom It Is Useful:
                    </strong>{" "}
                    <span className="text-sm">Ideal for clinical labs performing fluorescence assays,
                      research institutions studying gene expression and protein
                      localization, and educational institutions teaching advanced
                      microscopy techniques.</span>
                  </td>
                </tr>
                <tr>
                  <td className="  text-black">
                    <strong className="text-wrap tablet:text-sm largelaptop:text-sm">
                      Use Cases:
                    </strong>
                    <ul className="list-disc pl-5 ">
                      <li>
                        <span className="text-sm">Immunofluorescence Assays: Visualizing antibodies in
                          diagnostic tests.</span>
                      </li>
                      <li>
                        <span className="text-sm">Cellular and Molecular Research: Studying gene
                          expression and protein interactions.</span>
                      </li>
                      <li>
                        <span className="text-sm">Pathology: Analyzing pathological changes in tissue
                          samples.</span>
                      </li>
                    </ul>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        ),

        advantages: (
          <div>
            <ul className="space-y-6 font-poppins">
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Bright and
                  Consistent Illumination: LED technology provides reliable and
                  uniform lighting for enhanced clarity.
                </p>
              </li>
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> High-Resolution
                  Imaging: Sharp and detailed images for accurate analysis and
                  diagnosis.
                </p>
              </li>
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Ease of Use:
                  User-friendly controls and ergonomic design for extended
                  operation.
                </p>
              </li>
            </ul>
          </div>
        ),

        benefits: (
          <div>
            <ul className="space-y-6 font-poppins">
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Enhanced Diagnostic
                  Capabilities: Detailed images improve diagnostic accuracy for
                  better patient outcomes.
                </p>
              </li>
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Versatility:
                  Suitable for a wide range of applications, from diagnostics to
                  research.
                </p>
              </li>
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Cost-Efficient:
                  Energy-efficient LED lighting reduces operational costs.
                </p>
              </li>
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Durability: Designed
                  for long-term use in busy lab environments, ensuring
                  reliability.
                </p>
              </li>
            </ul>
          </div>
        ),

        testMenu: [""],
        mainAndCare: (
          <div>
            <ul className="space-y-6 font-poppins">
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Minimal Maintenance:
                  Requires only regular cleaning of optics and occasional
                  calibration.
                </p>
              </li>
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Long-Lasting LED:
                  The LED light source offers long operational life, reducing
                  replacement needs.
                </p>
              </li>
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> User Support:
                  Comprehensive technical support for troubleshooting and
                  maintenance.
                </p>
              </li>
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Durable Build:
                  Designed for regular use in demanding laboratory environments.
                </p>
              </li>
            </ul>
          </div>
        ),
        workServices:
          "Available technical support for installation and troubleshooting.",
        productBrochure: "path/to/eurostar-iii-plus-brochure.pdf",
        detailedSpecification: "Specifications can be provided on request.",
        offerOrDiscounts:
          "Check with distributor for current offers and discounts.",
      },
      // {
      //   id: "13",
      //   image: [image1],
      //   title: "Hemaquest",
      //   shortdescription: "Hemaquest",
      //   description:
      //     "Hemaquest is designed for advanced hematology testing, providing reliable and accurate results for various blood analysis applications.",
      //   workPrinciple: "Advanced technology for accurate hematology testing.",
      //   advantages:
      //     "Reliable and accurate results for diverse blood analysis needs.",
      //   benefits: "Ideal for comprehensive hematology diagnostics.",
      //   testMenu:[''],mainAndCare:
      //     "Routine maintenance required; adhere to operational guidelines.",
      //   workServices: "Technical support available for setup and service.",
      //   productBrochure: "path/to/hemaquest-brochure.pdf",
      //   detailedSpecification:
      //     "Detailed specifications available upon request.",
      //   offerOrDiscounts:
      //     "Inquire about current promotions and discounts with distributor.",
      // },
      {
        id: "14",
        slug: 'europattern-microscope',
        image: [

          { src: euroPattern, alt: "Europattern Microscope laboratory analyzer showcasing test modules and sample " },
        ],
        coverImg: euroPatternGrey,
        title: "EUROPattern Microscope",
        section: "ifa",
        shortdescription:
          "The EuroPattern Microscope is an advanced imaging system for automated pattern recognition in immunofluorescence testing, enhancing workflow efficiency and diagnostic precision.",
        description:
          "The EuroPattern Microscope is an advanced imaging system designed for automated pattern recognition in immunofluorescence testing. With advanced technology, this microscope streamlines workflows and enhances diagnostic precision.",
        workPrinciple: (
          <div>
            <table className="min-w-full table-auto">
              <tbody className="flex flex-col gap-4">
                <tr>
                  <td className="  text-black">
                    <strong className="text-xs tablet:text-sm font-semibold largeLaptop:text-lg ">
                      {" "}
                      Working Principle:
                      <br />
                    </strong>
                    <span className="text-sm">The acquired image data is automatically transmitted to the
                      pattern recognition software EUROPattern Classifier, which
                      is based on deep convolutional neural networks, a
                      deep-learning method. The program not only provides
                      classification in terms of “positive” and “negative” for
                      many substrates, but also reliably identifies different
                      patterns for ANA, ANCA, AMA and anti-LKM (LKM-like),
                      including mixed patterns. In combination with the laboratory
                      management software EUROLabOffice 4.0 it allows fast and
                      secure result archiving and bidirectional connection to the
                      laboratory information system (LIS).</span>
                  </td>
                </tr>
                <tr>
                  <td className="  text-black">
                    <strong className="text-xs tablet:text-sm font-semibold largeLaptop:text-lg ">
                      {" "}
                      For Whom It Is Useful? <br />
                    </strong>
                    <span className="text-sm">Ideal for laboratories performing autoimmune and infectious
                      disease testing using immunofluorescence techniques.</span>
                  </td>
                </tr>
                <tr>
                  <td className="  text-black">
                    <strong className="text-xs tablet:text-sm font-semibold largeLaptop:text-lg ">
                      {" "}
                      Use Cases:
                    </strong>
                    <ul className="list-disc pl-5 ">
                      <li>
                        <span className="text-sm">Diagnosing autoimmune diseases such as lupus and
                          rheumatoid arthritis.</span>
                      </li>
                      <li>
                        <span className="text-sm">Identifying infectious agents using fluorescent markers.</span>
                      </li>
                      <li>
                        <span className="text-sm">Research applications in immunology and pathology.</span>
                      </li>
                    </ul>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        ),

        advantages: (
          <div>
            <ul className="space-y-6 font-poppins">
              <li className="flex gap-3">
                <p className="text-sm largeLaptop:text-2xl font-medium text-gray-800">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Automated pattern
                  recognition ensures accurate identification of
                  immunofluorescence patterns, reducing errors.
                </p>
              </li>
              <li className="flex gap-3">
                <p className="text-sm largeLaptop:text-2xl font-medium text-gray-800">
                  {" "}
                  <span className="text-[#10b981]">◆</span> High throughput
                  capability processes up to 500 analysis positions with a high
                  system speed of 13 seconds per image
                </p>
              </li>
              <li className="flex gap-3">
                <p className="text-sm largeLaptop:text-2xl font-medium text-gray-800">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Over 250
                  fluorescence images can be recorded and automatically
                  evaluated in just one hour
                </p>
              </li>
              <li className="flex gap-3">
                <p className="text-sm largeLaptop:text-2xl font-medium text-gray-800">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Pattern recognition
                  and titer determination for ANA and ANCA (including mixed
                  patterns), Crithidia, recombinant cells, liver(rat) and kidney
                  (rat)
                </p>
              </li>
            </ul>
          </div>
        ),

        benefits: (
          <div>
            <ul className="space-y-6 font-poppins">
              <li className="flex gap-3">
                <p className="text-sm largeLaptop:text-2xl font-medium text-gray-800">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Provides consistent
                  and objective results by minimizing subjective variability.
                </p>
              </li>
              <li className="flex gap-3">
                <p className="text-sm largeLaptop:text-2xl font-medium text-gray-800">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Seamlessly
                  integrates with laboratory software, streamlining workflows.
                </p>
              </li>
            </ul>
          </div>
        ),

        testMenu: [""],
        mainAndCare: (
          <div>
            <ul className="space-y-6 font-poppins">
              <li className="flex gap-3">
                <p className="text-sm largeLaptop:text-2xl font-medium text-gray-800">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Regularly clean
                  optical components to maintain image clarity.
                </p>
              </li>
              <li className="flex gap-3">
                <p className="text-sm largeLaptop:text-2xl font-medium text-gray-800">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Update software for
                  improved performance and compatibility.
                </p>
              </li>
              <li className="flex gap-3">
                <p className="text-sm largeLaptop:text-2xl font-medium text-gray-800">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Schedule routine
                  servicing to ensure long-term reliability.
                </p>
              </li>
            </ul>
          </div>
        ),

        productBrochure: "path/to/Europattern Microscope-brochure.pdf",
        detailedSpecification:
          "Detailed specifications available upon request.",
        offerOrDiscounts:
          "Inquire about current promotions and discounts with distributor.",
      },
      {
        id: "15",
        slug: 'fluoromat-50',
        image: [

          { src: fluoroMat, alt: "FluoroMAT 50 advanced immunofluorescence analyzer providing precise IFA results" },
        ],
        coverImg: fluoroMatGrey,
        title: "FluoroMAT50",
        section: "ifa",
        shortdescription:
          "The Fluoromat 50 is a powerful IIFA processor designed to bring automation and efficiency to your laboratory. This automated IIFA processor delivers precise and reliable results, making it ideal for laboratories performing various diagnostics, including Rheumatology, Neurology, Nephrology, Gastrology etc. With a compact design and user-friendly interface, the Fluoromat 50 enhances lab productivity while maintaining accuracy.	",
        description:
          "The Fluoromat 50 is an advanced IIFA processor is designed to deliver high-precision results across a variety of diagnostic applications, making it a valuable tool for laboratories conducting  Rheumatology, Neurology, Nephrology, Gastrology and more. With its automated workflow and high throughput capabilities, the Fluoromat 50 minimizes manual intervention, ensuring consistency and reproducibility in every test.	",
        workPrinciple: (
          <div>
            <table className="min-w-full table-auto">
              <tbody className="flex flex-col gap-4">
                <tr>
                  <td className="  text-black">
                    <strong className="text-xs tablet:text-sm font-semibold largeLaptop:text-lg ">
                      {" "}
                      Working Principle: How It Works? <br />
                    </strong>
                    <span className="text-sm">The Fluoromat50 automates the entire ImmunoFluorescence
                      Assay (IFA) process, from sample preparation to result
                      generation. It uses fluorescent-labeled antibodies to detect
                      specific antigens in patient samples. After the
                      antigen-antibody reaction, the processor washes away unbound
                      antibodies and measures the emitted fluorescence, which is
                      proportional to the amount of antigen present in the sample.
                      This automation not only ensures precision and
                      reproducibility but also significantly reduces hands-on time
                      for lab technicians</span>
                  </td>
                </tr>
                <tr>
                  <td className="  text-black">
                    <strong className="text-xs tablet:text-sm font-semibold largeLaptop:text-lg ">
                      {" "}
                      For Whom It Is Useful? <br />
                    </strong>
                    <span className="text-sm">The Fluoromat 50 is ideal for clinical diagnostic
                      laboratories, research centers, and specialized testing
                      facilities that need to streamline their IIFA processing. It
                      is particularly useful for all laboratories that handle a
                      low to high volume of IIFA tests, providing a reliable
                      solution to increase lab efficiency and accuracy.</span>
                  </td>
                </tr>
                <tr>
                  <td className="  text-black">
                    <strong className="text-xs tablet:text-sm font-semibold largeLaptop:text-lg ">
                      {" "}
                      Use Cases:
                    </strong>
                    <ul className="list-disc pl-5 ">
                      <li>
                        <span className="text-sm">Autoimmune Disease Diagnostics: Automates the detection
                          of autoimmune markers, enabling quicker and more
                          accurate diagnosis of various autoimmune diseases</span>
                      </li>
                      <li>
                        <span className="text-sm">Endocrine Testing: Automates the detection of
                          hormone-related biomarkers, providing accurate endocrine
                          function assessments.</span>
                      </li>
                      <li>
                        <span className="text-sm">Research and Development: Ideal for research labs
                          conducting studies in immunology, infectious diseases,
                          and more.</span>
                      </li>
                      <li>
                        <span className="text-sm">Infectious Disease Testing: Automates IFA tests for
                          infectious diseases, enabling quicker diagnosis and
                          intervention.</span>
                      </li>
                    </ul>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        ),

        advantages: (
          <div>
            <ul className="space-y-6 font-poppins">
              <li className="flex gap-3">
                <p className="text-sm largeLaptop:text-2xl font-medium text-gray-800">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Automated Workflow:
                  Reduces manual labor and improves consistency, leading to more
                  accurate and reproducible results across all tests.
                </p>
              </li>
              <li className="flex gap-3">
                <p className="text-sm largeLaptop:text-2xl font-medium text-gray-800">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Versatile
                  Application: Supports a wide range of autoimmune test covered,
                  including Rheumatology, Neurology, Nephrology, Gastrology etc,
                  making it adaptable to various testing needs.
                </p>
              </li>
              <li className="flex gap-3">
                <p className="text-sm largeLaptop:text-2xl font-medium text-gray-800">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Compact Design: The
                  Fluoromat 50's small footprint allows it to fit easily into
                  labs with limited space while still providing full
                  functionality.
                </p>
              </li>
              <li className="flex gap-3">
                <p className="text-sm largeLaptop:text-2xl font-medium text-gray-800">
                  {" "}
                  <span className="text-[#10b981]">◆</span> High Sensitivity:
                  Fluorescence-based detection ensures high sensitivity,
                  allowing for the detection of even low-abundance proteins.
                </p>
              </li>
              <li className="flex gap-3">
                <p className="text-sm largeLaptop:text-2xl font-medium text-gray-800">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Efficiency: Capable
                  of processing multiple samples simultaneously, reducing
                  turnaround times and increasing lab throughput.
                </p>
              </li>
            </ul>
          </div>
        ),

        benefits: (
          <div>
            <ul className="space-y-6 font-poppins">
              <li className="flex gap-3">
                <p className="text-sm largeLaptop:text-2xl font-medium text-gray-800">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Enhanced
                  Productivity: Automation frees up lab technicians to focus on
                  other tasks while the Fluoromat 50 handles the IIFA process,
                  boosting overall lab efficiency.
                </p>
              </li>
              <li className="flex gap-3">
                <p className="text-sm largeLaptop:text-2xl font-medium text-gray-800">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Accurate and
                  Reproducible Results: The system's automation ensures that
                  every step is performed consistently, providing high-quality
                  results every time.
                </p>
              </li>
              <li className="flex gap-3">
                <p className="text-sm largeLaptop:text-2xl font-medium text-gray-800">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Cost-Effective
                  Operation: Reducing manual labor and repeat tests lowers
                  operational costs, making the Fluoromat 50 a cost-effective
                  solution for laboratories.
                </p>
              </li>
              <li className="flex gap-3">
                <p className="text-sm largeLaptop:text-2xl font-medium text-gray-800">
                  {" "}
                  <span className="text-[#10b981]">◆</span> User-Friendly
                  Design: The intuitive interface and easy-to-use controls
                  minimize the learning curve, allowing lab staff to operate the
                  system with ease.
                </p>
              </li>
              <li className="flex gap-3">
                <p className="text-sm largeLaptop:text-2xl font-medium text-gray-800">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Multi-Test
                  Capability: While handling Rheumatology, Neurology,
                  Nephrology, Gastrology tests. The Fluoromat 50 is versatile
                  enough to meet the needs of diverse diagnostic applications.
                </p>
              </li>
            </ul>
          </div>
        ),

        testMenu: [""],
        mainAndCare: (
          <div>
            <ul className="space-y-6 font-poppins">
              <li className="flex gap-3">
                <p className="text-sm largeLaptop:text-2xl font-medium text-gray-800">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Routine Calibration:
                  Regular calibration ensures that the Fluoromat 50 maintains
                  its accuracy and precision over time.
                </p>
              </li>
              <li className="flex gap-3">
                <p className="text-sm largeLaptop:text-2xl font-medium text-gray-800">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Automated
                  Maintenance Alerts: The system provides automated
                  notifications for scheduled maintenance, ensuring consistent
                  performance without disrupting operations.
                </p>
              </li>
              <li className="flex gap-3">
                <p className="text-sm largeLaptop:text-2xl font-medium text-gray-800">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Easy Access for
                  Servicing: Designed for easy access to internal components,
                  the Fluoromat 50 simplifies routine maintenance and servicing.
                </p>
              </li>
              <li className="flex gap-3">
                <p className="text-sm largeLaptop:text-2xl font-medium text-gray-800">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Durable
                  Construction: Built to last, the Fluoromat 50 provides
                  long-term reliability with minimal downtime, ensuring
                  continuous operation in busy labs.
                </p>
              </li>
              <li className="flex gap-3">
                <p className="text-sm largeLaptop:text-2xl font-medium text-gray-800">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Comprehensive
                  Support: Supported by CPC Diagnostics' expert technical team,
                  ensuring your system operates at peak performance throughout
                  its lifespan.
                </p>
              </li>
            </ul>
          </div>
        ),
        workServices: "Technical support available for setup and service.",
        productBrochure: "path/to/FLUOROMAT 50-brochure.pdf",
        detailedSpecification:
          "Detailed specifications available upon request.",
        offerOrDiscounts:
          "Inquire about current promotions and discounts with distributor.",
      },
      {
        id: "16",
        slug: 'euroimmun-i',
        image: [

          { src: euroimmunAnalyzerI, alt: " " },
        ],
        coverImg: euroimmunAnalyzerIGrey,
        title: "EUROIMMUN Analyzer I",
        section: "elisa",
        shortdescription:
          "The Euroimmun Analyzer I is a sophisticated, fully automated ELISA analyzer developed to enhance laboratory efficiency while delivering high-precision results. It automates the entire ELISA process, significantly reducing the need for manual labor and minimizing the risk of human error. This compact and reliable analyzer is an essential tool for any laboratory conducting regular ELISA tests.",
        description:
          "The Euroimmun Analyzer I is a fully automated immunoassay analyzer engineered for accuracy, efficiency, and reliability in ELISA testing. This advanced ELISA analyzer is designed to automate and streamline laboratory processes, ensuring consistent results with minimal human intervention.",
        workPrinciple: (
          <div>
            <table className="min-w-full table-auto">
              <tbody className="flex flex-col gap-4">
                <tr>
                  <td className="  text-black">
                    <strong className="text-wrap tablet:text-sm largelaptop:text-sm">
                      Working Principle:
                    </strong>{" "}
                    <span className="text-sm">The Euroimmun Analyzer I automates the ELISA process by
                      handling all stages of the assay, including sample dilution,
                      incubation, washing, and detection. The system's precise
                      optical measurement technology ensures consistent and
                      accurate results, while its user-friendly software allows
                      for easy setup and execution of various test protocols. The
                      fully automated process ensures that each step is performed
                      with precision, eliminating the variability associated with
                      manual operations.</span>
                  </td>
                </tr>
                <tr>
                  <td className="  text-black">
                    <strong className="text-wrap tablet:text-sm largelaptop:text-sm">
                      For Whom It Is Useful:
                    </strong>{" "}
                    <span className="text-sm">Ideal for clinical laboratories that require efficient and
                      reliable ELISA testing, research institutions focused on
                      biomarker analysis and disease research, and pharmaceutical
                      companies conducting product testing and quality control.</span>
                  </td>
                </tr>
                <tr>
                  <td className="  text-black">
                    <strong className="text-wrap tablet:text-sm largelaptop:text-sm">
                      Use Cases:
                    </strong>
                    <ul className="list-disc pl-5 ">
                      <li>
                        <span className="text-sm">Clinical Diagnostics: Routine testing for autoimmune
                          disorders & infectious diseases.</span>
                      </li>
                      <li>
                        <span className="text-sm">Research Applications: Analyzing biomarkers and
                          conducting research on disease mechanisms.</span>
                      </li>
                      <li>
                        <span className="text-sm">Quality Control: Ensuring consistency and reliability in
                          pharmaceutical and biotech product testing.</span>
                      </li>
                    </ul>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        ),

        advantages: (
          <div>
            <ul className="space-y-6 font-poppins">
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Fully Automated
                  Process: Automates all stages of the ELISA process, from
                  sample preparation to result generation.
                </p>
              </li>
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> High Precision:
                  Ensures accurate and reproducible results through precise
                  optical measurement.
                </p>
              </li>
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Compact and
                  Efficient Design: Occupies minimal laboratory space while
                  delivering high performance.
                </p>
              </li>
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Versatile
                  Application: Compatible with various ELISA kits and
                  customizable for different test protocols.
                </p>
              </li>
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> User-Friendly
                  Software: Easy to operate, with intuitive controls and
                  programming flexibility.
                </p>
              </li>
            </ul>
          </div>
        ),

        benefits: (
          <div>
            <ul className="space-y-6 font-poppins">
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Enhanced
                  Reliability: Automated processes reduce the chances of human
                  error, ensuring more reliable results.
                </p>
              </li>
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Time-Saving: Speeds
                  up the ELISA process, allowing lab personnel to focus on data
                  interpretation and other tasks.
                </p>
              </li>
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Space-Saving: The
                  compact design is ideal for laboratories where space is at a
                  premium.
                </p>
              </li>
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Cost-Effective:
                  Lowers overall costs by reducing the need for manual labor and
                  additional instruments.
                </p>
              </li>
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Increased Lab
                  Efficiency: Streamlines operations, making the lab more
                  efficient in handling ELISA tests.
                </p>
              </li>
            </ul>
          </div>
        ),

        testMenu: [""],
        mainAndCare: (
          <div>
            <ul className="space-y-6 font-poppins">
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Routine Calibration:
                  Regular calibration is essential for maintaining accuracy and
                  performance.
                </p>
              </li>
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Self-Cleaning
                  Functions: Designed with self-cleaning routines to minimize
                  regular maintenance efforts.
                </p>
              </li>
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Software Updates:
                  Regular software updates ensure continuous optimal performance
                  and access to new features.
                </p>
              </li>
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> User Support:
                  Comprehensive support and manuals are available for
                  troubleshooting and maintenance queries.
                </p>
              </li>
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Easy Access to
                  Components: Designed for quick component access to simplify
                  repairs and replacements.
                </p>
              </li>
            </ul>
          </div>
        ),
        workServices:
          "Technical support available for system setup and troubleshooting.",
        productBrochure: "path/to/Euroimmun Analyzer I-brochure.pdf",
        detailedSpecification: "Detailed specs available on request.",
        offerOrDiscounts: "Inquire about current offers with the distributor.",
      },
      {
        id: "17",
        slug: 'sprinter-xl',
        image: [

          { src: sprinter, alt: "Advanced IF Sprinter analyzer used for accurate diagnostic measurements" },
        ],
        coverImg: sprinterGrey,
        title: "Sprinter XL",
        section: "ifa",
        shortdescription:
          "The Sprinter XL is an advanced IFA Processor (ImmunoFluorescence Assay) designed for high-volume laboratories that demand precision, reliability, and speed. This fully automated IFA processor streamlines the entire immunoassay process, reducing manual intervention and delivering consistent, accurate results. With its scalable design and robust performance, the Sprinter XL offers the perfect solution for labs needing IFA automation.",
        description:
          "The Sprinter XL is an innovative IFA Processor (ImmunoFluorescence Assay) that brings next-level automation to clinical and diagnostic laboratories. This fully automated IFA processor is engineered to meet the needs of high-throughput labs, ensuring efficiency and accuracy for IFA. Its robust design supports the seamless integration of automation into laboratory workflows, minimizing errors and maximizing output. Whether performing routine diagnostics or specialized immunoassays, the Sprinter XL delivers unparalleled performance.",
        workPrinciple: (
          <div>
            <table className="min-w-full table-auto">
              <tbody className="flex flex-col gap-4">
                <tr>
                  <td className="  text-black">
                    <strong className="text-xs tablet:text-sm font-semibold largeLaptop:text-lg ">
                      {" "}
                      Working Principle:
                    </strong>{" "}
                    <span className="text-sm">The Sprinter XL operates using advanced IFA automation
                      technology, automating every step of the ImmunoFluorescence
                      Assay process. The machine detects antigens in patient
                      samples using fluorescent-labeled antibodies. The system
                      automates the application, incubation, washing, and
                      detection stages. Fluorescence signals are measured and
                      quantified, delivering results with high precision.</span>
                  </td>
                </tr>
                <tr>
                  <td className="  text-black">
                    <strong className="text-xs tablet:text-sm font-semibold largeLaptop:text-lg ">
                      {" "}
                      For Whom It Is Useful:
                    </strong>{" "}
                    <span className="text-sm">The Sprinter XL is ideal for clinical diagnostic
                      laboratories, research institutions, and hospital labs that
                      require high-volume, automated testing. This fully automatic
                      IFA processor is especially beneficial for facilities that
                      need to optimize their workflows and enhance testing
                      capabilities across a wide range of assays. Its dual
                      functionality makes it valuable for labs that handle diverse
                      testing requirements.</span>
                  </td>
                </tr>
                <tr>
                  <td className="  text-black">
                    <strong className="text-xs tablet:text-sm font-semibold largeLaptop:text-lg ">
                      {" "}
                      Use Cases:
                    </strong>
                    <ul className="list-disc pl-5 ">
                      <li>
                        <span className="text-sm">Autoimmune Disease Diagnostics: Efficiently automates
                          detection of autoimmune markers for timely patient
                          management.</span>
                      </li>
                      <li>
                        <span className="text-sm">Infectious Disease Testing: Automates IFA tests for
                          infectious diseases, enabling quicker diagnosis and
                          intervention.</span>
                      </li>
                      <li>
                        <span className="text-sm">Endocrinology Testing: Supports hormonal assays,
                          ensuring accurate analysis of endocrine function.</span>
                      </li>

                      <li>
                        <span className="text-sm">Research and Development: Ideal for research labs in
                          immunology, infectious diseases, and more.</span>
                      </li>
                    </ul>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        ),

        advantages: (
          <div>
            <ul className="space-y-6 font-poppins">
              <li className="flex gap-3">
                <p className="text-sm largeLaptop:text-2xl font-medium text-gray-800">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Scalable Automation:
                  Handles large volumes of samples, making it suitable for labs
                  with growing testing demands.
                </p>
              </li>
              <li className="flex gap-3">
                <p className="text-sm largeLaptop:text-2xl font-medium text-gray-800">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Precision and
                  Reliability: Delivers consistent, high-quality results,
                  reducing variability and ensuring confidence in diagnostic
                  outcomes.
                </p>
              </li>
              <li className="flex gap-3">
                <p className="text-sm largeLaptop:text-2xl font-medium text-gray-800">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Versatile Testing
                  Capabilities: Dual functionality allows the Sprinter XL to
                  handle IFA, enhancing flexibility.
                </p>
              </li>
              <li className="flex gap-3">
                <p className="text-sm largeLaptop:text-2xl font-medium text-gray-800">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Minimized Manual
                  Intervention: Reduces human error, improving overall lab
                  efficiency.
                </p>
              </li>
              <li className="flex gap-3">
                <p className="text-sm largeLaptop:text-2xl font-medium text-gray-800">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Optimized Workflow:
                  Compact, space-saving design integrates easily into lab setups
                  without compromising performance.
                </p>
              </li>
            </ul>
          </div>
        ),

        benefits: (
          <div>
            <ul className="space-y-6 font-poppins">
              <li className="flex gap-3">
                <p className="text-sm largeLaptop:text-2xl font-medium text-gray-800">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Increased
                  Productivity: High-throughput automation processes more
                  samples in less time, enhancing operational efficiency.
                </p>
              </li>
              <li className="flex gap-3">
                <p className="text-sm largeLaptop:text-2xl font-medium text-gray-800">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Improved Accuracy:
                  Consistent results contribute to better diagnostic accuracy
                  and improved patient outcomes.
                </p>
              </li>
              <li className="flex gap-3">
                <p className="text-sm largeLaptop:text-2xl font-medium text-gray-800">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Cost-Effective
                  Operation: Reduces labor costs and minimizes the need for
                  repeat testing, leading to overall savings.
                </p>
              </li>
              <li className="flex gap-3">
                <p className="text-sm largeLaptop:text-2xl font-medium text-gray-800">
                  {" "}
                  <span className="text-[#10b981]">◆</span> User-Friendly
                  Design: Simplified interface and controls allow quick
                  operation with minimal training.
                </p>
              </li>
            </ul>
          </div>
        ),

        testMenu: [""],
        mainAndCare: (
          <div>
            <ul className="space-y-6 font-poppins">
              <li className="flex gap-3">
                <p className="text-sm largeLaptop:text-2xl font-medium text-gray-800">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Automated
                  Maintenance Alerts: Provides notifications for routine
                  maintenance to keep the system in optimal condition.
                </p>
              </li>
              <li className="flex gap-3">
                <p className="text-sm largeLaptop:text-2xl font-medium text-gray-800">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Easy Access for
                  Servicing: Designed for quick and efficient maintenance with
                  easy access to internal components.
                </p>
              </li>
              <li className="flex gap-3">
                <p className="text-sm largeLaptop:text-2xl font-medium text-gray-800">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Low Maintenance
                  Requirements: Durable construction minimizes downtime and
                  reduces the need for frequent repairs.
                </p>
              </li>
              <li className="flex gap-3">
                <p className="text-sm largeLaptop:text-2xl font-medium text-gray-800">
                  {" "}
                  <span className="text-[#10b981]">◆</span> User Manuals and
                  Support: Detailed manuals and expert support ensure proper
                  maintenance procedures.
                </p>
              </li>
              <li className="flex gap-3">
                <p className="text-sm largeLaptop:text-2xl font-medium text-gray-800">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Long-Term
                  Reliability: Built for consistent, long-term use with minimal
                  operational interruptions.
                </p>
              </li>
            </ul>
          </div>
        ),
        workServices: "Technical support available for setup and service.",
        productBrochure: "path/to/Sprintezr XL-brochure.pdf",
        detailedSpecification:
          "Detailed specifications available upon request.",
        offerOrDiscounts:
          "Inquire about current promotions and discounts with distributor.",
      },
      {
        id: "18",
        slug: 'afias-1',
        image: [
          { src: afiaswhite1, alt: "AFIAS 1 POCT analyzer for rapid immunoassay diagnostics" },
          { src: afiaswhite2, alt: "AFIAS 1 point-of-care analyzer with dual test cartridge slots" },
          { src: afiaswhite3, alt: "AFIAS 1 analyzer designed for high-volume point-of-care testing" },
        ],
        coverImg: afiasgrey1,
        section: "fia",
        title: "AFIAS‑1",
        shortdescription:
          "The AFIAS-1 is an advanced automated immunoassay analyzer developed by Boditech Med for use in point-of-care testing (POCT). It employs fluorescence-labeled immunoassay technology to deliver accurate and rapid diagnostic results.  The AFIAS- 1 is compact, user - friendly, and supports a wide range of tests.Its all -in -one cartridge system makes it an ideal solution for clinics, emergency rooms, and decentralized healthcare settings.",
        description:
          "The AFIAS-1 is a compact, single-channel immunoassay analyzer developed by Boditech. Utilizing fluorescence- based technology, it delivers rapid and precise diagnostic results with minimal user intervention.Designed for point - of - care settings, it offers convenience, accuracy, and a small footprint for efficient testing.",
        description1:
          "AFIAS 1 offers a wide range of diagnostic parameters covering Cardiac, Cancer, Diabetes, Hormones, Autoimmune, Infection, and Therapeutic Drug Monitoring (TDM) and other test items. It delivers reliable quantitative results across multiple disease categories with precision and speed.",
        workPrinciple: (
          <div>
            <table className="min-w-full table-auto">
              <tbody className="flex flex-col gap-4">
                <tr>
                  <td className="  text-black">
                    <strong className="text-wrap tablet:text-sm largelaptop:text-sm">
                      Working Principle:
                    </strong>{" "}
                    <span className="text-sm">The AFIAS-1 utilizes fluorescence-based immunoassay technology to detect
                      target biomarkers in patient samples. With its fully automated single-test processing and cartridge-based system, it ensures reliable results within minutes.</span>
                  </td>
                </tr>
                <tr>
                  <td className="  text-black">
                    <strong className="text-wrap tablet:text-sm largelaptop:text-sm">
                      For Whom It Is Useful:
                    </strong>{" "}
                    <span className="text-sm">Designed for small clinics, physician offices, and remote care settings that require accurate testing with minimal space and training.</span>
                  </td>
                </tr>
                <tr>
                  <td className="  text-black">
                    <strong className="text-wrap tablet:text-sm largelaptop:text-sm">
                      Use Cases:
                    </strong>
                    <span className="text-sm">Ideal for single-patient diagnostics such as infectious diseases, hormone levels, and
                      inflammation markers at the point of care.</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        ),

        advantages: (
          <div>
            <ul className="space-y-6 font-poppins">
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> High precision with fluorescence-based detection
                </p>
              </li>
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Rapid turnaround time for results
                </p>
              </li>
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Compact and user-friendly design
                </p>
              </li>
            </ul>
          </div>
        ),

        benefits: (
          <div>
            <ul className="space-y-6 font-poppins">
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Improves diagnostic efficiency and accuracy
                </p>
              </li>
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Enhances patient throughput with quick testing
                </p>
              </li>
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Simplifies the diagnostic process for healthcare providers
                </p>
              </li>
            </ul>
          </div>
        ),

        testMenu: [""],
        mainAndCare: (
          <div>
            <ul className="space-y-6 font-poppins">
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> <strong>Regular Calibration:</strong> Perform periodic calibration to ensure consistent accuracy.
                </p>
              </li>
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> <strong>Routine Cleaning:</strong> Clean the sample ports and internal components regularly.
                </p>
              </li>
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> <strong>Software Updates:</strong> Keep the software up-to-date to utilize the latest features and improvements.
                </p>
              </li>
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> <strong>Preventive Maintenance:</strong> Schedule regular maintenance checks with certified technicians to maintain optimal performance.
                </p>
              </li>
            </ul>
          </div>
        ),
        workServices:
          "Available technical support for installation and troubleshooting.",
        productBrochure: "path/to/eurostar-iii-plus-brochure.pdf",
        detailedSpecification: "Specifications can be provided on request.",
        offerOrDiscounts:
          "Check with distributor for current offers and discounts.",
      },
      {
        id: "19",
        slug: 'afias-3',
        image: [
          { src: afias3white1, alt: "AFIAS 3 analyzer variant with updated cartridge loading system" },
          { src: afias3white2, alt: "AFIAS 3 diagnostic analyzer showing display and testing ports" },
          { src: afias3white3, alt: "AFIAS 3 POCT analyzer with compact automated testing design" },
        ],
        coverImg: afias3grey1,
        section: "fia",
        title: "AFIAS‑3",
        shortdescription:
          "The AFIAS-3 is a compact and efficient immunoassay analyzer designed by Boditech Med for small- to mid-volume point-of-care testing (POCT). Utilizing advanced fluorescence immunoassay technology, it offers simultaneous processing of up to three tests with minimal hands-on time. Its user-friendly interface, all-in-one cartridge system, and real-time data connectivity make it a practical choice for clinics, outpatient centers, and hospital departments seeking fast and reliable diagnostics.",
        description:
          "The AFIAS-3 is a mid-capacity immunoassay analyzer that supports up to three simultaneous tests. Built by Boditech and based on fluorescence immunoassay technology, it ensures fast, accurate diagnostics while maintaining a user- friendly interface. It is well - suited for clinics and decentralized testing environments that require reliable multi- test capabilities. AFIAS 1 offers a wide range of diagnostic parameters covering Cardiac, Cancer, Diabetes, Hormones, Autoimmune, Infection, and Therapeutic Drug Monitoring (TDM) and other test items. It delivers reliable quantitative results across multiple disease categories with precision and speed. ",
        workPrinciple: (
          <div>
            <table className="min-w-full table-auto">
              <tbody className="flex flex-col gap-4">
                <tr>
                  <td className="  text-black">
                    <strong className="text-wrap tablet:text-sm largelaptop:text-sm">
                      Working Principle:
                    </strong>{" "}
                    <span className="text-sm">The AFIAS-3 performs up to three tests simultaneously using fluorescence immunoassay detection.
                      It features an intuitive interface and automated sample-to-result workflow for fast, hands-off operation.</span>
                  </td>
                </tr>
                <tr>
                  <td className="  text-black">
                    <strong className="text-wrap tablet:text-sm largelaptop:text-sm">
                      For Whom It Is Useful:
                    </strong>{" "}
                    <span className="text-sm">Perfect for outpatient clinics, emergency rooms, and specialty practices that demand quick turnaround
                      for multiple tests.</span>
                  </td>
                </tr>
                <tr>
                  <td className="  text-black">
                    <strong className="text-wrap tablet:text-sm largelaptop:text-sm">
                      Use Cases:
                    </strong>
                    <span className="text-sm">Well-suited for mid-volume testing of cardiac markers, thyroid function, tumor markers, and infectious diseases.</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        ),

        advantages: (
          <div>
            <ul className="space-y-6 font-poppins">
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> High precision with fluorescence-based detection
                </p>
              </li>
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Rapid turnaround time for results
                </p>
              </li>
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Compact and user-friendly design
                </p>
              </li>
            </ul>
          </div>
        ),

        benefits: (
          <div>
            <ul className="space-y-6 font-poppins">
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Improves diagnostic efficiency and accuracy
                </p>
              </li>
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Enhances patient throughput with quick testing
                </p>
              </li>
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Simplifies the diagnostic process for healthcare providers
                </p>
              </li>
            </ul>
          </div>
        ),

        testMenu: [""],
        mainAndCare: (
          <div>
            <ul className="space-y-6 font-poppins">
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> <strong>Regular Calibration:</strong> Perform periodic calibration to ensure consistent accuracy.
                </p>
              </li>
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> <strong>Routine Cleaning:</strong> Clean the sample ports and internal components regularly.
                </p>
              </li>
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> <strong>Software Updates:</strong> Keep the software up-to-date to utilize the latest features and improvements.
                </p>
              </li>
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> <strong>Preventive Maintenance:</strong> Schedule regular maintenance checks with certified technicians to maintain optimal performance.
                </p>
              </li>
            </ul>
          </div>
        ),
        workServices:
          "Available technical support for installation and troubleshooting.",
        productBrochure: "path/to/eurostar-iii-plus-brochure.pdf",
        detailedSpecification: "Specifications can be provided on request.",
        offerOrDiscounts:
          "Check with distributor for current offers and discounts.",
      },
      {
        id: "20",
        slug: 'afias-6',
        image: [
          { src: afias6white1, alt: "AFIAS 6 analyzer supporting multiple simultaneous immunoassays" },
          { src: afias6white2, alt: "AFIAS 6 POCT system for fast, automated clinical diagnostics" },
          { src: afias6white3, alt: "AFIAS 6 analyzer variant with expanded assay processing module" },
        ],
        coverImg: afias6grey1,
        section: "fia",
        title: "AFIAS‑6",
        shortdescription:
          "The AFIAS-6 is a fully automated immunoassay analyzer tailored for medium-throughput point-of-care testing (POCT). Developed by Boditech Med, it processes up to six tests simultaneously using fluorescence-labeled technology. With its intuitive operation, minimal sample handling, and broad test menu, the AFIAS-6 is ideal for busy clinical environments requiring rapid, accurate, and scalable diagnostic solutions.",
        description:
          "The AFIAS-6 is an automated immunoassay analyzer that performs up to six tests at once. Leveraging Boditech’s fluorescence- based system, it combines speed, accuracy, and automation in one platform.It is optimized for medium - throughput settings requiring efficient and scalable diagnostic workflows. AFIAS 1 offers a wide range of diagnostic parameters covering Cardiac, Cancer, Diabetes, Hormones, Autoimmune, Infection, and Therapeutic Drug Monitoring (TDM) and other test items. It delivers reliable quantitative results across multiple disease categories with precision and speed. ",
        workPrinciple: (
          <div>
            <table className="min-w-full table-auto">
              <tbody className="flex flex-col gap-4">
                <tr>
                  <td className="  text-black">
                    <strong className="text-wrap tablet:text-sm largelaptop:text-sm">
                      Working Principle:
                    </strong>{" "}

                    <span className="text-sm">The AFIAS-6 uses advanced fluorescence-based technology to perform six tests simultaneously. It automates sample handling and analysis, improving throughput while requiring minimal operator involvement.</span>
                  </td>
                </tr>
                <tr>
                  <td className="  text-black">
                    <strong className="text-wrap tablet:text-sm largelaptop:text-sm">
                      For Whom It Is Useful:
                    </strong>{" "}
                    <span className="text-sm">It is designed for mid-sized hospitals, diagnostic laboratories, and busy clinical settings that require efficient and accurate testing.</span>
                  </td>
                </tr>
                <tr>
                  <td className="  text-black">
                    <strong className="text-wrap tablet:text-sm largelaptop:text-sm">
                      Use Cases:
                    </strong>
                    <span className="text-sm">It supports a wide range of assays, including cardiac panels, diabetes monitoring, sepsis detection, and fertility hormone analysis.</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        ),

        advantages: (
          <div>
            <ul className="space-y-6 font-poppins">
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> High precision with fluorescence-based detection
                </p>
              </li>
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Rapid turnaround time for results
                </p>
              </li>
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Compact and user-friendly design
                </p>
              </li>
            </ul>
          </div>
        ),

        benefits: (
          <div>
            <ul className="space-y-6 font-poppins">
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Improves diagnostic efficiency and accuracy
                </p>
              </li>
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Enhances patient throughput with quick testing
                </p>
              </li>
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Simplifies the diagnostic process for healthcare providers
                </p>
              </li>
            </ul>
          </div>
        ),

        testMenu: [""],
        mainAndCare: (
          <div>
            <ul className="space-y-6 font-poppins">
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> <strong>Regular Calibration:</strong> Perform periodic calibration to ensure consistent accuracy.
                </p>
              </li>
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> <strong>Routine Cleaning:</strong> Clean the sample ports and internal components regularly.
                </p>
              </li>
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> <strong>Software Updates:</strong> Keep the software up-to-date to utilize the latest features and improvements.
                </p>
              </li>
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> <strong>Preventive Maintenance:</strong> Schedule regular maintenance checks with certified technicians to maintain optimal performance.
                </p>
              </li>
            </ul>
          </div>
        ),
        workServices:
          "Available technical support for installation and troubleshooting.",
        productBrochure: "path/to/eurostar-iii-plus-brochure.pdf",
        detailedSpecification: "Specifications can be provided on request.",
        offerOrDiscounts:
          "Check with distributor for current offers and discounts.",
      },
      {
        id: "21",
        slug: 'afias-10',
        image: [
          { src: afias10white1, alt: "AFIAS 10 high-throughput immunoassay analyzer for clinical labs" },
          { src: afias10white2, alt: "AFIAS 10 analyzer displaying multi-channel testing capabilities" },
          { src: afias10white3, alt: "AFIAS 10 automated immunoassay system for large-volume testing" },
        ],
        coverImg: afias10grey1,
        section: "fia",
        title: "AFIAS‑10",
        shortdescription:
          "The AFIAS-10 is a high-throughput, fully automated immunoassay analyzer designed to meet the needs of high-demand POCT environments. Capable of performing up to ten tests concurrently, it delivers fast and precise results using fluorescence-based immunoassay technology. The AFIAS-10 has walk-away operation, a wide test panel, and strong data integration features. It is ideal for hospitals, large clinics, and central labs. settings that need efficient and scalable diagnostic performance.",
        description:
          "The AFIAS-10 is a high-throughput immunoassay analyzer capable of running ten tests simultaneously. Powered by Boditech’s advanced fluorescence immunoassay technology, it delivers fast, precise results with walk - away automation.Perfect for hospitals and high- demand environments, it ensures seamless operation and maximum productivity. AFIAS 1 offers a wide range of diagnostic parameters covering Cardiac, Cancer, Diabetes, Hormones, Autoimmune, Infection, and Therapeutic Drug Monitoring (TDM) and other test items. It delivers reliable quantitative results across multiple disease categories with precision and speed. ",
        workPrinciple: (
          <div>
            <table className="min-w-full table-auto">
              <tbody className="flex flex-col gap-4">
                <tr>
                  <td className="  text-black">
                    <strong className="text-wrap tablet:text-sm largelaptop:text-sm">
                      Working Principle:
                    </strong>{" "}

                    <span className="text-sm">The AFIAS-10 uses fluorescence immunoassay technology to fully automate the testing process. It runs up to ten tests simultaneously and offers walk-away functionality with high throughput.</span>
                  </td>
                </tr>
                <tr>
                  <td className="  text-black">
                    <strong className="text-wrap tablet:text-sm largelaptop:text-sm">
                      For Whom It Is Useful:
                    </strong>{" "}
                    <span className="text-sm">This system serves large hospitals, central labs, and high-volume facilities that need scalable, automated diagnostic solutions.</span>
                  </td>
                </tr>
                <tr>
                  <td className="  text-black">
                    <strong className="text-wrap tablet:text-sm largelaptop:text-sm">
                      Use Cases:
                    </strong>
                    <span className="text-sm">It supports comprehensive diagnostic panels, including cardiac, infectious disease, metabolic, and critical care testing.</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        ),

        advantages: (
          <div>
            <ul className="space-y-6 font-poppins">
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> High precision with fluorescence-based detection
                </p>
              </li>
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Rapid turnaround time for results
                </p>
              </li>
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Compact and user-friendly design
                </p>
              </li>
            </ul>
          </div>
        ),

        benefits: (
          <div>
            <ul className="space-y-6 font-poppins">
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Improves diagnostic efficiency and accuracy
                </p>
              </li>
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Enhances patient throughput with quick testing
                </p>
              </li>
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Simplifies the diagnostic process for healthcare providers
                </p>
              </li>
            </ul>
          </div>
        ),

        testMenu: [""],
        mainAndCare: (
          <div>
            <ul className="space-y-6 font-poppins">
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> <strong>Regular Calibration:</strong> Perform periodic calibration to ensure consistent accuracy.
                </p>
              </li>
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> <strong>Routine Cleaning:</strong> Clean the sample ports and internal components regularly.
                </p>
              </li>
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> <strong>Software Updates:</strong> Keep the software up-to-date to utilize the latest features and improvements.
                </p>
              </li>
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> <strong>Preventive Maintenance:</strong> Schedule regular maintenance checks with certified technicians to maintain optimal performance.
                </p>
              </li>
            </ul>
          </div>
        ),
        workServices:
          "Available technical support for installation and troubleshooting.",
        productBrochure: "path/to/eurostar-iii-plus-brochure.pdf",
        detailedSpecification: "Specifications can be provided on request.",
        offerOrDiscounts:
          "Check with distributor for current offers and discounts.",
      },
    ],
  },
  // Point of Care
  {
    category: "Point of Care",
    categoryURL: 'point-of-care',
    subsection: [
      //  "Reagents"
    ],
    items: [
      {
        topic: "POCT Hormone Analyzer",
        id: "2",
        slug: 'ichroma-3',
        section: 'ichroma',
        image: [

          { src: ichromaIII, alt: "Boditech ichroma III compact POCT analyzer for accurate clinical testing" },
        ],
        coverImg: ichromaIIIGrey,
        title: "ichroma™ III",
        shortdescription:
          "The ichroma™ III is a state-of-the-art immunoassay analyzer that uses fluorescence-based technology to provide quick and accurate diagnostic results. This POCT device is designed to meet the demands of modern healthcare facilities, ensuring reliable performance and ease of use.",
        description:
          "The ichroma™ III is an advanced immunoassay analyzer designed for point-of-care testing (POCT). Leveraging fluorescence-based technology, this Boditech POCT device delivers rapid and accurate diagnostic results. Ideal for various healthcare settings, it offers high throughput and user-friendly operation.",
        workPrinciple: (
          <div>
            {/* Working Principle Table */}
            <table className="min-w-full table-auto">
              <tbody className="flex flex-col gap-4">
                <tr>
                  <td className="  text-black">
                    <strong className="text-xs tablet:text-sm font-semibold largeLaptop:text-lg ">
                      {" "}
                      <span className="font-semibold tablet:text-sm largeLaptop:text-2xl  text-xs">
                        How it Works
                      </span>
                      :
                    </strong>{" "}
                    <span className="text-sm">The ichroma™ III utilizes fluorescence-based technology to
                      detect specific biomarkers in patient samples. It processes
                      samples quickly, providing results in minutes.</span>
                  </td>
                </tr>
                <tr>
                  <td className="  text-black">
                    <strong className="text-xs tablet:text-sm font-semibold largeLaptop:text-lg ">
                      {" "}
                      For Whom:
                    </strong>{" "}
                    <span className="text-sm">Ideal for hospitals, clinics, and diagnostic centers
                      requiring rapid test results.</span>
                  </td>
                </tr>
                <tr>
                  <td className="  text-black">
                    <strong className="text-xs tablet:text-sm font-semibold largeLaptop:text-lg ">
                      {" "}
                      Use Cases:
                    </strong>{" "}
                    <span className="text-sm">Suitable for various tests including cardiac markers,
                      infectious diseases, and more.</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        ),

        advantages: (
          <div>
            {/* Advantages List */}
            <ul className="space-y-6 font-poppins">
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> High precision with
                  fluorescence-based detection
                </p>
              </li>
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Quick turnaround
                  time for test results
                </p>
              </li>
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Easy-to-use
                  interface
                </p>
              </li>
            </ul>
          </div>
        ),

        benefits: (
          <div>
            {/* Benefits List */}
            <ul className="space-y-6 font-poppins">
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Enhances diagnostic
                  efficiency and accuracy
                </p>
              </li>
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Increases patient
                  throughput with rapid testing
                </p>
              </li>
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Simplifies the
                  testing process for healthcare providers
                </p>
              </li>
            </ul>
          </div>
        ),

        testMenu: [""],
        mainAndCare: (
          <div>
            {/* Maintenance and Care List */}
            <ul className="space-y-6 font-poppins">
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Regular Calibration:
                  Perform periodic calibration to maintain accuracy.
                </p>
              </li>
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Routine Cleaning:
                  Clean the sample ports and internal components regularly.
                </p>
              </li>
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Software Updates:
                  Keep the software updated to access the latest features and
                  improvements.
                </p>
              </li>
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Preventive
                  Maintenance: Schedule regular maintenance checks by certified
                  technicians to ensure long-term reliability.
                </p>
              </li>
            </ul>
          </div>
        ),

        workServices:
          "Support services available for operational and technical assistance.",
        productBrochure: "path/to/ichroma-III-brochure.pdf",
        detailedSpecification:
          "Detailed specifications available upon request.",
        offerOrDiscounts:
          "Check with the distributor for any available offers and discounts.",
      },
      {
        topic: "POCT Hormone Analyzer",
        id: "1",
        slug: 'ichroma-2',
        section: 'ichroma',
        image: [

          { src: ichromaII, alt: "Boditech ichroma II advanced point-of-care testing analyzer for rapid results" },
        ],
        coverImg: ichromaIIGrey,
        title: "ichroma™ II",
        shortdescription:
          "The ichroma™ II is an advanced immunoassay analyzer that leverages fluorescence-based technology to deliver quick and accurate diagnostic results. Engineered by Boditech, this POCT device is ideal for modern healthcare environments, ensuring dependable performance and ease of use.",
        description:
          "The ichroma™ II is a sophisticated immunoassay analyzer designed for point-of-care testing (POCT). Utilizing fluorescence-based technology, this Boditech POCT device offers rapid and reliable diagnostic results. Perfect for a variety of healthcare settings, it combines high accuracy with user-friendly features.",
        workPrinciple: (
          <div>
            {/* Working Principle Table */}
            <table className="min-w-full table-auto">
              <tbody className="flex flex-col gap-4">
                <tr>
                  <td className="  text-black">
                    <strong className="text-xs tablet:text-sm font-semibold largeLaptop:text-lg ">
                      {" "}
                      <span className="font-semibold tablet:text-sm largeLaptop:text-2xl  text-xs">
                        How it Works
                      </span>
                      :
                    </strong>{" "}
                    <span className="text-sm">The ichroma™ II uses fluorescence-based detection to
                      identify specific biomarkers in patient samples. It
                      processes the samples rapidly, delivering results in just
                      minutes.</span>
                  </td>
                </tr>
                <tr>
                  <td className="  text-black">
                    <strong className="text-xs tablet:text-sm font-semibold largeLaptop:text-lg ">
                      {" "}
                      For Whom:
                    </strong>{" "}
                    <span className="text-sm">Suitable for hospitals, clinics, and diagnostic centers that
                      need fast and accurate testing.</span>
                  </td>
                </tr>
                <tr>
                  <td className="  text-black">
                    <strong className="text-xs tablet:text-sm font-semibold largeLaptop:text-lg ">
                      {" "}
                      Use Cases:
                    </strong>{" "}
                    <span className="text-sm">Ideal for tests such as cardiac markers, infectious
                      diseases, and other critical diagnostics.</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        ),

        advantages: (
          <div>
            {/* Advantages List */}
            <ul className="space-y-6 font-poppins">
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> High precision with
                  fluorescence-based detection
                </p>
              </li>
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Rapid turnaround
                  time for results
                </p>
              </li>
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Compact and
                  user-friendly design
                </p>
              </li>
            </ul>
          </div>
        ),

        benefits: (
          <div>
            {/* Benefits List */}
            <ul className="space-y-6 font-poppins">
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Improves diagnostic
                  efficiency and accuracy
                </p>
              </li>
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Enhances patient
                  throughput with quick testing
                </p>
              </li>
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Simplifies the
                  diagnostic process for healthcare providers
                </p>
              </li>
            </ul>
          </div>
        ),

        testMenu: [""],
        mainAndCare: (
          <div>
            {/* Maintenance and Care List */}
            <ul className="space-y-6 font-poppins">
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Regular Calibration:
                  Perform periodic calibration to ensure consistent accuracy.
                </p>
              </li>
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Routine Cleaning:
                  Clean the sample ports and internal components regularly.
                </p>
              </li>
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Software Updates:
                  Keep the software up-to-date to utilize the latest features
                  and improvements.
                </p>
              </li>
              <li className="flex gap-3">
                <p className=" text-xs largeLaptop:text-xl tablet:text-sm text-black font-normal text-wrap ">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Preventive
                  Maintenance: Schedule regular maintenance checks with
                  certified technicians to maintain optimal performance.
                </p>
              </li>
            </ul>
          </div>
        ),

        workServices:
          "Technical support available for setup, troubleshooting, and maintenance.",
        productBrochure: "path/to/ichroma-II-brochure.pdf",
        detailedSpecification:
          "Detailed specifications available upon request.",
        offerOrDiscounts:
          "Inquire about current offers and discounts with distributor.",
      },
    ],
  },
  {
    category: "Molecular Diagnostics",
    categoryURL: 'molecular-diagnostics',
    subsection: [

      // "Reagents"
    ],
    items: [
      {
        topic: "LABScan 3D",
        id: "1",
        slug: 'labscan-3d',
        section: 'labscan',
        image: [

          { src: labscan3D, alt: "Luminex LABScan 3D multiplexing analyzer for diagnostic testing" },
        ],
        coverImg: labscan3DGrey,
        title: "LABScan 3D",
        alt: "Luminex LABScan 3D multiplexing analyzer for diagnostic testing",
        shortdescription: "LABScan3DTM - the most advanced multiplex flow analyzer. Processes LABType™™ assays for HLA typing of Class I/II alleles, and LABScreen™™ assays for HLA antibody screening, detection of DSA, and profiling complement binding antibodies.",
        description:
          "Designed to provide breakthrough performance, higher throughput, and greater flexibility to transplant diagnostics, the LABScan3D™is the most advanced IVD approved Luminex® system available. Dual syringe pumps and reagent reservoirs allow for higher throughput and programmable maintenance routines. Able to process 500 bead regions simultaneously, LABScan3D significantly increases the number of screenable analytes. This advanced instrument is compatible with all of One Lambda’s LABType™ and LABScreen™ products.",
        workPrinciple: (
          <div>
            <table className="min-w-full table-auto">
              <tbody className="flex flex-col gap-4">
                <tr>
                  <td className="  text-black">
                    <strong className="text-xs tablet:text-sm font-semibold largeLaptop:text-lg ">
                      {" "}
                      Working Principle: How It Works? <br />
                    </strong>
                    <span className="text-sm">xMAP® Technology.</span>
                  </td>
                </tr>
                <tr>
                  <td className="  text-black">
                    <strong className="text-xs tablet:text-sm font-semibold largeLaptop:text-lg ">
                      {" "}
                      For Whom It Is Useful? <br />
                    </strong>
                    <span className="text-sm"> Transplant Immunology, Molecular Oncology, and
                      Immunogenetics</span>
                  </td>
                </tr>
                <tr>
                  <td className="  text-black">
                    <strong className="text-xs tablet:text-sm font-semibold largeLaptop:text-lg ">
                      {" "}
                      Use Cases:
                    </strong>
                    <ul className="list-disc pl-5 text-sm">
                      <span className="text-sm"><li>500 bead count</li></span>
                      <span className="text-sm"><li>Can use to know Extended coverage</li></span>
                      <span className="text-sm"><li>
                        High throughput up to 384 samples in a single batch
                      </li></span>
                      <span className="text-sm"><li>Auto-adjust probe for accurate acquisition</li></span>
                    </ul>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        ),

        advantages: (
          <div>
            <ul className="space-y-6 font-poppins">
              <li className="flex gap-3">
                <p className="text-sm largeLaptop:text-2xl font-medium text-gray-800">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Programmable and
                  automated maintenance routines
                </p>
              </li>
              <li className="flex gap-3">
                <p className="text-sm largeLaptop:text-2xl font-medium text-gray-800">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Intuitive graphical
                  user interface
                </p>
              </li>
              <li className="flex gap-3">
                <p className="text-sm largeLaptop:text-2xl font-medium text-gray-800">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Enhanced data
                  archiving
                </p>
              </li>
              <li className="flex gap-3">
                <p className="text-sm largeLaptop:text-2xl font-medium text-gray-800">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Customizable
                  import/export options simplify data exchange
                </p>
              </li>
            </ul>
          </div>
        ),

        benefits: (
          <div>
            <ul className="space-y-6 font-poppins">
              <li className="flex gap-3">
                <p className="text-sm largeLaptop:text-2xl font-medium text-gray-800">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Multiplexing
                  capability with 500 unique bead regions for increased analyte
                  detection
                </p>
              </li>
              <li className="flex gap-3">
                <p className="text-sm largeLaptop:text-2xl font-medium text-gray-800">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Accelerated
                  acquisition with dual sample fluidics paths and increased
                  syringe injection rate
                </p>
              </li>
              <li className="flex gap-3">
                <p className="text-sm largeLaptop:text-2xl font-medium text-gray-800">
                  {" "}
                  <span className="text-[#10b981]">◆</span> High throughput
                  testing with reduced turnaround time
                </p>
              </li>
              <li className="flex gap-3">
                <p className="text-sm largeLaptop:text-2xl font-medium text-gray-800">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Compatible with
                  classic LABScan™ 100 based assays and new LABScan3D specific
                  assays
                </p>
              </li>
            </ul>
          </div>
        ),
        testMenu: [""],
        mainAndCare:
          "Requires regular maintenance for optimal performance. The manufacturer's maintenance schedule should be followed to ensure long-term reliability and accuracy.",
        workServices:
          "Offers comprehensive services for installation, maintenance, and technical troubleshooting to ensure seamless operation.",
        productBrochure: "path/to/labscan-3d-brochure.pdf",
        detailedSpecification:
          "Key specifications include sorting capacity for moderate sample volumes, customizable speed settings, and compatibility with a range of sample containers.",
        offerOrDiscounts:
          "Check with the distributor for current offers or discounts, including bundle deals with other lab equipment.",
      },
      {
        topic: "LABScan 100",
        id: "2",
        section: 'labscan',
        slug: 'labscan-100',
        image: [

          { src: labscan100, alt: "LABScan 100 analyzer used for multiplex bead-based diagnostic assays" },
        ],
        coverImg: labscan100Grey,
        title: "LABScan 100",
        alt: "LABScan 100 analyzer used for multiplex bead-based diagnostic assays",
        shortdescription:
          "  The ability to perform up to 100 different tests in a single reaction volume, and to use either magnetic beads or plain polystyrene beads makes this instrument a popular choice for laboratories needing greater flexibility. Additionally, the Luminex 200 is able to offer higher sample throughput with a 96-well plate read time of only 45 minutes.",
        description:
          "The Luminex® 200™, a flow-based reader, sets the standard for multiplexing with thousands of instruments sold globally and more than fifty FDA 510(k) cleared assays using xMAP® Technology. The ability to perform up to 100 different tests in a single reaction volume, and to use either magnetic beads or plain polystyrene beads makes this instrument a popular choice for laboratories needing greater flexibility.",
        workPrinciple: (
          <div>
            <table className="min-w-full table-auto">
              <tbody className="flex flex-col gap-4">
                <tr>
                  <td className="  text-black">
                    <strong className="text-xs tablet:text-sm font-semibold largeLaptop:text-lg ">
                      {" "}
                      Working Principle: How It Works? <br />
                    </strong>
                    <span className="text-sm">xMAP® Technology.</span>
                  </td>
                </tr>
                <tr>
                  <td className="  text-black">
                    <strong className="text-xs tablet:text-sm font-semibold largeLaptop:text-lg ">
                      {" "}
                      For Whom It Is Useful? <br />
                    </strong>
                    <span className="text-sm">Transplant Immunology, Molecular Oncology, and
                      Immunogenetics</span>
                  </td>
                </tr>
                <tr>
                  <td className="  text-black">
                    <strong className="text-xs tablet:text-sm font-semibold largeLaptop:text-lg ">
                      {" "}
                      Use Cases:
                    </strong>
                    <ul className="list-disc pl-5 ">
                      <span className="text-sm"> <li>100 different tests in a single reaction volume</li></span>
                      <span className="text-sm"><li>
                        Antibody screen and Mid-resolution HLA can be performed
                        in a single go
                      </li></span>
                    </ul>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        ),

        advantages: (
          <div>
            <ul className="space-y-6 font-poppins">
              <li className="flex gap-3">
                <p className="text-sm largeLaptop:text-2xl font-medium text-gray-800">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Sample Probe Height
                  Adjustment Kit
                </p>
              </li>
              <li className="flex gap-3">
                <p className="text-sm largeLaptop:text-2xl font-medium text-gray-800">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Automated
                  Maintenance Plate
                </p>
              </li>
              <li className="flex gap-3">
                <p className="text-sm largeLaptop:text-2xl font-medium text-gray-800">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Heater Block
                  (96-well plate)
                </p>
              </li>
            </ul>
          </div>
        ),

        benefits: (
          <div>
            <ul className="space-y-6 font-poppins">
              <li className="flex gap-3">
                <p className="text-sm largeLaptop:text-2xl font-medium text-gray-800">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Flexible
                  Multiplexing Technology
                </p>
              </li>
              <li className="flex gap-3">
                <p className="text-sm largeLaptop:text-2xl font-medium text-gray-800">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Higher sample
                  throughput with a 96-well plate read time of only 45 minutes.
                </p>
              </li>
            </ul>
          </div>
        ),
        testMenu: [""],
        mainAndCare:
          "Minimal maintenance needed thanks to its built-in self-cleaning feature. Regular check-ups as per the manufacturer's guidelines will ensure long-lasting performance.",
        workServices:
          "Complete support services for installation, calibration, regular maintenance, and troubleshooting, ensuring smooth and uninterrupted lab operations.",
        productBrochure: "path/to/labscan-100-brochure.pdf",
        detailedSpecification:
          "The Labscan 100 offers specifications including higher sorting speed, increased capacity for larger labs, and compatibility with multiple sample types.",
        offerOrDiscounts:
          "Inquire with authorized distributors for ongoing promotions or discounts on bulk purchases or bundled offers.",
      },
    ],
  },
  {
    category: "Pre-Analytical Automation",
    categoryURL: 'pre-analytical-automation',
    subsection: [
      //  "Reagents"
    ],
    items: [
      {
        topic: "Sample Sorter",
        id: "1",
        slug: 'sortpro-sample-sorter',
        section: 'sample-sorter',
        image: [

          { src: PreAnalytical, alt: "Automated immunoblot analyzer system for western blot processing" },
        ],
        coverImg: PreAnalyticalGrey,
        title: "Sortpro Sample Sorter",
        shortdescription:
          "The Sortpro Sample Sorter is a high-performance sample sorting system that automates the pre-analytical process, ensuring samples are sorted accurately and efficiently. Designed to handle a variety of biological samples, including blood, urine, and other bodily fluids, this system automates sorting based on specific criteria, such as sample type, destination, or test requirements. The SORTPRO SAMPLE SORTER significantly reduces manual handling, lowering the risk of errors and improving overall laboratory productivity.",
        description:
          "The Sortpro Sample Sorter is an advanced automation system designed to optimize sample sorting and distribution with high efficiency and accuracy. It automates the entire sorting process, minimizing manual errors and streamlining laboratory workflows. Ideal for laboratories with high sample volumes, the SORTPRO SAMPLE SORTER increases productivity and ensures every sample is processed correctly and efficiently.",
        workPrinciple: (
          <div>
            <table className="min-w-full table-auto">
              <tbody className="flex flex-col gap-4">
                <tr>
                  <td className="  text-black">
                    <strong className="text-xs tablet:text-sm font-semibold largeLaptop:text-lg ">
                      {" "}
                      Working Principle: How It Works? <br />
                    </strong>
                    <span className="text-sm">The Sortpro Sample Sorter utilizes barcode scanning
                      technology to identify samples and sort them based on
                      pre-set criteria. After scanning, the system automatically
                      directs each sample to the appropriate location, whether for
                      testing, storage, or further processing. The automation
                      ensures consistency in handling large volumes of samples,
                      reducing the likelihood of mix-ups and ensuring that every
                      sample is processed according to the lab’s workflow
                      requirements. The system is flexible and can be customized
                      to meet the specific needs of different labs.</span>
                  </td>
                </tr>
                <tr>
                  <td className="  text-black">
                    <strong className="text-xs tablet:text-sm font-semibold largeLaptop:text-lg ">
                      {" "}
                      For Whom It Is Useful? <br />
                    </strong>
                    <span className="text-sm">The Sortpro Sample Sorter is ideal for clinical and
                      diagnostic laboratories, hospital labs, and research
                      facilities that need to manage high volumes of samples
                      efficiently. It is especially beneficial for labs that seek
                      to reduce manual sorting errors, increase throughput, and
                      optimize their pre-analytical processes. Whether your lab
                      handles routine diagnostics or complex testing, the SORTPRO
                      SAMPLE SORTER is designed to improve accuracy and streamline
                      operations.</span>
                  </td>
                </tr>
                <tr>
                  <td className="  text-black">
                    <strong className="text-xs tablet:text-sm font-semibold largeLaptop:text-lg ">
                      {" "}
                      Use Cases:
                    </strong>
                    <ul className="list-disc pl-5 ">
                      <span className="text-sm"><li>
                        High-Volume Sample Sorting: Automates sorting in
                        high-demand environments, reducing turnaround times and
                        improving efficiency.
                      </li></span>
                      <span className="text-sm"><li>
                        Pre-Analytical Automation: Streamlines the
                        pre-analytical phase by automating sorting, reducing
                        manual labor and the risk of errors.
                      </li></span>
                      <span className="text-sm"><li>
                        Customizable Sorting: Flexible enough to handle various
                        sample types and sorting criteria, adaptable to the
                        specific needs of your lab.
                      </li></span>
                      <span className="text-sm"><li>
                        Error Reduction: Minimizes the possibility of human
                        errors in sample sorting, ensuring consistency and
                        accuracy.
                      </li></span>
                      <span className="text-sm"><li>
                        Optimized Workflows: Increases productivity by enabling
                        lab staff to focus on more critical tasks while the
                        SORTPRO SAMPLE SORTER handles sorting.
                      </li></span>
                    </ul>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        ),

        advantages: (
          <div>
            <ul className="space-y-6 font-poppins">
              <li className="flex gap-3">
                <p className="text-sm largeLaptop:text-2xl font-medium text-gray-800">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Increased
                  Efficiency: Automates the sorting of large volumes of samples,
                  reducing manual intervention and speeding up processing.
                </p>
              </li>
              <li className="flex gap-3">
                <p className="text-sm largeLaptop:text-2xl font-medium text-gray-800">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Error Minimization:
                  Automation ensures accurate sorting, reducing the risk of
                  human errors and ensuring that every sample reaches its
                  correct destination.
                </p>
              </li>
              <li className="flex gap-3">
                <p className="text-sm largeLaptop:text-2xl font-medium text-gray-800">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Customizable
                  Solutions: The Sortpro Sample Sorter can be tailored to meet
                  the specific workflow requirements of your lab, ensuring
                  flexibility and scalability as your lab grows.
                </p>
              </li>
              <li className="flex gap-3">
                <p className="text-sm largeLaptop:text-2xl font-medium text-gray-800">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Compact Design: The
                  space-saving design fits easily into laboratories with limited
                  space, allowing you to optimize your workspace without
                  sacrificing functionality.
                </p>
              </li>
              <li className="flex gap-3">
                <p className="text-sm largeLaptop:text-2xl font-medium text-gray-800">
                  {" "}
                  <span className="text-[#10b981]">◆</span> User-Friendly
                  Operation: Intuitive controls and a simple interface make it
                  easy to operate, reducing the need for extensive training.
                </p>
              </li>
            </ul>
          </div>
        ),

        benefits: (
          <div>
            <ul className="space-y-6 font-poppins">
              <li className="flex gap-3">
                <p className="text-sm largeLaptop:text-2xl font-medium text-gray-800">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Enhanced
                  Productivity: By automating the sorting process, the SORTPRO
                  SAMPLE SORTER allows lab technicians to focus on more complex
                  tasks, boosting overall lab productivity.
                </p>
              </li>
              <li className="flex gap-3">
                <p className="text-sm largeLaptop:text-2xl font-medium text-gray-800">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Consistent and
                  Reliable Results: Automation ensures that every sample is
                  sorted correctly, providing reliability and consistency in
                  laboratory operations.
                </p>
              </li>
              <li className="flex gap-3">
                <p className="text-sm largeLaptop:text-2xl font-medium text-gray-800">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Reduced Labor Costs:
                  Automation lowers the need for manual sorting, reducing labor
                  costs and allowing staff to focus on higher-value tasks.
                </p>
              </li>
              <li className="flex gap-3">
                <p className="text-sm largeLaptop:text-2xl font-medium text-gray-800">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Scalability: As your
                  lab grows, the Sortpro Sample Sorter can scale to meet
                  increasing demands, ensuring continued efficiency and
                  productivity.
                </p>
              </li>
              <li className="flex gap-3">
                <p className="text-sm largeLaptop:text-2xl font-medium text-gray-800">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Low Maintenance: The
                  system is designed for long-term reliability with minimal
                  maintenance, reducing downtime and ensuring consistent
                  performance.
                </p>
              </li>
            </ul>
          </div>
        ),
        testMenu: [""],
        mainAndCare: (
          <div>
            <ul className="space-y-6 font-poppins">
              <li className="flex gap-3">
                <p className="text-sm largeLaptop:text-2xl font-medium text-gray-800">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Routine Calibration:
                  Regular calibration is essential to maintain accuracy and
                  efficiency over time.
                </p>
              </li>
              <li className="flex gap-3">
                <p className="text-sm largeLaptop:text-2xl font-medium text-gray-800">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Automated
                  Maintenance Alerts: The system provides notifications for
                  scheduled maintenance, ensuring that it remains in optimal
                  working condition.
                </p>
              </li>
              <li className="flex gap-3">
                <p className="text-sm largeLaptop:text-2xl font-medium text-gray-800">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Easy Access for
                  Servicing: The SORTPRO SAMPLE SORTER is designed for easy
                  access to internal components, simplifying routine maintenance
                  and repairs.
                </p>
              </li>
              <li className="flex gap-3">
                <p className="text-sm largeLaptop:text-2xl font-medium text-gray-800">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Durable
                  Construction: Built for long-term use, ensuring minimal
                  downtime and consistent performance.
                </p>
              </li>
              <li className="flex gap-3">
                <p className="text-sm largeLaptop:text-2xl font-medium text-gray-800">
                  {" "}
                  <span className="text-[#10b981]">◆</span> Comprehensive
                  Support: Supported by CPC Diagnostics’ technical team,
                  ensuring optimal performance and long-lasting reliability.
                </p>
              </li>
            </ul>
          </div>
        ),
        workServices:
          "Comprehensive support available for installation, maintenance, and troubleshooting.",
        productBrochure: "path/to/sortpro-sample-sorter-brochure.pdf",
        detailedSpecification:
          "Specifications include sorting capacity, speed, and compatibility with different sample types.",
        offerOrDiscounts:
          "Check with distributor for current promotions and pricing offers.",
      },
    ],
  },
];
export default products;
